var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
/* eslint-disable */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { clearLocalStorage } from '../components/Sidebar';
import { setSentryUser, clearSentryUser } from '../config/sentry.config';
export var getSessionToken = createAsyncThunk('auth/getSessionToken', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get('/rest/s1/fp/moquiSessionToken')];
            case 1:
                response = _a.sent();
                console.log('session token', response);
                if (response.status === 200) {
                    localStorage.setItem('moquiSessionToken', response.data.moquiSessionToken);
                    return [2 /*return*/, response.data];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                console.log('Error', e_1.response.data);
                return [2 /*return*/, thunkAPI.rejectWithValue(e_1.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var loginUser = createAsyncThunk('auth/loginUser', function (_a, thunkAPI) {
    var email = _a.email, password = _a.password, history = _a.history;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, name, customerData, e_2;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        return __generator(this, function (_w) {
            switch (_w.label) {
                case 0:
                    _w.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post('/rest/s1/fp/login', {
                            username: email,
                            password: password
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _w.sent();
                    if (response.status === 200) {
                        localStorage.setItem('moquiSessionToken', response.headers.moquisessiontoken);
                        if (!response.data.forcePasswordChange) {
                            localStorage.setItem('loggedInHH', response.headers.moquisessiontoken);
                        }
                        if (response.data.customerInfo.userId) {
                            localStorage.setItem('userId', response.data.customerInfo.userId);
                            // return response.data.customerInfo.userId
                        }
                        if (response.data.customerInfo.activeOrgId) {
                            localStorage.setItem('isOrgSelected', 'true');
                            localStorage.setItem('activeOrgId', response.data.customerInfo.activeOrgId);
                        }
                        else {
                            if (response.data.customerInfo.filterOrgIds &&
                                response.data.customerInfo.filterOrgIds.length === 1) {
                                localStorage.setItem('isOrgSelected', 'true');
                                localStorage.setItem('activeOrgId', response.data.customerInfo.filterOrgIds[0]);
                            }
                        }
                        if (response.data.customerInfo.activeStoreId) {
                            localStorage.setItem('activeStoreId', response.data.customerInfo.activeStoreId);
                        }
                        if ((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.customerInfo) === null || _c === void 0 ? void 0 : _c.emailAddress) {
                            localStorage.setItem('loggedInEmail', (_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.customerInfo) === null || _e === void 0 ? void 0 : _e.emailAddress);
                        }
                        name = (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.customerInfo) === null || _g === void 0 ? void 0 : _g.firstName;
                        if ((_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.customerInfo) === null || _j === void 0 ? void 0 : _j.lastName) {
                            name = name + ' ' + ((_l = (_k = response.data) === null || _k === void 0 ? void 0 : _k.customerInfo) === null || _l === void 0 ? void 0 : _l.lastName);
                        }
                        if (name) {
                            localStorage.setItem('loggedInUserName', name);
                        }
                        else if ((_o = (_m = response.data) === null || _m === void 0 ? void 0 : _m.customerInfo) === null || _o === void 0 ? void 0 : _o.userFullName) {
                            localStorage.setItem('loggedInUserName', (_q = (_p = response.data) === null || _p === void 0 ? void 0 : _p.customerInfo) === null || _q === void 0 ? void 0 : _q.userFullName);
                        }
                        if (response.data.customerInfo) {
                            customerData = {
                                firstName: response.data.customerInfo.firstName,
                                lastName: response.data.customerInfo.lastName,
                                email: response.data.customerInfo.emailAddress,
                                phone: response.data.customerInfo.contactNumber,
                                locale: response.data.customerInfo.locale,
                                timeZone: response.data.customerInfo.timeZone
                            };
                            localStorage.setItem('customerInfo', JSON.stringify(customerData));
                        }
                        localStorage.setItem('currScreen', 'home');
                        localStorage.setItem('isNavOpen', 'true');
                        // Set Sentry user context for error tracking
                        setSentryUser({
                            id: response.data.customerInfo.userId,
                            email: (_s = (_r = response.data) === null || _r === void 0 ? void 0 : _r.customerInfo) === null || _s === void 0 ? void 0 : _s.emailAddress,
                            username: name || ((_u = (_t = response.data) === null || _t === void 0 ? void 0 : _t.customerInfo) === null || _u === void 0 ? void 0 : _u.userFullName),
                            organizationId: response.data.customerInfo.activeOrgId,
                            facilityId: response.data.customerInfo.activeStoreId,
                        });
                        history.push('/');
                        return [2 /*return*/, (_v = response === null || response === void 0 ? void 0 : response.data) === null || _v === void 0 ? void 0 : _v.userId];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _w.sent();
                    console.log('Error', e_2.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_2.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var logout = createAsyncThunk('auth/logout', function (_a, thunkAPI) {
    var history = _a.history;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get('/rest/s1/fp/logout', {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        localStorage.clear();
                        // Clear Sentry user context on logout
                        clearSentryUser();
                        history.push('/login');
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _b.sent();
                    console.log('Error', e_3.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_3.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var facilitiesList = createAsyncThunk('auth/facilitiesList', function (_a, thunkAPI) {
    var setFacilitiesData = _a.setFacilitiesData, history = _a.history;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, activeOrgId, response, mappedArray, e_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    activeOrgId = localStorage.getItem('activeOrgId');
                    return [4 /*yield*/, axios.get('/rest/s1/fp/facility', {
                            params: {
                                organizationPartyId: activeOrgId
                            },
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        mappedArray = response.data.facilityList.map(function (item) {
                            return {
                                key: item.facilityId,
                                value: item.facilityName
                            };
                        });
                        setFacilitiesData(mappedArray);
                        return [2 /*return*/, mappedArray];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _b.sent();
                    console.log('Error', e_4.response.data);
                    if (e_4.response.data.errors.includes("Cannot get property 'partyId' on null object")) {
                        thunkAPI.dispatch(logout({ history: history }));
                    }
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_4.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getPrinterName = createAsyncThunk('auth/getPrinterName', function (_a, thunkAPI) {
    var setPrinterNameData = _a.setPrinterNameData;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, mappedArray, e_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("rest/s1/fp/facility/" + facilityId + "/podPrinters", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        mappedArray = response.data.podPrinters.map(function (item) {
                            return {
                                key: item.podId,
                                value: item.printerName,
                                host: item.serverHost,
                                port: item.serverPort,
                                secure: item.secure && item.secure === 'Y' ? true : false
                            };
                        });
                        setPrinterNameData(mappedArray);
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_5 = _b.sent();
                    console.log('Error', e_5.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_5.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//Scan cart Rest Api
export var getScannedCart = createAsyncThunk('auth/getScannedCart', function (_a, thunkAPI) {
    var scanId = _a.scanId, setScannedCartIncorrect = _a.setScannedCartIncorrect, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setCartScannedData = _a.setCartScannedData, setIsCartScanned = _a.setIsCartScanned, setErrorMsgText = _a.setErrorMsgText, subscreenName = _a.subscreenName, productIdList = _a.productIdList, functionCall = _a.functionCall, setPrinterNameData = _a.setPrinterNameData, setToteFull = _a.setToteFull, shipmentId = _a.shipmentId, setShippingTotesForShipmentData = _a.setShippingTotesForShipmentData, setFromPodLocationSeqId = _a.setFromPodLocationSeqId, shipmentIdList = _a.shipmentIdList, setShipmentIdForPickMoveProductToShippingContainer = _a.setShipmentIdForPickMoveProductToShippingContainer, setFacilitiesLocationList = _a.setFacilitiesLocationList, setCurrContainerData = _a.setCurrContainerData, setContainerIncorrect = _a.setContainerIncorrect, setCurrLocationData = _a.setCurrLocationData, setLocationIncorrect = _a.setLocationIncorrect, setProductDetailIncorrect = _a.setProductDetailIncorrect;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response_1, facilityLocationContainersList, isPodExist, setBtnDisabled, includeProductId, shipmentIdForShippingTote, e_6;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 12, , 13]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/fp/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response_1 = _d.sent();
                    if (!(response_1.status === 200)) return [3 /*break*/, 10];
                    if (!(functionCall === 'onPodScanned')) return [3 /*break*/, 2];
                    if (response_1.data.messages || response_1.data.container || response_1.data.product) {
                        setScannedCartIncorrect(true);
                        setErrorMsgText('Incorrect pod, scan again');
                        setIsCartScanned(true);
                    }
                    else {
                        if (response_1.data.facilityLocation &&
                            response_1.data.facilityLocation.locationTypeEnumId === 'FltPod') {
                            facilityLocationContainersList = localStorage.getItem('podFacilityLocationContainersList');
                            if (!facilityLocationContainersList) {
                                facilityLocationContainersList = [];
                            }
                            else {
                                facilityLocationContainersList = JSON.parse(facilityLocationContainersList);
                            }
                            isPodExist = facilityLocationContainersList.filter(function (item) { return item.locationSeqId === response_1.data.facilityLocation.locationSeqId; });
                            if (isPodExist && isPodExist.length > 0) {
                                thunkAPI.dispatch(getPrinterName({
                                    setPrinterNameData: setPrinterNameData
                                }));
                                setBtnDisabled = '';
                                thunkAPI.dispatch(getFacilityLocationContainers({
                                    locationSeqId: response_1.data.facilityLocation.locationSeqId,
                                    setBtnDisabled: setBtnDisabled,
                                    forMoveToSorting: false,
                                    setFacilitiesLocationList: setFacilitiesLocationList,
                                    functionCall: 'authSlice'
                                }));
                                localStorage.setItem('sortinglocationSeqId', response_1.data.facilityLocation.locationSeqId);
                                setCartScannedData(response_1.data.locationSeqId);
                                setCurrentActiveSubscreen(subscreenName);
                                setFromPodLocationSeqId(response_1.data.locationSeqId);
                            }
                            else {
                                setScannedCartIncorrect(true);
                                setErrorMsgText("Pod " + response_1.data.facilityLocation.locationSeqId + " is empty");
                                setIsCartScanned(true);
                            }
                        }
                        else {
                            setScannedCartIncorrect(true);
                            setErrorMsgText('Incorrect pod, scan again');
                            setIsCartScanned(true);
                        }
                    }
                    return [3 /*break*/, 9];
                case 2:
                    if (!(functionCall === 'onScanItem')) return [3 /*break*/, 8];
                    if (!(response_1.data.messages ||
                        response_1.data.container ||
                        (response_1.data.facilityLocation &&
                            response_1.data.facilityLocation.locationTypeEnumId === 'FltPod'))) return [3 /*break*/, 3];
                    setScannedCartIncorrect(true);
                    if (subscreenName === 'fromReceiving') {
                        thunkAPI.dispatch(setProductDetailIncorrect(true));
                    }
                    if (subscreenName === 'scanPrinter') {
                        setErrorMsgText('Incorrect pod, scan again');
                    }
                    else {
                        setErrorMsgText('Incorrect product, scan again');
                    }
                    setIsCartScanned(true);
                    return [3 /*break*/, 7];
                case 3:
                    if (!(subscreenName === 'fromReceiving' && !response_1.data.productId)) return [3 /*break*/, 4];
                    setScannedCartIncorrect(true);
                    setErrorMsgText('Incorrect product, scan again');
                    return [3 /*break*/, 7];
                case 4:
                    setCartScannedData(response_1.data.locationSeqId);
                    if (subscreenName === 'fromReceiving') {
                        thunkAPI.dispatch(setProductDetailIncorrect(false));
                    }
                    localStorage.setItem('productId', response_1.data.productId);
                    localStorage.removeItem('sortinglocationSeqId');
                    includeProductId = productIdList.includes((_b = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _b === void 0 ? void 0 : _b.productId);
                    if (!!includeProductId) return [3 /*break*/, 5];
                    setScannedCartIncorrect(true);
                    setErrorMsgText('Incorrect product, try again');
                    return [3 /*break*/, 7];
                case 5:
                    shipmentIdForShippingTote = shipmentIdList[(_c = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _c === void 0 ? void 0 : _c.productId][0];
                    setShipmentIdForPickMoveProductToShippingContainer(shipmentIdForShippingTote);
                    return [4 /*yield*/, thunkAPI.dispatch(getListOfShippingTotesForShipment({
                            shipmentIdForShippingTote: shipmentIdForShippingTote,
                            setShippingTotesForShipmentData: setShippingTotesForShipmentData
                        }))];
                case 6:
                    _d.sent();
                    localStorage.setItem('productId', response_1.data.productId);
                    setCurrentActiveSubscreen(subscreenName);
                    _d.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    if (functionCall === 'onContainerItem') {
                        if (response_1.data.messages) {
                            setScannedCartIncorrect(false);
                            setContainerIncorrect(true);
                            setErrorMsgText('Incorrect Container, scan again');
                            setIsCartScanned(true);
                        }
                        else {
                            setCurrContainerData(response_1.data.containerId);
                            setCartScannedData(response_1.data.locationSeqId);
                        }
                    }
                    else if (functionCall === 'onLocation') {
                        if (response_1.data.messages) {
                            setLocationIncorrect(true);
                            setErrorMsgText('Incorrect Location, scan again');
                            setIsCartScanned(true);
                        }
                        else {
                            setCurrLocationData(response_1.data.locationSeqId);
                            localStorage.setItem('scannedLocSeqId', response_1.data.locationSeqId);
                            setCartScannedData(response_1.data.locationSeqId);
                        }
                    }
                    else {
                        if (response_1.data.messages ||
                            response_1.data.container ||
                            (response_1.data.facilityLocation &&
                                response_1.data.facilityLocation.locationTypeEnumId !== 'FltCart')) {
                            setScannedCartIncorrect(true);
                            setErrorMsgText('Incorrect cart, scan again');
                            setIsCartScanned(true);
                        }
                        else {
                            setCartScannedData(response_1.data.locationSeqId);
                            localStorage.setItem('cartId', response_1.data.facilityLocation.description);
                            localStorage.setItem('cartLocationSeqId', response_1.data.facilityLocation.locationSeqId);
                            setCurrentActiveSubscreen(subscreenName);
                            localStorage.setItem('locationSeqId', response_1.data.locationSeqId);
                        }
                    }
                    _d.label = 9;
                case 9: return [2 /*return*/, response_1.data];
                case 10: return [2 /*return*/, thunkAPI.rejectWithValue(response_1)];
                case 11: return [3 /*break*/, 13];
                case 12:
                    e_6 = _d.sent();
                    console.log('Error', e_6.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_6.response.data)];
                case 13: return [2 /*return*/];
            }
        });
    });
});
export var getPickRunDetails = createAsyncThunk('auth/getPickRunDetails', function (_a, thunkAPI) {
    var setErrorMsgText = _a.setErrorMsgText, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, nearestLocationSeqId = _a.nearestLocationSeqId, fromLookup = _a.fromLookup, history = _a.history, pickRunType = _a.pickRunType, setLookUpVisible = _a.setLookUpVisible, fromPickRunsScreen = _a.fromPickRunsScreen;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, loggedInUserId, assignedToUserId, currentPickRunTypeId, pickedItemsArr_1, filteredPickRunItems_1, fetchedPickRunItems, locationData, results, bulkPickItemsData, _loop_1, key, pickRunContainerList, requiredPickContainerCount, hospitalContainers, totesList_1, redirectTo, totesList_2, e_7, errorMessage;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
        return __generator(this, function (_5) {
            switch (_5.label) {
                case 0:
                    _5.trys.push([0, 20, , 21]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "?nearestLocationSeqId=" + nearestLocationSeqId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _5.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 18];
                    // history.push({
                    //   pathname: '/bulkPick',
                    //   state: { subscreenToBeSet: 'scanCart' }
                    // })
                    // return
                    if (response.data && response.data.pickRun) {
                        if (!response.data.pickRun.pickRunItems) {
                            if (!fromLookup) {
                                setErrorMsgText('Something went wrong!');
                                setScannedLocationIncorrect(true);
                                return [2 /*return*/, response];
                            }
                        }
                        else if (response.data.pickRun.pickRunItems &&
                            response.data.pickRun.pickRunItems.length === 0) {
                            if (!fromLookup) {
                                setErrorMsgText('Something went wrong!');
                                setScannedLocationIncorrect(true);
                                return [2 /*return*/, response];
                            }
                        }
                    }
                    loggedInUserId = localStorage.getItem('userId');
                    assignedToUserId = response.data && response.data.pickRun && response.data.pickRun.assignedToUserId
                        ? response.data.pickRun.assignedToUserId
                        : '';
                    currentPickRunTypeId = '';
                    if (response.data && response.data.pickRun && response.data.pickRun.pickRunTypeId) {
                        currentPickRunTypeId = response.data.pickRun.pickRunTypeId;
                    }
                    return [4 /*yield*/, localStorage.setItem('pickRunDetailsDropzoneId', response.data.pickRun.dropzoneId)];
                case 2:
                    _5.sent();
                    if (!(response.data && response.data.pickRun && response.data.pickRun.cartId)) return [3 /*break*/, 5];
                    return [4 /*yield*/, localStorage.setItem('cartId', response.data.pickRun.cartId)];
                case 3:
                    _5.sent();
                    return [4 /*yield*/, localStorage.setItem('newCartScannedId', response.data.pickRun.cartId)];
                case 4:
                    _5.sent();
                    _5.label = 5;
                case 5: return [4 /*yield*/, localStorage.getItem('pickedItemsArr')];
                case 6:
                    pickedItemsArr_1 = _5.sent();
                    if (pickedItemsArr_1) {
                        pickedItemsArr_1 = JSON.parse(pickedItemsArr_1);
                    }
                    else {
                        pickedItemsArr_1 = [];
                    }
                    filteredPickRunItems_1 = [];
                    fetchedPickRunItems = (response === null || response === void 0 ? void 0 : response.data) &&
                        ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.pickRun) &&
                        ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.pickRun) === null || _d === void 0 ? void 0 : _d.pickRunItems) &&
                        ((_g = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.pickRun) === null || _f === void 0 ? void 0 : _f.pickRunItems) === null || _g === void 0 ? void 0 : _g.length) > 0
                        ? (_j = (_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.pickRun) === null || _j === void 0 ? void 0 : _j.pickRunItems
                        : [];
                    fetchedPickRunItems === null || fetchedPickRunItems === void 0 ? void 0 : fetchedPickRunItems.forEach(function (fetchedItem) {
                        var isProductFound = false;
                        pickedItemsArr_1 === null || pickedItemsArr_1 === void 0 ? void 0 : pickedItemsArr_1.forEach(function (pickedItem) {
                            if ((fetchedItem === null || fetchedItem === void 0 ? void 0 : fetchedItem.productId) === (pickedItem === null || pickedItem === void 0 ? void 0 : pickedItem.productId) &&
                                (fetchedItem === null || fetchedItem === void 0 ? void 0 : fetchedItem.pickRunItemId) === (pickedItem === null || pickedItem === void 0 ? void 0 : pickedItem.pickRunItemId)) {
                                isProductFound = true;
                                return;
                            }
                        });
                        if (!isProductFound && (fetchedItem === null || fetchedItem === void 0 ? void 0 : fetchedItem.pickRunItemQty) > 0) {
                            filteredPickRunItems_1.push(fetchedItem);
                        }
                    });
                    if (!(((_l = (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.pickRun) === null || _l === void 0 ? void 0 : _l.pickRunTypeId) === 'PrtBulkPick')) return [3 /*break*/, 9];
                    locationData = [];
                    results = filteredPickRunItems_1.reduce(function (acc, curr) {
                        var productId = curr.productId, locationSeqId = curr.locationSeqId;
                        var key = productId + "-" + locationSeqId;
                        if (!acc[key]) {
                            acc[key] = [];
                        }
                        acc[key].push(curr);
                        return acc;
                    }, {});
                    bulkPickItemsData = {
                        pickedItemsCount: 0,
                        totalItemsCount: 0
                    };
                    _loop_1 = function (key) {
                        var item = results[key];
                        var pickedQuantity = 0, pickRunItemQty = 0, quantity = 0;
                        var pickRunItems = [];
                        var lots = [];
                        var obj = {};
                        if (Array.isArray(item)) {
                            for (var i = 0; i < item.length; i++) {
                                var shipmentItem = item[i];
                                pickedQuantity += shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickedQuantity;
                                pickRunItemQty += shipmentItem.pickRunItemQty;
                                bulkPickItemsData['pickedItemsCount'] += (_m = shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickedQuantity) !== null && _m !== void 0 ? _m : 0;
                                bulkPickItemsData['totalItemsCount'] += (_o = shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickRunItemQty) !== null && _o !== void 0 ? _o : 0;
                                quantity += shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickRunItemQty;
                                pickRunItems.push(shipmentItem.pickRunItemId);
                                if (shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.lotId) {
                                    lots.push({
                                        lotId: shipmentItem.lotId,
                                        lotNumber: shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.lotNumber,
                                        manufacturedDate: shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.manufacturedDate,
                                        expirationDate: shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.expirationDate,
                                        pickRunItemQty: (_p = shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickRunItemQty) !== null && _p !== void 0 ? _p : 0,
                                        pickedQuantity: (_q = shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickedQuantity) !== null && _q !== void 0 ? _q : 0
                                    });
                                }
                                obj = shipmentItem;
                            }
                        }
                        // grouping lotDetails by lotID::START
                        var lotDetails = {};
                        lots.forEach(function (item) {
                            var lotId = item.lotId, lotNumber = item.lotNumber, pickRunItemQty = item.pickRunItemQty, pickedQuantity = item.pickedQuantity, manufacturedDate = item.manufacturedDate, expirationDate = item.expirationDate;
                            if (lotDetails[lotId]) {
                                lotDetails[lotId].totalPickRunItemQty += pickRunItemQty;
                                lotDetails[lotId].totalPickedQuantity += pickedQuantity;
                            }
                            else {
                                lotDetails[lotId] = {
                                    lotId: lotId,
                                    lotNumber: lotNumber,
                                    totalPickRunItemQty: pickRunItemQty,
                                    totalPickedQuantity: pickedQuantity,
                                    manufacturedDate: manufacturedDate,
                                    expirationDate: expirationDate
                                };
                            }
                        });
                        // grouping lotDetails by lotID::END
                        var newObj = Object.assign({}, obj, {
                            pickedQuantity: pickedQuantity,
                            pickRunItems: pickRunItems,
                            pickRunItemQty: pickRunItemQty,
                            quantity: quantity,
                            lotDetails: Object.values(lotDetails)
                        });
                        locationData.push(newObj);
                    };
                    for (key in results) {
                        _loop_1(key);
                    }
                    return [4 /*yield*/, localStorage.setItem('goToLocationData', JSON.stringify(locationData))];
                case 7:
                    _5.sent();
                    return [4 /*yield*/, localStorage.setItem('bulkPickItemsData', JSON.stringify(bulkPickItemsData))];
                case 8:
                    _5.sent();
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, localStorage.setItem('goToLocationData', JSON.stringify(fetchedPickRunItems))];
                case 10:
                    _5.sent();
                    _5.label = 11;
                case 11: return [4 /*yield*/, thunkAPI.dispatch(updatePickRunStatus({ statusId: 'PrInProgress' }))];
                case 12:
                    _5.sent();
                    if (!fromLookup) return [3 /*break*/, 16];
                    return [4 /*yield*/, thunkAPI.dispatch(getPickRunContainers())];
                case 13:
                    _5.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getRequiredContainerCount({ pickRunId: response.data.pickRun.pickRunId }))];
                case 14:
                    _5.sent();
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
                    if (requiredPickContainerCount) {
                        requiredPickContainerCount *= 1;
                    }
                    else {
                        requiredPickContainerCount = 0;
                    }
                    if (currentPickRunTypeId !== 'PrtSingle' && currentPickRunTypeId !== 'PrtOrderLevel') {
                        requiredPickContainerCount = 1;
                    }
                    return [4 /*yield*/, thunkAPI.dispatch(getPickRunItemContainers({ pickRunId: (_s = (_r = response === null || response === void 0 ? void 0 : response.data) === null || _r === void 0 ? void 0 : _r.pickRun) === null || _s === void 0 ? void 0 : _s.pickRunId }))];
                case 15:
                    _5.sent();
                    hospitalContainers = localStorage.getItem('hospitalContainers');
                    if (hospitalContainers) {
                        hospitalContainers = JSON.parse(hospitalContainers);
                    }
                    else {
                        hospitalContainers = [];
                    }
                    setLookUpVisible(false);
                    if (pickRunType === 'PrtSingle' ||
                        pickRunType === 'PrtBulkSingle' ||
                        pickRunType === 'PrtOrderLevel' ||
                        pickRunType === 'PrtBulkPick') {
                        if (!((_u = (_t = response === null || response === void 0 ? void 0 : response.data) === null || _t === void 0 ? void 0 : _t.pickRun) === null || _u === void 0 ? void 0 : _u.cartId)) {
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: {
                                        subscreenToBeSet: 'scanCart',
                                        currentPickRunTypeId: currentPickRunTypeId,
                                        skipScanLocationScreen: true
                                    }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: { subscreenToBeSet: 'scanCart', currentPickRunTypeId: currentPickRunTypeId }
                                });
                            }
                        }
                        else if (pickRunContainerList.length !== requiredPickContainerCount) {
                            totesList_1 = [];
                            pickRunContainerList === null || pickRunContainerList === void 0 ? void 0 : pickRunContainerList.forEach(function (tote, index) {
                                totesList_1.push({
                                    toteData: (tote === null || tote === void 0 ? void 0 : tote.serialNumber)
                                        ? tote === null || tote === void 0 ? void 0 : tote.serialNumber
                                        : (tote === null || tote === void 0 ? void 0 : tote.description)
                                            ? tote === null || tote === void 0 ? void 0 : tote.description
                                            : '',
                                    count: index + 1
                                });
                            });
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: {
                                        subscreenToBeSet: 'scanTotes',
                                        currentPickRunTypeId: currentPickRunTypeId,
                                        totesList: totesList_1,
                                        skipScanLocationScreen: true
                                    }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: { subscreenToBeSet: 'scanTotes', currentPickRunTypeId: currentPickRunTypeId, totesList: totesList_1 }
                                });
                            }
                        }
                        else if (((_w = (_v = response === null || response === void 0 ? void 0 : response.data) === null || _v === void 0 ? void 0 : _v.pickRun) === null || _w === void 0 ? void 0 : _w.statusId) === 'PrInProgress' &&
                            filteredPickRunItems_1.length <= 0) {
                            redirectTo = 'packingStationLocation';
                            if ((currentPickRunTypeId === 'PrtSingle' ||
                                currentPickRunTypeId === 'PrtOrderLevel') &&
                                hospitalContainers.length > 0) {
                                redirectTo = 'hospitalLocation';
                            }
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: {
                                        subscreenToBeSet: redirectTo,
                                        currentPickRunTypeId: currentPickRunTypeId,
                                        skipScanLocationScreen: true
                                    }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: { subscreenToBeSet: redirectTo, currentPickRunTypeId: currentPickRunTypeId }
                                });
                            }
                        }
                        else {
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: {
                                        subscreenToBeSet: 'scanLocation',
                                        currentPickRunTypeId: currentPickRunTypeId,
                                        skipScanLocationScreen: true
                                    }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickSingle',
                                    state: { subscreenToBeSet: 'scanLocation', currentPickRunTypeId: currentPickRunTypeId }
                                });
                            }
                        }
                    }
                    else {
                        if (!((_y = (_x = response === null || response === void 0 ? void 0 : response.data) === null || _x === void 0 ? void 0 : _x.pickRun) === null || _y === void 0 ? void 0 : _y.cartId)) {
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanCart', skipScanLocationScreen: true }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanCart' }
                                });
                            }
                        }
                        else if (pickRunContainerList.length !== requiredPickContainerCount) {
                            totesList_2 = [];
                            pickRunContainerList === null || pickRunContainerList === void 0 ? void 0 : pickRunContainerList.forEach(function (tote, index) {
                                totesList_2.push({
                                    toteData: (tote === null || tote === void 0 ? void 0 : tote.serialNumber)
                                        ? tote === null || tote === void 0 ? void 0 : tote.serialNumber
                                        : (tote === null || tote === void 0 ? void 0 : tote.description)
                                            ? tote === null || tote === void 0 ? void 0 : tote.description
                                            : '',
                                    count: index + 1
                                });
                            });
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanTotes', totesList: totesList_2, skipScanLocationScreen: true }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanTotes', totesList: totesList_2 }
                                });
                            }
                        }
                        else if (((_0 = (_z = response === null || response === void 0 ? void 0 : response.data) === null || _z === void 0 ? void 0 : _z.pickRun) === null || _0 === void 0 ? void 0 : _0.statusId) === 'PrInProgress' &&
                            filteredPickRunItems_1.length <= 0) {
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanDropzoneLocation', skipScanLocationScreen: true }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanDropzoneLocation' }
                                });
                            }
                        }
                        else {
                            if (fromPickRunsScreen) {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanLocation', skipScanLocationScreen: true }
                                });
                            }
                            else {
                                history.push({
                                    pathname: '/pickMultis',
                                    state: { subscreenToBeSet: 'scanLocation' }
                                });
                            }
                        }
                    }
                    return [3 /*break*/, 17];
                case 16:
                    setCurrentActiveSubscreen(subscreenName);
                    _5.label = 17;
                case 17: return [2 /*return*/, response];
                case 18: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 19: return [3 /*break*/, 21];
                case 20:
                    e_7 = _5.sent();
                    console.log('Error', (_1 = e_7.response) === null || _1 === void 0 ? void 0 : _1.data);
                    errorMessage = ((_3 = (_2 = e_7.response) === null || _2 === void 0 ? void 0 : _2.data) === null || _3 === void 0 ? void 0 : _3.errors) || 'Something went wrong!';
                    setErrorMsgText(errorMessage);
                    setScannedLocationIncorrect(true);
                    return [2 /*return*/, thunkAPI.rejectWithValue((_4 = e_7.response) === null || _4 === void 0 ? void 0 : _4.data)];
                case 21: return [2 /*return*/];
            }
        });
    });
});
export var checkPickRunAvailability = createAsyncThunk('auth/checkPickRunAvailability', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + localStorage.getItem('facilityId') + "/checkPickRunAvailability", {
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    if (response.data.isSinglePickingRunAvailable) {
                        thunkAPI.dispatch(setSinglePickBtnDisabled(false));
                    }
                    else {
                        thunkAPI.dispatch(setSinglePickBtnDisabled(true));
                    }
                    if (response.data.isMultiPickingRunAvailable) {
                        thunkAPI.dispatch(setMultiPickBtnDisabled(false));
                    }
                    else {
                        thunkAPI.dispatch(setMultiPickBtnDisabled(true));
                    }
                    return [2 /*return*/, response];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_8 = _a.sent();
                console.log('Error', e_8.response.data);
                return [2 /*return*/, thunkAPI.rejectWithValue(e_8.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var getActiveFacility = createAsyncThunk('auth/getActiveFacility', function (_a, thunkAPI) {
    var setFacility = _a.setFacility;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_9;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get('/rest/s1/handheld/user/activeFacility', {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        if (response.data.facilityId) {
                            setFacility(response.data.facilityId);
                            localStorage.setItem('facilityId', response.data.facilityId);
                            // thunkAPI.dispatch(checkPickRunAvailability())
                        }
                        return [2 /*return*/, (_b = response.data) === null || _b === void 0 ? void 0 : _b.facilityId];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_9 = _c.sent();
                    console.log('Error', e_9.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_9.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var setActiveFacility = createAsyncThunk('auth/setActiveFacility', function (_a, thunkAPI) {
    var facilityId = _a.facilityId, setFacility = _a.setFacility;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_10;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/user/activeFacility/" + facilityId, { facilityId: facilityId }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        setFacility(facilityId);
                        localStorage.setItem('facilityId', facilityId);
                        // thunkAPI.dispatch(checkPickRunAvailability())
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_10 = _b.sent();
                    console.log('Error', e_10.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_10.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getShippingLPDetails = createAsyncThunk('auth/getShippingLPDetails', function (_a, thunkAPI) {
    var scanToteId = _a.scanToteId, setScannedToteIncorrect = _a.setScannedToteIncorrect, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setIsToteScanned = _a.setIsToteScanned, setErrorMsgText = _a.setErrorMsgText, subscreenName = _a.subscreenName, data = _a.data, containerIdFromShippingContainers = _a.containerIdFromShippingContainers, setShippingContainerId = _a.setShippingContainerId, setShipmentCompletionStatusData = _a.setShipmentCompletionStatusData, toteFull = _a.toteFull, newShipmentFound = _a.newShipmentFound, shouldSkipPrinter = _a.shouldSkipPrinter, connectWithPrinter = _a.connectWithPrinter;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, shipmentId, productToShippingContainer, productToShippingContainerMsg, shipmentId, productToShippingContainer, productToShippingContainerMsg, e_11;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    _p.trys.push([0, 18, , 19]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanToteId, {
                            params: {
                                isLP: true
                            },
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _p.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 16];
                    if (!(response.data.messages || !response.data.container)) return [3 /*break*/, 2];
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect shipping LP, scan again');
                    setIsToteScanned(true);
                    return [3 /*break*/, 15];
                case 2:
                    if (!((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.container) === null || _c === void 0 ? void 0 : _c.serialNumber)) return [3 /*break*/, 15];
                    if (!(((_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.container) === null || _e === void 0 ? void 0 : _e.containerTypeEnumId) === 'CtShippingContainer')) return [3 /*break*/, 14];
                    if (!(((_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.container) === null || _g === void 0 ? void 0 : _g.containerTypeEnumId) === 'CtShippingContainer' &&
                        ((_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.container) === null || _j === void 0 ? void 0 : _j.containerId) === containerIdFromShippingContainers)) return [3 /*break*/, 7];
                    Object.assign(data, { shippingContainerId: response.data.container.containerId });
                    return [4 /*yield*/, thunkAPI.dispatch(setProductToShippingContainer({
                            data: data
                        }))];
                case 3:
                    _p.sent();
                    shipmentId = data.shipmentId;
                    localStorage.setItem('shipmentId', shipmentId);
                    productToShippingContainer = localStorage.getItem('productToShippingContainer');
                    productToShippingContainerMsg = localStorage.getItem('productToShippingContainerMsg');
                    if (!(productToShippingContainer === 'false')) return [3 /*break*/, 4];
                    setScannedToteIncorrect(true);
                    setErrorMsgText(productToShippingContainerMsg);
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, thunkAPI.dispatch(getShipmentCompletionStatus({
                        shipmentId: shipmentId,
                        setShipmentCompletionStatusData: setShipmentCompletionStatusData,
                        shouldSkipPrinter: shouldSkipPrinter,
                        connectWithPrinter: connectWithPrinter
                    }))];
                case 5:
                    _p.sent();
                    setCurrentActiveSubscreen(subscreenName);
                    _p.label = 6;
                case 6: return [3 /*break*/, 13];
                case 7:
                    if (!((((_l = (_k = response.data) === null || _k === void 0 ? void 0 : _k.container) === null || _l === void 0 ? void 0 : _l.containerTypeEnumId) === 'CtShippingContainer' &&
                        !containerIdFromShippingContainers) ||
                        toteFull ||
                        newShipmentFound ||
                        ((_o = (_m = response.data) === null || _m === void 0 ? void 0 : _m.container) === null || _o === void 0 ? void 0 : _o.containerId) !== containerIdFromShippingContainers)) return [3 /*break*/, 12];
                    Object.assign(data, { shippingContainerId: response.data.container.containerId });
                    return [4 /*yield*/, thunkAPI.dispatch(setProductToShippingContainer({
                            data: data
                        }))];
                case 8:
                    _p.sent();
                    shipmentId = data.shipmentId;
                    localStorage.setItem('shipmentId', shipmentId);
                    productToShippingContainer = localStorage.getItem('productToShippingContainer');
                    productToShippingContainerMsg = localStorage.getItem('productToShippingContainerMsg');
                    if (!(productToShippingContainer === 'false')) return [3 /*break*/, 9];
                    setScannedToteIncorrect(true);
                    setErrorMsgText(productToShippingContainerMsg);
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, thunkAPI.dispatch(getShipmentCompletionStatus({
                        shipmentId: shipmentId,
                        setShipmentCompletionStatusData: setShipmentCompletionStatusData,
                        shouldSkipPrinter: shouldSkipPrinter,
                        connectWithPrinter: connectWithPrinter
                    }))];
                case 10:
                    _p.sent();
                    setCurrentActiveSubscreen(subscreenName);
                    _p.label = 11;
                case 11: return [3 /*break*/, 13];
                case 12:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect shipping LP, scan again');
                    return [2 /*return*/];
                case 13: return [3 /*break*/, 15];
                case 14:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect shipping LP, scan again');
                    _p.label = 15;
                case 15: return [2 /*return*/, response.data];
                case 16: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 17: return [3 /*break*/, 19];
                case 18:
                    e_11 = _p.sent();
                    console.log('Error', e_11.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_11.response.data)];
                case 19: return [2 /*return*/];
            }
        });
    });
});
//30) API to Get Shipment Completion Status:
export var getShipmentCompletionStatus = createAsyncThunk('auth/getShipmentCompletionStatus', function (_a, thunkAPI) {
    var setShipmentCompletionStatusData = _a.setShipmentCompletionStatusData, shipmentId = _a.shipmentId, shouldSkipPrinter = _a.shouldSkipPrinter, connectWithPrinter = _a.connectWithPrinter;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_12;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/shipment/" + shipmentId + "/isCompleted", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        if (response.data.isCompleted) {
                            if (!shouldSkipPrinter) {
                                connectWithPrinter();
                            }
                        }
                        setShipmentCompletionStatusData(response.data.isCompleted);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_12 = _b.sent();
                    console.log('Error', e_12.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_12.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// 34) API to Get the list of shipping Totes for a shipment:
export var getListOfShippingTotesForShipment = createAsyncThunk('auth/getListOfShippingTotesForShipment', function (_a, thunkAPI) {
    var setShippingTotesForShipmentData = _a.setShippingTotesForShipmentData, shipmentIdForShippingTote = _a.shipmentIdForShippingTote;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_13;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("rest/s1/handheld/facility/shipment/" + shipmentIdForShippingTote + "/shippingContainers", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        setShippingTotesForShipmentData(response.data.shipmentContainers);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_13 = _b.sent();
                    console.log('Error', e_13.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_13.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getScannedTote = createAsyncThunk('auth/getScannedTote', function (_a, thunkAPI) {
    var scanToteId = _a.scanToteId, setScannedToteIncorrect = _a.setScannedToteIncorrect, totesList = _a.totesList, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setTotesList = _a.setTotesList, setIsToteScanned = _a.setIsToteScanned, setErrorMsgText = _a.setErrorMsgText, setCheckedContainers = _a.setCheckedContainers, isFromFinalStep = _a.isFromFinalStep, fromMoveToSortingScreen = _a.fromMoveToSortingScreen, subscreenName = _a.subscreenName, setProductIdList = _a.setProductIdList, setContainerId = _a.setContainerId, setShipmentId = _a.setShipmentId, setShipmentIdList = _a.setShipmentIdList, facilitiesLocationList = _a.facilitiesLocationList;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_1, token, facilityId, response_2, requiredPickContainerCount, containerIdToMatch_1, containers, filteredContainerId_1, setContainersCount_1, isExist_1, isPickMoved, containerIdToMatch_2, parsedPodDetailsArray, currIndexInPodDetailsList, scannedPodItemsList_1, scannedContainerIds, currPodName, filteredItem, isToteValid, count1_1, count2_1, picklistContainerCounts, requiredPickContainerCount_1, currentWorkEffortId, workEffortIdsList_1, containerDesc, pickRunContainerList, containerDesc_1, isExistInPickRunContainerList, isExistInWorkEffortIdsList_1, pickRunContainerList, containerDesc_2, isExistInPickRunContainerList, workEffortIdsList_2, pickRunContainerList, containerDesc_3, isExistInPickRunContainerList, containerDesc_4, containerDesc_5, isExistInWorkEffortIdsList_2, isExistInPickRunContainerList, containerDesc_6, isExistInWorkEffortIdsList_3, isExistInPickRunContainerList, containerIdIncludes, statusCode, containerIdStr_1, e_14;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104;
        return __generator(this, function (_105) {
            switch (_105.label) {
                case 0:
                    _105.trys.push([0, 50, , 51]);
                    originalSetErrorMsgText_1 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        originalSetErrorMsgText_1 === null || originalSetErrorMsgText_1 === void 0 ? void 0 : originalSetErrorMsgText_1(msg);
                    };
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanToteId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response_2 = _105.sent();
                    if (!(response_2.status === 200)) return [3 /*break*/, 48];
                    if (!(response_2.data.messages || !response_2.data.container)) return [3 /*break*/, 2];
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    setIsToteScanned(true);
                    return [3 /*break*/, 47];
                case 2:
                    if (!((_c = (_b = response_2.data) === null || _b === void 0 ? void 0 : _b.container) === null || _c === void 0 ? void 0 : _c.serialNumber)) return [3 /*break*/, 47];
                    if (((_e = (_d = response_2.data) === null || _d === void 0 ? void 0 : _d.container) === null || _e === void 0 ? void 0 : _e.containerTypeEnumId) !== 'CtPickContainer') {
                        setScannedToteIncorrect(true);
                        setErrorMsgText('Incorrect tote, scan again');
                        setContainerId(response_2.container.containerId);
                        return [2 /*return*/];
                    }
                    requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
                    requiredPickContainerCount *= 1;
                    if (!isFromFinalStep) return [3 /*break*/, 10];
                    if (!(subscreenName === 'takeToDropzone')) return [3 /*break*/, 3];
                    containerIdToMatch_1 = response_2.data && response_2.data.container && response_2.data.container.containerId
                        ? response_2.data.container.containerId
                        : '';
                    containers = localStorage.getItem('pickRunContainerList');
                    containers = JSON.parse(containers);
                    filteredContainerId_1 = containers.filter(function (item) { return item.containerId === containerIdToMatch_1; });
                    if (filteredContainerId_1.length === 0) {
                        setScannedToteIncorrect(true);
                        setErrorMsgText('Incorrect tote, scan again');
                    }
                    else {
                        filteredContainerId_1 =
                            filteredContainerId_1.length > 0 ? filteredContainerId_1[0]['containerId'] : '';
                        setContainersCount_1 = 0;
                        isExist_1 = false;
                        setCheckedContainers(function (prev) {
                            prev.forEach(function (item) {
                                if (item === filteredContainerId_1) {
                                    isExist_1 = true;
                                }
                            });
                            if (!isExist_1) {
                                setContainersCount_1 = prev.length + 1;
                                return __spreadArray(__spreadArray([], prev, true), [filteredContainerId_1], false);
                            }
                            else {
                                setScannedToteIncorrect(true);
                                setErrorMsgText('Tote already scanned, scan another');
                                setContainersCount_1 = prev.length;
                                return prev;
                            }
                        });
                        if (setContainersCount_1 === containers.length) {
                            setCurrentActiveSubscreen(subscreenName);
                        }
                    }
                    return [3 /*break*/, 9];
                case 3:
                    isPickMoved = true;
                    if (!isPickMoved) return [3 /*break*/, 9];
                    containerIdToMatch_2 = response_2.data && response_2.data.container && response_2.data.container.containerId
                        ? response_2.data.container.containerId
                        : '';
                    parsedPodDetailsArray = localStorage.getItem('podsDetailsArray');
                    parsedPodDetailsArray = JSON.parse(parsedPodDetailsArray);
                    currIndexInPodDetailsList = localStorage.getItem('currIndexInPodDetailsList');
                    if (!currIndexInPodDetailsList) {
                        currIndexInPodDetailsList = 0;
                    }
                    else {
                        currIndexInPodDetailsList *= 1;
                    }
                    scannedPodItemsList_1 = localStorage.getItem('scannedPodItemsList');
                    if (!scannedPodItemsList_1) {
                        scannedPodItemsList_1 = {};
                    }
                    else {
                        scannedPodItemsList_1 = JSON.parse(scannedPodItemsList_1);
                    }
                    scannedContainerIds = localStorage.getItem('scannedContainerIds');
                    if (!scannedContainerIds) {
                        scannedContainerIds = [];
                    }
                    else {
                        scannedContainerIds = JSON.parse(scannedContainerIds);
                    }
                    currPodName = parsedPodDetailsArray[currIndexInPodDetailsList]['podName'];
                    filteredItem = '';
                    if (Object.keys(scannedPodItemsList_1).length > 0 &&
                        scannedPodItemsList_1[currPodName]) {
                        filteredItem = scannedPodItemsList_1[currPodName].filter(function (item) { return item.toLowerCase() === scanToteId.toLowerCase(); });
                    }
                    isToteValid = parsedPodDetailsArray[currIndexInPodDetailsList] &&
                        parsedPodDetailsArray[currIndexInPodDetailsList]['totes'] &&
                        // eslint-disable-next-line
                        parsedPodDetailsArray[currIndexInPodDetailsList]['totes'].filter(function (tote) {
                            if (tote.containerId === containerIdToMatch_2) {
                                return tote.description;
                            }
                        });
                    if (!(filteredItem && filteredItem.length > 0)) return [3 /*break*/, 4];
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    return [3 /*break*/, 9];
                case 4:
                    if (!(isToteValid && isToteValid.length > 0)) return [3 /*break*/, 8];
                    if (!scannedContainerIds.includes((_g = (_f = response_2.data) === null || _f === void 0 ? void 0 : _f.container) === null || _g === void 0 ? void 0 : _g.containerId)) return [3 /*break*/, 5];
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, thunkAPI.dispatch(pickMovePickContainer({
                        containerId: (_j = (_h = response_2.data) === null || _h === void 0 ? void 0 : _h.container) === null || _j === void 0 ? void 0 : _j.containerId,
                        fromCart: false,
                        fromPod: true,
                        isPickMoved: isPickMoved,
                        subscreenName: 'moveToSortingFinalScreen'
                    }))];
                case 6:
                    _105.sent();
                    if (scannedPodItemsList_1[currPodName]) {
                        scannedPodItemsList_1[currPodName].push((_l = (_k = response_2.data) === null || _k === void 0 ? void 0 : _k.container) === null || _l === void 0 ? void 0 : _l.containerId);
                        scannedContainerIds.push((_o = (_m = response_2.data) === null || _m === void 0 ? void 0 : _m.container) === null || _o === void 0 ? void 0 : _o.containerId);
                    }
                    else {
                        scannedPodItemsList_1[currPodName] = [];
                        scannedPodItemsList_1[currPodName].push((_q = (_p = response_2.data) === null || _p === void 0 ? void 0 : _p.container) === null || _q === void 0 ? void 0 : _q.containerId);
                        scannedContainerIds.push((_s = (_r = response_2.data) === null || _r === void 0 ? void 0 : _r.container) === null || _s === void 0 ? void 0 : _s.containerId);
                    }
                    count1_1 = 0;
                    count2_1 = 0;
                    // eslint-disable-next-line
                    Object.keys(scannedPodItemsList_1).map(function (item) {
                        count1_1 += scannedPodItemsList_1[item].length;
                    });
                    // eslint-disable-next-line
                    parsedPodDetailsArray.map(function (item) {
                        count2_1 += item.totes.length;
                    });
                    if (count1_1 === count2_1) {
                        localStorage.setItem('scannedContainerIds', JSON.stringify(scannedContainerIds));
                        setCurrentActiveSubscreen(subscreenName);
                    }
                    else if (scannedPodItemsList_1[currPodName].length ===
                        parsedPodDetailsArray[currIndexInPodDetailsList]['totes'].length) {
                        currIndexInPodDetailsList++;
                        localStorage.setItem('currIndexInPodDetailsList', currIndexInPodDetailsList);
                        localStorage.setItem('scannedPodItemsList', JSON.stringify(scannedPodItemsList_1));
                        localStorage.setItem('scannedContainerIds', JSON.stringify(scannedContainerIds));
                        setCurrentActiveSubscreen('scanSortingPodLocation');
                    }
                    else {
                        localStorage.setItem('scannedPodItemsList', JSON.stringify(scannedPodItemsList_1));
                        localStorage.setItem('scannedContainerIds', JSON.stringify(scannedContainerIds));
                    }
                    _105.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 9;
                case 9: return [3 /*break*/, 47];
                case 10:
                    if (!(subscreenName === 'scanDropzoneLocation')) return [3 /*break*/, 38];
                    if (!(response_2.data.container &&
                        response_2.data.container.containerTypeEnumId === 'CtPickContainer')) return [3 /*break*/, 37];
                    picklistContainerCounts = localStorage.getItem('picklistContainerCounts');
                    if (picklistContainerCounts) {
                        picklistContainerCounts = JSON.parse(picklistContainerCounts);
                    }
                    else {
                        picklistContainerCounts = {};
                    }
                    requiredPickContainerCount_1 = localStorage.getItem('requiredPickContainerCount');
                    currentWorkEffortId = localStorage.getItem('currentWorkEffortId');
                    if (!(Object.keys(picklistContainerCounts).length === requiredPickContainerCount_1)) return [3 /*break*/, 22];
                    workEffortIdsList_1 = localStorage.getItem('workEffortIdsList');
                    if (workEffortIdsList_1) {
                        workEffortIdsList_1 = JSON.parse(workEffortIdsList_1);
                    }
                    else {
                        workEffortIdsList_1 = {};
                    }
                    if (!(Object.keys(workEffortIdsList_1).length > 0)) return [3 /*break*/, 18];
                    if (!(Object.keys(workEffortIdsList_1).indexOf(currentWorkEffortId) > -1)) return [3 /*break*/, 14];
                    containerDesc = ((_u = (_t = response_2.data) === null || _t === void 0 ? void 0 : _t.container) === null || _u === void 0 ? void 0 : _u.serialNumber)
                        ? (_w = (_v = response_2.data) === null || _v === void 0 ? void 0 : _v.container) === null || _w === void 0 ? void 0 : _w.serialNumber
                        : (_y = (_x = response_2.data) === null || _x === void 0 ? void 0 : _x.container) === null || _y === void 0 ? void 0 : _y.description;
                    if (!(containerDesc === workEffortIdsList_1[currentWorkEffortId])) return [3 /*break*/, 12];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_0 = (_z = response_2.data) === null || _z === void 0 ? void 0 : _z.container) === null || _0 === void 0 ? void 0 : _0.containerId,
                            containerDescription: ((_2 = (_1 = response_2.data) === null || _1 === void 0 ? void 0 : _1.container) === null || _2 === void 0 ? void 0 : _2.serialNumber)
                                ? (_4 = (_3 = response_2.data) === null || _3 === void 0 ? void 0 : _3.container) === null || _4 === void 0 ? void 0 : _4.serialNumber
                                : ((_6 = (_5 = response_2.data) === null || _5 === void 0 ? void 0 : _5.container) === null || _6 === void 0 ? void 0 : _6.description)
                                    ? (_8 = (_7 = response_2.data) === null || _7 === void 0 ? void 0 : _7.container) === null || _8 === void 0 ? void 0 : _8.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 11:
                    _105.sent();
                    return [3 /*break*/, 13];
                case 12:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 13;
                case 13: return [3 /*break*/, 17];
                case 14:
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    containerDesc_1 = ((_10 = (_9 = response_2.data) === null || _9 === void 0 ? void 0 : _9.container) === null || _10 === void 0 ? void 0 : _10.serialNumber)
                        ? (_12 = (_11 = response_2.data) === null || _11 === void 0 ? void 0 : _11.container) === null || _12 === void 0 ? void 0 : _12.serialNumber
                        : (_14 = (_13 = response_2.data) === null || _13 === void 0 ? void 0 : _13.container) === null || _14 === void 0 ? void 0 : _14.description;
                    isExistInPickRunContainerList = pickRunContainerList.filter(function (item) { return item.serialNumber.toLowerCase() === containerDesc_1.toLowerCase(); });
                    isExistInWorkEffortIdsList_1 = false;
                    Object.keys(workEffortIdsList_1).forEach(function (key) {
                        if (workEffortIdsList_1[key] === containerDesc_1) {
                            isExistInWorkEffortIdsList_1 = true;
                        }
                    });
                    if (!(!isExistInWorkEffortIdsList_1 &&
                        isExistInPickRunContainerList &&
                        isExistInPickRunContainerList.length > 0)) return [3 /*break*/, 16];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_16 = (_15 = response_2.data) === null || _15 === void 0 ? void 0 : _15.container) === null || _16 === void 0 ? void 0 : _16.containerId,
                            containerDescription: ((_18 = (_17 = response_2.data) === null || _17 === void 0 ? void 0 : _17.container) === null || _18 === void 0 ? void 0 : _18.serialNumber)
                                ? (_20 = (_19 = response_2.data) === null || _19 === void 0 ? void 0 : _19.container) === null || _20 === void 0 ? void 0 : _20.serialNumber
                                : ((_22 = (_21 = response_2.data) === null || _21 === void 0 ? void 0 : _21.container) === null || _22 === void 0 ? void 0 : _22.description)
                                    ? (_24 = (_23 = response_2.data) === null || _23 === void 0 ? void 0 : _23.container) === null || _24 === void 0 ? void 0 : _24.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 15:
                    _105.sent();
                    return [3 /*break*/, 17];
                case 16:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 17;
                case 17: return [3 /*break*/, 21];
                case 18:
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    containerDesc_2 = ((_26 = (_25 = response_2.data) === null || _25 === void 0 ? void 0 : _25.container) === null || _26 === void 0 ? void 0 : _26.serialNumber)
                        ? (_28 = (_27 = response_2.data) === null || _27 === void 0 ? void 0 : _27.container) === null || _28 === void 0 ? void 0 : _28.serialNumber
                        : (_30 = (_29 = response_2.data) === null || _29 === void 0 ? void 0 : _29.container) === null || _30 === void 0 ? void 0 : _30.description;
                    isExistInPickRunContainerList = pickRunContainerList.filter(function (item) { return item.serialNumber.toLowerCase() === containerDesc_2.toLowerCase(); });
                    if (!(isExistInPickRunContainerList && isExistInPickRunContainerList.length > 0)) return [3 /*break*/, 20];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_32 = (_31 = response_2.data) === null || _31 === void 0 ? void 0 : _31.container) === null || _32 === void 0 ? void 0 : _32.containerId,
                            containerDescription: ((_34 = (_33 = response_2.data) === null || _33 === void 0 ? void 0 : _33.container) === null || _34 === void 0 ? void 0 : _34.serialNumber)
                                ? (_36 = (_35 = response_2.data) === null || _35 === void 0 ? void 0 : _35.container) === null || _36 === void 0 ? void 0 : _36.serialNumber
                                : ((_38 = (_37 = response_2.data) === null || _37 === void 0 ? void 0 : _37.container) === null || _38 === void 0 ? void 0 : _38.description)
                                    ? (_40 = (_39 = response_2.data) === null || _39 === void 0 ? void 0 : _39.container) === null || _40 === void 0 ? void 0 : _40.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 19:
                    _105.sent();
                    return [3 /*break*/, 21];
                case 20:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 21;
                case 21: return [3 /*break*/, 37];
                case 22:
                    workEffortIdsList_2 = localStorage.getItem('workEffortIdsList');
                    if (workEffortIdsList_2) {
                        workEffortIdsList_2 = JSON.parse(workEffortIdsList_2);
                    }
                    else {
                        workEffortIdsList_2 = {};
                    }
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    containerDesc_3 = ((_42 = (_41 = response_2.data) === null || _41 === void 0 ? void 0 : _41.container) === null || _42 === void 0 ? void 0 : _42.serialNumber)
                        ? (_44 = (_43 = response_2.data) === null || _43 === void 0 ? void 0 : _43.container) === null || _44 === void 0 ? void 0 : _44.serialNumber
                        : (_46 = (_45 = response_2.data) === null || _45 === void 0 ? void 0 : _45.container) === null || _46 === void 0 ? void 0 : _46.description;
                    if (!(Object.keys(workEffortIdsList_2).length === 0)) return [3 /*break*/, 26];
                    isExistInPickRunContainerList = pickRunContainerList.filter(function (item) { return item.serialNumber.toLowerCase() === containerDesc_3.toLowerCase(); });
                    if (!(isExistInPickRunContainerList && isExistInPickRunContainerList.length > 0)) return [3 /*break*/, 24];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_48 = (_47 = response_2.data) === null || _47 === void 0 ? void 0 : _47.container) === null || _48 === void 0 ? void 0 : _48.containerId,
                            containerDescription: ((_50 = (_49 = response_2.data) === null || _49 === void 0 ? void 0 : _49.container) === null || _50 === void 0 ? void 0 : _50.serialNumber)
                                ? (_52 = (_51 = response_2.data) === null || _51 === void 0 ? void 0 : _51.container) === null || _52 === void 0 ? void 0 : _52.serialNumber
                                : ((_54 = (_53 = response_2.data) === null || _53 === void 0 ? void 0 : _53.container) === null || _54 === void 0 ? void 0 : _54.description)
                                    ? (_56 = (_55 = response_2.data) === null || _55 === void 0 ? void 0 : _55.container) === null || _56 === void 0 ? void 0 : _56.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 23:
                    _105.sent();
                    return [3 /*break*/, 25];
                case 24:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 25;
                case 25: return [3 /*break*/, 37];
                case 26:
                    if (!(Object.keys(workEffortIdsList_2).indexOf(currentWorkEffortId) > -1)) return [3 /*break*/, 34];
                    if (!(workEffortIdsList_2[currentWorkEffortId].length ===
                        picklistContainerCounts[currentWorkEffortId])) return [3 /*break*/, 30];
                    containerDesc_4 = ((_58 = (_57 = response_2.data) === null || _57 === void 0 ? void 0 : _57.container) === null || _58 === void 0 ? void 0 : _58.serialNumber)
                        ? (_60 = (_59 = response_2.data) === null || _59 === void 0 ? void 0 : _59.container) === null || _60 === void 0 ? void 0 : _60.serialNumber
                        : (_62 = (_61 = response_2.data) === null || _61 === void 0 ? void 0 : _61.container) === null || _62 === void 0 ? void 0 : _62.description;
                    if (!(workEffortIdsList_2[currentWorkEffortId].indexOf(containerDesc_4) > -1)) return [3 /*break*/, 28];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_64 = (_63 = response_2.data) === null || _63 === void 0 ? void 0 : _63.container) === null || _64 === void 0 ? void 0 : _64.containerId,
                            containerDescription: ((_66 = (_65 = response_2.data) === null || _65 === void 0 ? void 0 : _65.container) === null || _66 === void 0 ? void 0 : _66.serialNumber)
                                ? (_68 = (_67 = response_2.data) === null || _67 === void 0 ? void 0 : _67.container) === null || _68 === void 0 ? void 0 : _68.serialNumber
                                : ((_70 = (_69 = response_2.data) === null || _69 === void 0 ? void 0 : _69.container) === null || _70 === void 0 ? void 0 : _70.description)
                                    ? (_72 = (_71 = response_2.data) === null || _71 === void 0 ? void 0 : _71.container) === null || _72 === void 0 ? void 0 : _72.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 27:
                    _105.sent();
                    return [3 /*break*/, 29];
                case 28:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 29;
                case 29: return [3 /*break*/, 33];
                case 30:
                    containerDesc_5 = ((_74 = (_73 = response_2.data) === null || _73 === void 0 ? void 0 : _73.container) === null || _74 === void 0 ? void 0 : _74.serialNumber)
                        ? (_76 = (_75 = response_2.data) === null || _75 === void 0 ? void 0 : _75.container) === null || _76 === void 0 ? void 0 : _76.serialNumber
                        : (_78 = (_77 = response_2.data) === null || _77 === void 0 ? void 0 : _77.container) === null || _78 === void 0 ? void 0 : _78.description;
                    isExistInWorkEffortIdsList_2 = false;
                    // eslint-disable-next-line
                    Object.keys(workEffortIdsList_2).some(function (key) {
                        if (workEffortIdsList_2[key].includes(containerDesc_5)) {
                            isExistInWorkEffortIdsList_2 = true;
                        }
                    });
                    isExistInPickRunContainerList = pickRunContainerList.filter(function (item) {
                        return item.serialNumber.toLowerCase() === containerDesc_5.toLowerCase();
                    });
                    if (!(workEffortIdsList_2[currentWorkEffortId].indexOf(containerDesc_5) > -1 ||
                        (!isExistInWorkEffortIdsList_2 &&
                            isExistInPickRunContainerList &&
                            isExistInPickRunContainerList.length > 0))) return [3 /*break*/, 32];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_80 = (_79 = response_2.data) === null || _79 === void 0 ? void 0 : _79.container) === null || _80 === void 0 ? void 0 : _80.containerId,
                            containerDescription: ((_82 = (_81 = response_2.data) === null || _81 === void 0 ? void 0 : _81.container) === null || _82 === void 0 ? void 0 : _82.serialNumber)
                                ? (_84 = (_83 = response_2.data) === null || _83 === void 0 ? void 0 : _83.container) === null || _84 === void 0 ? void 0 : _84.serialNumber
                                : ((_86 = (_85 = response_2.data) === null || _85 === void 0 ? void 0 : _85.container) === null || _86 === void 0 ? void 0 : _86.description)
                                    ? (_88 = (_87 = response_2.data) === null || _87 === void 0 ? void 0 : _87.container) === null || _88 === void 0 ? void 0 : _88.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 31:
                    _105.sent();
                    return [3 /*break*/, 33];
                case 32:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 33;
                case 33: return [3 /*break*/, 37];
                case 34:
                    containerDesc_6 = ((_90 = (_89 = response_2.data) === null || _89 === void 0 ? void 0 : _89.container) === null || _90 === void 0 ? void 0 : _90.serialNumber)
                        ? (_92 = (_91 = response_2.data) === null || _91 === void 0 ? void 0 : _91.container) === null || _92 === void 0 ? void 0 : _92.serialNumber
                        : (_94 = (_93 = response_2.data) === null || _93 === void 0 ? void 0 : _93.container) === null || _94 === void 0 ? void 0 : _94.description;
                    isExistInWorkEffortIdsList_3 = false;
                    // eslint-disable-next-line
                    Object.keys(workEffortIdsList_2).some(function (key) {
                        if (workEffortIdsList_2[key].includes(containerDesc_6)) {
                            isExistInWorkEffortIdsList_3 = true;
                        }
                    });
                    isExistInPickRunContainerList = pickRunContainerList.filter(function (item) { return item.serialNumber.toLowerCase() === containerDesc_6.toLowerCase(); });
                    if (!(!isExistInWorkEffortIdsList_3 &&
                        isExistInPickRunContainerList &&
                        isExistInPickRunContainerList.length > 0)) return [3 /*break*/, 36];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_96 = (_95 = response_2.data) === null || _95 === void 0 ? void 0 : _95.container) === null || _96 === void 0 ? void 0 : _96.containerId,
                            containerDescription: ((_98 = (_97 = response_2.data) === null || _97 === void 0 ? void 0 : _97.container) === null || _98 === void 0 ? void 0 : _98.serialNumber)
                                ? (_100 = (_99 = response_2.data) === null || _99 === void 0 ? void 0 : _99.container) === null || _100 === void 0 ? void 0 : _100.serialNumber
                                : ((_102 = (_101 = response_2.data) === null || _101 === void 0 ? void 0 : _101.container) === null || _102 === void 0 ? void 0 : _102.description)
                                    ? (_104 = (_103 = response_2.data) === null || _103 === void 0 ? void 0 : _103.container) === null || _104 === void 0 ? void 0 : _104.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: true,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            scanToteId: scanToteId
                        }))];
                case 35:
                    _105.sent();
                    return [3 /*break*/, 37];
                case 36:
                    setScannedToteIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _105.label = 37;
                case 37: return [3 /*break*/, 47];
                case 38:
                    if (!(totesList.length + 1 === requiredPickContainerCount)) return [3 /*break*/, 39];
                    setCurrentActiveSubscreen(subscreenName);
                    return [3 /*break*/, 47];
                case 39:
                    if (!!fromMoveToSortingScreen) return [3 /*break*/, 42];
                    return [4 /*yield*/, thunkAPI.dispatch(createPickContainer({
                            inputVal: scanToteId,
                            containerId: response_2.data.container.containerId,
                            setIncorrect: setScannedToteIncorrect,
                            setErrorMsgText: setErrorMsgText,
                            setTotesList: setTotesList,
                            totesList: totesList,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: subscreenName,
                            pickRunTypeId: 'PrtSingle'
                        }))];
                case 40:
                    _105.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getPickRunContainers())];
                case 41:
                    _105.sent();
                    return [3 /*break*/, 47];
                case 42:
                    if (!(subscreenName === 'scanSortingItem')) return [3 /*break*/, 46];
                    setContainerId(response_2.data.container.containerId);
                    containerIdIncludes = facilitiesLocationList.includes(response_2.data.container.containerId);
                    if (!containerIdIncludes) return [3 /*break*/, 44];
                    return [4 /*yield*/, thunkAPI.dispatch(getContainerDetail({
                            setProductIdList: setProductIdList,
                            setShipmentId: setShipmentId,
                            containerId: response_2.data.container.containerId,
                            setShipmentIdList: setShipmentIdList
                        }))];
                case 43:
                    _105.sent();
                    return [3 /*break*/, 45];
                case 44:
                    setScannedToteIncorrect(true);
                    setErrorMsgText("Container " + response_2.data.container.containerId + " is not present on pod " + localStorage.getItem('sortinglocationSeqId') + ".");
                    _105.label = 45;
                case 45:
                    statusCode = localStorage.getItem('getContainerDetailsAPIStatus');
                    if (statusCode === 'status_200') {
                        setCurrentActiveSubscreen(subscreenName);
                    }
                    return [3 /*break*/, 47];
                case 46:
                    containerIdStr_1 = localStorage.getItem('containerIdStr');
                    if (containerIdStr_1 === null) {
                        containerIdStr_1 = '';
                    }
                    setTotesList(function (prev) {
                        var _a, _b, _c, _d, _e, _f;
                        var isAlreadyIncluded = false;
                        prev.forEach(function (item) {
                            var _a, _b, _c, _d, _e, _f;
                            if (item.toteData === ((_b = (_a = response_2.data) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.serialNumber) ||
                                item.toteData === ((_d = (_c = response_2.data) === null || _c === void 0 ? void 0 : _c.container) === null || _d === void 0 ? void 0 : _d.description) ||
                                item.toteData === ((_f = (_e = response_2.data) === null || _e === void 0 ? void 0 : _e.container) === null || _f === void 0 ? void 0 : _f.containerId)) {
                                isAlreadyIncluded = true;
                            }
                        });
                        if (isAlreadyIncluded) {
                            setScannedToteIncorrect(true);
                            setErrorMsgText('Tote already placed on cart, scan another');
                            return prev;
                        }
                        else {
                            if (containerIdStr_1) {
                                var containerIdIncluded = facilitiesLocationList.includes(response_2.data.container.containerId);
                                if (containerIdIncluded) {
                                    containerIdStr_1 = containerIdStr_1 + ',' + response_2.data.container.containerId;
                                }
                                else {
                                    setScannedToteIncorrect(true);
                                    setErrorMsgText("Container " + response_2.data.container.containerId + " is not present on Dropzone " + localStorage.getItem('dropzoneLocationSeqId') + ".");
                                    return __spreadArray([], prev, true);
                                }
                            }
                            else {
                                var containeIdIncluded = facilitiesLocationList.includes(response_2.data.container.containerId);
                                if (containeIdIncluded) {
                                    containerIdStr_1 = response_2.data.container.containerId;
                                }
                                else {
                                    setScannedToteIncorrect(true);
                                    setErrorMsgText("Container " + response_2.data.container.containerId + " is not present on Dropzone " + localStorage.getItem('dropzoneLocationSeqId'));
                                    return __spreadArray([], prev, true);
                                }
                            }
                            return __spreadArray(__spreadArray([], prev, true), [
                                {
                                    toteData: ((_b = (_a = response_2.data) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.serialNumber)
                                        ? (_d = (_c = response_2.data) === null || _c === void 0 ? void 0 : _c.container) === null || _d === void 0 ? void 0 : _d.serialNumber
                                        : (_f = (_e = response_2.data) === null || _e === void 0 ? void 0 : _e.container) === null || _f === void 0 ? void 0 : _f.description,
                                    count: totesList.length + 1
                                }
                            ], false);
                        }
                    });
                    localStorage.setItem('containerIdStr', containerIdStr_1);
                    _105.label = 47;
                case 47: return [2 /*return*/, response_2.data];
                case 48: return [2 /*return*/, thunkAPI.rejectWithValue(response_2)];
                case 49: return [3 /*break*/, 51];
                case 50:
                    e_14 = _105.sent();
                    console.log('Error', e_14.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_14.response.data)];
                case 51: return [2 /*return*/];
            }
        });
    });
});
export var getContainerDetail = createAsyncThunk('auth/getContainerDetail', function (_a, thunkAPI) {
    var setProductIdList = _a.setProductIdList, setShipmentId = _a.setShipmentId, containerId = _a.containerId, setShipmentIdList = _a.setShipmentIdList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, containerDetailNotification, productIdList_1, containerObj_1, e_15;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/container/" + containerId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (typeof (response === null || response === void 0 ? void 0 : response.status) == 'undefined') {
                        localStorage.setItem('getContainerDetailsAPIStatus', 'status_400');
                        containerDetailNotification = false;
                        localStorage.setItem('containerDetailNotification', JSON.stringify(containerDetailNotification));
                    }
                    if (response.status === 200) {
                        localStorage.setItem('getContainerDetailsAPIStatus', 'status_200');
                        productIdList_1 = [];
                        response.data.facilityContainer.products.map(function (item) {
                            productIdList_1.push(item.productId);
                            return null;
                        });
                        setProductIdList(productIdList_1);
                        containerObj_1 = {};
                        response.data.facilityContainer.products.map(function (item) {
                            containerObj_1[item.productId] = [];
                            item.shipments.map(function (shipment) {
                                containerObj_1[item.productId].push(shipment.shipmentId);
                                return null;
                            });
                            return null;
                        });
                        setShipmentIdList(containerObj_1);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_15 = _b.sent();
                    console.log('Error', e_15.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_15.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getScannedLocation = createAsyncThunk('auth/getScannedLocation', function (_a, thunkAPI) {
    var scanLocationId = _a.scanLocationId, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, fromScreen = _a.fromScreen, subscreenName = _a.subscreenName, setTotesList = _a.setTotesList, setErrorMsgText = _a.setErrorMsgText, totesList = _a.totesList, containerLocationSeqId = _a.containerLocationSeqId, setScannedDropzoneLocationData = _a.setScannedDropzoneLocationData, newShipmentFound = _a.newShipmentFound, setScanPodLocationData = _a.setScanPodLocationData, toteFull = _a.toteFull, setFacilitiesLocationList = _a.setFacilitiesLocationList, pickRunTypeId = _a.pickRunTypeId, setScannedContainerIncorrect = _a.setScannedContainerIncorrect, setLookUpProductList = _a.setLookUpProductList, setLookUpContainerDetails = _a.setLookUpContainerDetails, setEnumTypeList = _a.setEnumTypeList, productQty = _a.productQty, lotId = _a.lotId;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_2, token, facilityId, pickRunId, ownerPartyId, url, response_3, locationSeqId, currProdId, requiredPickContainerCount, parsedContainers, alreadyScannedContainer, pickRunContainerList, pickRunContainer, containerDesc, currentOrderId_1, currentShipmentId_1, recommendedContainer, containerDesc, pickRunContainerList, orderContainerList, hospitalContainers, containerDesc_7, isExistInPickRunContainerList_1, scannedOrderIds, packingStationContainers, isFound_1, foundIndex_1, containerId, foundIndexInPackStationArray_1, foundIndexInPackStationArray_2, facilityLocationContainersList, isDropzoneExist, setBtnDisabled, parsedPodDetailsArray, currIndexInPodDetailsList, podLocationId, e_16;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55;
        return __generator(this, function (_56) {
            switch (_56.label) {
                case 0:
                    _56.trys.push([0, 52, , 53]);
                    originalSetErrorMsgText_2 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        originalSetErrorMsgText_2 === null || originalSetErrorMsgText_2 === void 0 ? void 0 : originalSetErrorMsgText_2(msg);
                    };
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    pickRunId = localStorage.getItem('pickRunId');
                    ownerPartyId = localStorage.getItem('activeOrgId');
                    url = "/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanLocationId;
                    if (fromScreen === 'scanProduct') {
                        url = "/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanLocationId + "&pickRunId=" + pickRunId + "&ownerPartyId=" + ownerPartyId;
                    }
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response_3 = _56.sent();
                    if (!(response_3.status === 200)) return [3 /*break*/, 50];
                    if (!(fromScreen === 'scanCart')) return [3 /*break*/, 5];
                    if (!(response_3.data.facilityLocation &&
                        response_3.data.facilityLocation.locationTypeEnumId === 'FltCart')) return [3 /*break*/, 3];
                    // setTotesList([])
                    localStorage.setItem('newCartScannedId', ((_b = response_3.data) === null || _b === void 0 ? void 0 : _b.locationSeqId)
                        ? (_c = response_3.data) === null || _c === void 0 ? void 0 : _c.locationSeqId
                        : ((_e = (_d = response_3.data) === null || _d === void 0 ? void 0 : _d.facilityLocation) === null || _e === void 0 ? void 0 : _e.locationSeqId)
                            ? (_g = (_f = response_3.data) === null || _f === void 0 ? void 0 : _f.facilityLocation) === null || _g === void 0 ? void 0 : _g.locationSeqId
                            : '');
                    localStorage.setItem('cartLocationSeqId', (_h = response_3.data.facilityLocation) === null || _h === void 0 ? void 0 : _h.locationSeqId);
                    // Commenting out description check
                    // if (response.data.facilityLocation?.description) {
                    //   localStorage.setItem('cartId', response.data.facilityLocation?.description)
                    // } else 
                    if ((_j = response_3.data.facilityLocation) === null || _j === void 0 ? void 0 : _j.serialNumber) {
                        localStorage.setItem('cartId', (_k = response_3.data.facilityLocation) === null || _k === void 0 ? void 0 : _k.serialNumber);
                    }
                    else if ((_l = response_3.data.facilityLocation) === null || _l === void 0 ? void 0 : _l.locationSeqId) {
                        localStorage.setItem('cartId', (_m = response_3.data.facilityLocation) === null || _m === void 0 ? void 0 : _m.locationSeqId);
                    }
                    return [4 /*yield*/, thunkAPI.dispatch(associateCartWithPickRun({
                            cartId: response_3.data.facilityLocation.locationSeqId,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setErrorMsgText: setErrorMsgText,
                            subscreenName: subscreenName
                        }))];
                case 2:
                    _56.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setErrorMsgText('Incorrect cart, scan again');
                    setScannedLocationIncorrect(true);
                    _56.label = 4;
                case 4: return [3 /*break*/, 49];
                case 5:
                    if (!(fromScreen === 'scanTote')) return [3 /*break*/, 10];
                    if (!(response_3.data.container &&
                        response_3.data.container.containerTypeEnumId === 'CtPickContainer')) return [3 /*break*/, 8];
                    return [4 /*yield*/, localStorage.setItem('cartLocationSeqId', (_o = response_3.data.facilityLocation) === null || _o === void 0 ? void 0 : _o.locationSeqId)];
                case 6:
                    _56.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(createPickContainer({
                            inputVal: scanLocationId,
                            containerId: response_3.data.container.containerId,
                            setIncorrect: setScannedLocationIncorrect,
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: subscreenName,
                            setTotesList: setTotesList,
                            pickRunTypeId: pickRunTypeId
                        }))];
                case 7:
                    _56.sent();
                    return [3 /*break*/, 9];
                case 8:
                    setErrorMsgText('Incorrect tote, scan again');
                    setScannedLocationIncorrect(true);
                    _56.label = 9;
                case 9: return [3 /*break*/, 49];
                case 10:
                    if (!(fromScreen === 'scanStartLocation' || fromScreen === 'scanLocationAgain')) return [3 /*break*/, 17];
                    if (!(response_3.data.facilityLocation &&
                        (response_3.data.facilityLocation.locationTypeEnumId === 'FltPick' ||
                            response_3.data.facilityLocation.locationTypeEnumId === 'FltBulk'))) return [3 /*break*/, 15];
                    setScannedLocationIncorrect(false);
                    if (!(fromScreen === 'scanStartLocation')) return [3 /*break*/, 13];
                    return [4 /*yield*/, thunkAPI.dispatch(createPickRun({
                            pickRunTypeId: pickRunTypeId,
                            locationSeqId: response_3.data.facilityLocation.locationSeqId
                        }))];
                case 11:
                    _56.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getPickRunDetails({
                            setErrorMsgText: setErrorMsgText,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: subscreenName,
                            nearestLocationSeqId: response_3.data.facilityLocation.locationSeqId,
                            fromLookup: false,
                            fromPickRunsScreen: false
                        }))];
                case 12:
                    _56.sent();
                    return [3 /*break*/, 14];
                case 13:
                    locationSeqId = localStorage.getItem('pickRunDtlsLocationSeqId');
                    localStorage.removeItem('pickRunDtlsLocationSeqId1');
                    if (scanLocationId.toLowerCase() === locationSeqId.toLowerCase()) {
                        setCurrentActiveSubscreen(subscreenName);
                    }
                    else {
                        if (pickRunTypeId === 'PrtBulkPick') {
                            localStorage.setItem('pickRunDtlsLocationSeqId1', scanLocationId);
                            setCurrentActiveSubscreen(subscreenName);
                        }
                        else {
                            setScannedLocationIncorrect(true);
                            setErrorMsgText('Incorrect location, scan again!');
                        }
                    }
                    _56.label = 14;
                case 14: return [3 /*break*/, 16];
                case 15:
                    setErrorMsgText('Incorrect location, scan again');
                    setScannedLocationIncorrect(true);
                    _56.label = 16;
                case 16: return [3 /*break*/, 49];
                case 17:
                    if (!(fromScreen === 'scanProduct' || fromScreen === 'prodUpcScreen')) return [3 /*break*/, 18];
                    currProdId = localStorage.getItem('currProdId');
                    if (response_3.data.product &&
                        response_3.data.product.productId === currProdId &&
                        response_3.data.product.productTypeEnumId === 'PtAsset') {
                        setCurrentActiveSubscreen(subscreenName);
                    }
                    else if (response_3.data &&
                        response_3.data.productId &&
                        response_3.data.productId === currProdId) {
                        setCurrentActiveSubscreen(subscreenName);
                    }
                    else {
                        setScannedLocationIncorrect(true);
                        setErrorMsgText('Incorrect product, scan again');
                    }
                    return [3 /*break*/, 49];
                case 18:
                    if (!(fromScreen === 'placeTote')) return [3 /*break*/, 37];
                    if (!(response_3.data.container &&
                        response_3.data.container.containerTypeEnumId === 'CtPickContainer')) return [3 /*break*/, 35];
                    return [4 /*yield*/, localStorage.setItem('cartLocationSeqId', (_p = response_3.data.facilityLocation) === null || _p === void 0 ? void 0 : _p.locationSeqId)];
                case 19:
                    _56.sent();
                    requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
                    parsedContainers = localStorage.getItem('pickRunContainerList');
                    if (parsedContainers) {
                        parsedContainers = JSON.parse(parsedContainers);
                    }
                    else {
                        parsedContainers = [];
                    }
                    if (pickRunTypeId === 'PrtBulkPick') {
                        requiredPickContainerCount = 1;
                    }
                    alreadyScannedContainer = parsedContainers === null || parsedContainers === void 0 ? void 0 : parsedContainers.some(function (con) {
                        var _a, _b;
                        if (((_a = con === null || con === void 0 ? void 0 : con.containerId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (scanLocationId === null || scanLocationId === void 0 ? void 0 : scanLocationId.toLowerCase()) ||
                            ((_b = con === null || con === void 0 ? void 0 : con.serialNumber) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === (scanLocationId === null || scanLocationId === void 0 ? void 0 : scanLocationId.toLowerCase())) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                    if (!(requiredPickContainerCount !== (parsedContainers === null || parsedContainers === void 0 ? void 0 : parsedContainers.length) &&
                        !alreadyScannedContainer)) return [3 /*break*/, 21];
                    return [4 /*yield*/, thunkAPI.dispatch(createPickContainer({
                            inputVal: scanLocationId,
                            containerId: response_3.data.container.containerId,
                            setIncorrect: setScannedLocationIncorrect,
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: subscreenName,
                            setTotesList: setTotesList,
                            pickRunTypeId: pickRunTypeId
                        }))];
                case 20:
                    _56.sent();
                    _56.label = 21;
                case 21:
                    if (!(pickRunTypeId !== 'PrtSingle' && pickRunTypeId !== 'PrtOrderLevel')) return [3 /*break*/, 27];
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    pickRunContainer = '';
                    if (pickRunContainerList &&
                        pickRunContainerList.length > 0 &&
                        pickRunContainerList[0]['serialNumber']) {
                        pickRunContainer = pickRunContainerList[0]['serialNumber'];
                    }
                    else if (pickRunContainerList &&
                        pickRunContainerList.length > 0 &&
                        pickRunContainerList[0]['description']) {
                        pickRunContainer = pickRunContainerList[0]['description'];
                    }
                    containerDesc = ((_r = (_q = response_3.data) === null || _q === void 0 ? void 0 : _q.container) === null || _r === void 0 ? void 0 : _r.serialNumber)
                        ? (_t = (_s = response_3.data) === null || _s === void 0 ? void 0 : _s.container) === null || _t === void 0 ? void 0 : _t.serialNumber
                        : (_v = (_u = response_3.data) === null || _u === void 0 ? void 0 : _u.container) === null || _v === void 0 ? void 0 : _v.description;
                    if (!(pickRunContainer.toLowerCase() !== containerDesc.toLowerCase())) return [3 /*break*/, 22];
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    return [3 /*break*/, 26];
                case 22:
                    if (!(pickRunTypeId === 'PrtBulkPick')) return [3 /*break*/, 24];
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunMove({
                            containerId: (_x = (_w = response_3.data) === null || _w === void 0 ? void 0 : _w.container) === null || _x === void 0 ? void 0 : _x.containerId,
                            containerDescription: ((_z = (_y = response_3.data) === null || _y === void 0 ? void 0 : _y.container) === null || _z === void 0 ? void 0 : _z.serialNumber)
                                ? (_1 = (_0 = response_3.data) === null || _0 === void 0 ? void 0 : _0.container) === null || _1 === void 0 ? void 0 : _1.serialNumber
                                : ((_3 = (_2 = response_3.data) === null || _2 === void 0 ? void 0 : _2.container) === null || _3 === void 0 ? void 0 : _3.description)
                                    ? (_5 = (_4 = response_3.data) === null || _4 === void 0 ? void 0 : _4.container) === null || _5 === void 0 ? void 0 : _5.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: false,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedLocationIncorrect,
                            scanToteId: scanLocationId,
                            bulkPickedQuantity: +productQty,
                            lotId: lotId
                        }))];
                case 23:
                    _56.sent();
                    return [3 /*break*/, 26];
                case 24: return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                        containerId: (_7 = (_6 = response_3.data) === null || _6 === void 0 ? void 0 : _6.container) === null || _7 === void 0 ? void 0 : _7.containerId,
                        containerDescription: ((_9 = (_8 = response_3.data) === null || _8 === void 0 ? void 0 : _8.container) === null || _9 === void 0 ? void 0 : _9.serialNumber)
                            ? (_11 = (_10 = response_3.data) === null || _10 === void 0 ? void 0 : _10.container) === null || _11 === void 0 ? void 0 : _11.serialNumber
                            : ((_13 = (_12 = response_3.data) === null || _12 === void 0 ? void 0 : _12.container) === null || _13 === void 0 ? void 0 : _13.description)
                                ? (_15 = (_14 = response_3.data) === null || _14 === void 0 ? void 0 : _14.container) === null || _15 === void 0 ? void 0 : _15.description
                                : '',
                        setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                        fromPickMultis: false,
                        subscreenName: subscreenName,
                        setErrorMsgText: setErrorMsgText,
                        setScannedToteIncorrect: setScannedLocationIncorrect,
                        scanToteId: scanLocationId,
                        pickedQuantity: productQty
                    }))];
                case 25:
                    _56.sent();
                    _56.label = 26;
                case 26: return [3 /*break*/, 34];
                case 27:
                    currentOrderId_1 = localStorage.getItem('currentOrderId');
                    currentShipmentId_1 = localStorage.getItem('currentShipmentId');
                    recommendedContainer = localStorage.getItem('recommendedContainer');
                    containerDesc = ((_17 = (_16 = response_3.data) === null || _16 === void 0 ? void 0 : _16.container) === null || _17 === void 0 ? void 0 : _17.serialNumber)
                        ? (_19 = (_18 = response_3.data) === null || _18 === void 0 ? void 0 : _18.container) === null || _19 === void 0 ? void 0 : _19.serialNumber
                        : (_21 = (_20 = response_3.data) === null || _20 === void 0 ? void 0 : _20.container) === null || _21 === void 0 ? void 0 : _21.description;
                    if (!recommendedContainer) return [3 /*break*/, 31];
                    if (!(recommendedContainer.toLowerCase() !== containerDesc.toLowerCase())) return [3 /*break*/, 28];
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    return [3 /*break*/, 30];
                case 28: return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                        containerId: (_23 = (_22 = response_3.data) === null || _22 === void 0 ? void 0 : _22.container) === null || _23 === void 0 ? void 0 : _23.containerId,
                        containerDescription: ((_25 = (_24 = response_3.data) === null || _24 === void 0 ? void 0 : _24.container) === null || _25 === void 0 ? void 0 : _25.serialNumber)
                            ? (_27 = (_26 = response_3.data) === null || _26 === void 0 ? void 0 : _26.container) === null || _27 === void 0 ? void 0 : _27.serialNumber
                            : ((_29 = (_28 = response_3.data) === null || _28 === void 0 ? void 0 : _28.container) === null || _29 === void 0 ? void 0 : _29.description)
                                ? (_31 = (_30 = response_3.data) === null || _30 === void 0 ? void 0 : _30.container) === null || _31 === void 0 ? void 0 : _31.description
                                : '',
                        setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                        fromPickMultis: false,
                        subscreenName: subscreenName,
                        setErrorMsgText: setErrorMsgText,
                        setScannedToteIncorrect: setScannedLocationIncorrect,
                        scanToteId: scanLocationId
                    }))];
                case 29:
                    _56.sent();
                    _56.label = 30;
                case 30: return [3 /*break*/, 34];
                case 31:
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    orderContainerList = localStorage.getItem('orderContainerList');
                    if (orderContainerList) {
                        orderContainerList = JSON.parse(orderContainerList);
                    }
                    else {
                        orderContainerList = [];
                    }
                    hospitalContainers = localStorage.getItem('hospitalContainers');
                    if (hospitalContainers) {
                        hospitalContainers = JSON.parse(hospitalContainers);
                    }
                    else {
                        hospitalContainers = [];
                    }
                    containerDesc_7 = ((_33 = (_32 = response_3.data) === null || _32 === void 0 ? void 0 : _32.container) === null || _33 === void 0 ? void 0 : _33.serialNumber)
                        ? (_35 = (_34 = response_3.data) === null || _34 === void 0 ? void 0 : _34.container) === null || _35 === void 0 ? void 0 : _35.serialNumber
                        : (_37 = (_36 = response_3.data) === null || _36 === void 0 ? void 0 : _36.container) === null || _37 === void 0 ? void 0 : _37.description;
                    isExistInPickRunContainerList_1 = false;
                    pickRunContainerList.forEach(function (item) {
                        if (item.serialNumber.toLowerCase() === containerDesc_7.toLowerCase()) {
                            isExistInPickRunContainerList_1 = true;
                        }
                    });
                    if (isExistInPickRunContainerList_1) {
                        orderContainerList.forEach(function (item) {
                            if (item.containerId.toLowerCase() === containerDesc_7.toLowerCase()) {
                                isExistInPickRunContainerList_1 = false;
                            }
                        });
                    }
                    if (isExistInPickRunContainerList_1) {
                        hospitalContainers.forEach(function (item) {
                            if (item.containerId.toLowerCase() === containerDesc_7.toLowerCase()) {
                                if ("" + currentOrderId_1 + currentShipmentId_1 !== item.orderId) {
                                    console.log('====line 1936====exists in hospitalContainers=====');
                                }
                            }
                        });
                    }
                    scannedOrderIds = localStorage.getItem('scannedOrderIds');
                    if (scannedOrderIds) {
                        scannedOrderIds = JSON.parse(scannedOrderIds);
                    }
                    else {
                        scannedOrderIds = [];
                    }
                    packingStationContainers = localStorage.getItem('packingStationContainers');
                    if (packingStationContainers) {
                        packingStationContainers = JSON.parse(packingStationContainers);
                    }
                    else {
                        packingStationContainers = [];
                    }
                    if (!isExistInPickRunContainerList_1) return [3 /*break*/, 33];
                    isFound_1 = false;
                    foundIndex_1 = -1;
                    hospitalContainers.forEach(function (item, index) {
                        if (item.orderId === "" + currentOrderId_1 + currentShipmentId_1) {
                            isFound_1 = true;
                            foundIndex_1 = index;
                        }
                    });
                    containerId = ((_39 = (_38 = response_3.data) === null || _38 === void 0 ? void 0 : _38.container) === null || _39 === void 0 ? void 0 : _39.serialNumber)
                        ? (_41 = (_40 = response_3.data) === null || _40 === void 0 ? void 0 : _40.container) === null || _41 === void 0 ? void 0 : _41.serialNumber
                        : ((_43 = (_42 = response_3.data) === null || _42 === void 0 ? void 0 : _42.container) === null || _43 === void 0 ? void 0 : _43.description)
                            ? (_45 = (_44 = response_3.data) === null || _44 === void 0 ? void 0 : _44.container) === null || _45 === void 0 ? void 0 : _45.description
                            : '';
                    //let newPackingStationData: any = []
                    if (isFound_1) {
                        foundIndexInPackStationArray_1 = -1;
                        packingStationContainers.forEach(function (item, index) {
                            if (item.orderId === "" + currentOrderId_1 + currentShipmentId_1) {
                                foundIndexInPackStationArray_1 = index;
                            }
                        });
                        if (foundIndex_1 > -1) {
                            hospitalContainers[foundIndex_1] = {
                                orderId: "" + currentOrderId_1 + currentShipmentId_1,
                                containerId: containerId
                            };
                        }
                        if (foundIndexInPackStationArray_1 > -1) {
                            packingStationContainers.splice(foundIndexInPackStationArray_1, 1);
                        }
                        localStorage.setItem('hospitalContainers', JSON.stringify(hospitalContainers));
                        localStorage.setItem('packingStationContainers', JSON.stringify(packingStationContainers));
                    }
                    else {
                        foundIndexInPackStationArray_2 = -1;
                        packingStationContainers.forEach(function (item, index) {
                            if (item.orderId === "" + currentOrderId_1 + currentShipmentId_1) {
                                foundIndexInPackStationArray_2 = index;
                            }
                        });
                        if (foundIndexInPackStationArray_2 <= -1) {
                            packingStationContainers.push({
                                orderId: "" + currentOrderId_1 + currentShipmentId_1,
                                containerId: containerId
                            });
                        }
                        localStorage.setItem('packingStationContainers', JSON.stringify(packingStationContainers));
                    }
                    // } else {
                    //   packingStationContainers.push({
                    //     orderId: currentOrderId,
                    //     containerId: response.data?.container?.description
                    //   })
                    //   localStorage.setItem(
                    //     'packingStationContainers',
                    //     JSON.stringify(packingStationContainers)
                    //   )
                    //   scannedOrderIds.push(currentOrderId)
                    //   localStorage.setItem('scannedOrderIds', JSON.stringify(scannedOrderIds))
                    // }
                    return [4 /*yield*/, thunkAPI.dispatch(pickRunItemToCartContainer({
                            containerId: (_47 = (_46 = response_3.data) === null || _46 === void 0 ? void 0 : _46.container) === null || _47 === void 0 ? void 0 : _47.containerId,
                            containerDescription: ((_49 = (_48 = response_3.data) === null || _48 === void 0 ? void 0 : _48.container) === null || _49 === void 0 ? void 0 : _49.serialNumber)
                                ? (_51 = (_50 = response_3.data) === null || _50 === void 0 ? void 0 : _50.container) === null || _51 === void 0 ? void 0 : _51.serialNumber
                                : ((_53 = (_52 = response_3.data) === null || _52 === void 0 ? void 0 : _52.container) === null || _53 === void 0 ? void 0 : _53.description)
                                    ? (_55 = (_54 = response_3.data) === null || _54 === void 0 ? void 0 : _54.container) === null || _55 === void 0 ? void 0 : _55.description
                                    : '',
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromPickMultis: false,
                            subscreenName: subscreenName,
                            setErrorMsgText: setErrorMsgText,
                            setScannedToteIncorrect: setScannedLocationIncorrect,
                            scanToteId: scanLocationId
                        }))];
                case 32:
                    // } else {
                    //   packingStationContainers.push({
                    //     orderId: currentOrderId,
                    //     containerId: response.data?.container?.description
                    //   })
                    //   localStorage.setItem(
                    //     'packingStationContainers',
                    //     JSON.stringify(packingStationContainers)
                    //   )
                    //   scannedOrderIds.push(currentOrderId)
                    //   localStorage.setItem('scannedOrderIds', JSON.stringify(scannedOrderIds))
                    // }
                    _56.sent();
                    return [3 /*break*/, 34];
                case 33:
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _56.label = 34;
                case 34: return [3 /*break*/, 36];
                case 35:
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect tote, scan again');
                    _56.label = 36;
                case 36: return [3 /*break*/, 49];
                case 37:
                    if (!(fromScreen === 'dropzoneScreen')) return [3 /*break*/, 43];
                    if (!(response_3.data.facilityLocation &&
                        response_3.data.facilityLocation.locationTypeEnumId === 'FltDropzone')) return [3 /*break*/, 41];
                    facilityLocationContainersList = localStorage.getItem('dropzoneFacilityLocationContainersList');
                    if (!facilityLocationContainersList) {
                        facilityLocationContainersList = [];
                    }
                    else {
                        facilityLocationContainersList = JSON.parse(facilityLocationContainersList);
                    }
                    isDropzoneExist = facilityLocationContainersList.filter(function (item) { return item.locationSeqId === response_3.data.facilityLocation.locationSeqId; });
                    if (!((isDropzoneExist && isDropzoneExist.length > 0) ||
                        subscreenName === 'scanFinalTotes')) return [3 /*break*/, 39];
                    setCurrentActiveSubscreen(subscreenName);
                    setBtnDisabled = [];
                    return [4 /*yield*/, thunkAPI.dispatch(getFacilityLocationContainers({
                            locationSeqId: response_3.data.facilityLocation.locationSeqId,
                            setBtnDisabled: setBtnDisabled,
                            forMoveToSorting: true,
                            setFacilitiesLocationList: setFacilitiesLocationList,
                            functionCall: 'authSlice'
                        }))];
                case 38:
                    _56.sent();
                    localStorage.setItem('dropzoneLocationSeqId', response_3.data.facilityLocation.locationSeqId);
                    localStorage.setItem('pickRunDetailsDropzoneId', response_3.data.facilityLocation.locationSeqId);
                    localStorage.setItem('dropzoneName', response_3.data.facilityLocation.description
                        ? response_3.data.facilityLocation.description
                        : response_3.data.facilityLocation.locationSeqId);
                    return [3 /*break*/, 40];
                case 39:
                    setErrorMsgText("Dropzone " + response_3.data.facilityLocation.locationSeqId + " is empty");
                    setScannedLocationIncorrect(true);
                    _56.label = 40;
                case 40: return [3 /*break*/, 42];
                case 41:
                    setErrorMsgText('Incorrect dropzone, scan again');
                    setScannedLocationIncorrect(true);
                    _56.label = 42;
                case 42: return [3 /*break*/, 49];
                case 43:
                    if (!(fromScreen === 'sortingPodScreen')) return [3 /*break*/, 44];
                    if (response_3.data.facilityLocation &&
                        response_3.data.facilityLocation.locationTypeEnumId === 'FltPod') {
                        if (subscreenName === 'scanShippingLp') {
                            if (newShipmentFound) {
                                setScanPodLocationData(response_3.data.locationSeqId);
                                setCurrentActiveSubscreen(subscreenName);
                            }
                            else {
                                if (scanLocationId.toUpperCase() === containerLocationSeqId) {
                                    setScanPodLocationData(response_3.data.locationSeqId);
                                    setCurrentActiveSubscreen(subscreenName);
                                }
                                else {
                                    setErrorMsgText('incorrect scan pod location, scan again');
                                    setScannedLocationIncorrect(true);
                                    return [2 /*return*/];
                                }
                            }
                        }
                        else {
                            parsedPodDetailsArray = localStorage.getItem('podsDetailsArray');
                            parsedPodDetailsArray = JSON.parse(parsedPodDetailsArray);
                            currIndexInPodDetailsList = localStorage.getItem('currIndexInPodDetailsList');
                            if (!currIndexInPodDetailsList) {
                                currIndexInPodDetailsList = 0;
                            }
                            else {
                                currIndexInPodDetailsList *= 1;
                            }
                            podLocationId = parsedPodDetailsArray[currIndexInPodDetailsList]['podName'];
                            if (response_3.data.locationSeqId !== podLocationId) {
                                setErrorMsgText('Incorrect sorting pod, scan again');
                                setScannedLocationIncorrect(true);
                            }
                            else {
                                localStorage.setItem('currentPodLocationSeqId', response_3.data.locationSeqId);
                                setCurrentActiveSubscreen(subscreenName);
                            }
                        }
                    }
                    else if (response_3.data.facilityLocation &&
                        response_3.data.facilityLocation.locationTypeEnumId === 'FltPick') {
                        if (scanLocationId === containerLocationSeqId) {
                            setCurrentActiveSubscreen(subscreenName);
                        }
                        else {
                            setErrorMsgText('Does not Match, scan again');
                            setScannedLocationIncorrect(true);
                        }
                    }
                    else {
                        setErrorMsgText('Incorrect pod, scan again');
                        setScannedLocationIncorrect(true);
                    }
                    return [3 /*break*/, 49];
                case 44:
                    if (!(fromScreen === 'lookUp')) return [3 /*break*/, 48];
                    if (!(response_3.data.container &&
                        response_3.data.container.containerTypeEnumId === 'CtPickContainer')) return [3 /*break*/, 46];
                    return [4 /*yield*/, thunkAPI.dispatch(getContainerIdToLookup({
                            scanContainerId: scanLocationId,
                            setLookUpProductList: setLookUpProductList,
                            setLookUpContainerDetails: setLookUpContainerDetails,
                            setEnumTypeList: setEnumTypeList,
                            fromLookupGeneral: false
                        }))];
                case 45:
                    _56.sent();
                    return [3 /*break*/, 47];
                case 46:
                    setErrorMsgText('Incorrect Container, scan again');
                    setScannedContainerIncorrect(true);
                    _56.label = 47;
                case 47: return [3 /*break*/, 49];
                case 48:
                    setScannedLocationIncorrect(true);
                    _56.label = 49;
                case 49: return [2 /*return*/, response_3.data];
                case 50: return [2 /*return*/, thunkAPI.rejectWithValue(response_3)];
                case 51: return [3 /*break*/, 53];
                case 52:
                    e_16 = _56.sent();
                    console.log('Error', e_16.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_16.response.data)];
                case 53: return [2 /*return*/];
            }
        });
    });
});
export var associateCartWithPickRun = createAsyncThunk('auth/associateCartWithPickRun', function (_a, thunkAPI) {
    var cartId = _a.cartId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, subscreenName = _a.subscreenName, setErrorMsgText = _a.setErrorMsgText;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_17;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/associateCart?cartId=" + cartId + "&moquiSessionToken=" + token)];
                case 1:
                    response = _b.sent();
                    console.log('associateCartWithPickRun', response);
                    if (response.status === 200) {
                        setCurrentActiveSubscreen(subscreenName);
                        setScannedLocationIncorrect(false);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_17 = _b.sent();
                    console.log('Error', e_17.response.data);
                    setErrorMsgText('Something went wrong, please try again!');
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_17.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getContainerIdToLookup = createAsyncThunk('auth/getContainerIdToLookup', function (_a, thunkAPI) {
    var scanContainerId = _a.scanContainerId, setLookUpContainerDetails = _a.setLookUpContainerDetails, setLookUpProductList = _a.setLookUpProductList, setEnumTypeList = _a.setEnumTypeList, fromLookupGeneral = _a.fromLookupGeneral;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_18;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 8, , 9]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/lookupContainer", {
                            params: {
                                scanId: scanContainerId,
                                facilityId: facilityId
                            },
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 6];
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            enumType: 'ContainerType',
                            fromLookup: false,
                            setEnumTypeList: setEnumTypeList
                        }))];
                case 2:
                    _c.sent();
                    if (!fromLookupGeneral) return [3 /*break*/, 5];
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            enumType: 'FacilityLocationType',
                            fromLookup: true
                        }))];
                case 3:
                    _c.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getStatusList({
                            statusTypeId: 'Asset'
                        }))];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    setLookUpProductList((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.productList);
                    setLookUpContainerDetails(response === null || response === void 0 ? void 0 : response.data);
                    return [2 /*return*/, response.data];
                case 6: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_18 = _c.sent();
                    console.log('Error', e_18.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_18.response.data)];
                case 9: return [2 /*return*/];
            }
        });
    });
});
export var createPickRun = createAsyncThunk('auth/createPickRun', function (_a, thunkAPI) {
    var pickRunTypeId = _a.pickRunTypeId, history = _a.history, urlToPush = _a.urlToPush, locationSeqId = _a.locationSeqId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_19;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pickRun?moquiSessionToken=" + token, {
                            pickRunTypeId: pickRunTypeId,
                            organizationPartyId: localStorage.getItem('activeOrgId'),
                            facilityId: localStorage.getItem('facilityId'),
                            locationSeqId: locationSeqId
                        })];
                case 1:
                    response = _c.sent();
                    console.log('create pick run=====>', response);
                    if (response.status === 200) {
                        if (response.data && response.data.pickRunId) {
                            localStorage.setItem('pickRunId', response.data.pickRunId);
                            localStorage.setItem('requiredPickContainerCount', response.data.requiredPickContainerCount);
                            if (response.data && response.data.picklistContainerCounts) {
                                localStorage.setItem('picklistContainerCounts', JSON.stringify((_b = response.data) === null || _b === void 0 ? void 0 : _b.picklistContainerCounts));
                            }
                        }
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_19 = _c.sent();
                    console.log('Error', e_19.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_19.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_19.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getPickRunContainers = createAsyncThunk('auth/getPickRunContainers', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, e_20;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                return [4 /*yield*/, axios.get("rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/container", {
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _b.sent();
                console.log('pick container tote', response);
                if (response.status === 200) {
                    localStorage.setItem('containerId', (_a = response.data.pickRunContainerList[1]) === null || _a === void 0 ? void 0 : _a.containerId);
                    localStorage.setItem('pickRunContainerList', JSON.stringify(response.data.pickRunContainerList));
                    return [2 /*return*/, response.data];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_20 = _b.sent();
                console.log('Error', e_20.response.data);
                return [2 /*return*/, thunkAPI.rejectWithValue(e_20.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var createPickContainer = createAsyncThunk('auth/createPickContainer', function (_a, thunkAPI) {
    var inputVal = _a.inputVal, containerId = _a.containerId, setIncorrect = _a.setIncorrect, setErrorMsgText = _a.setErrorMsgText, setTotesList = _a.setTotesList, totesList = _a.totesList, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, pickRunTypeId = _a.pickRunTypeId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, pickRunContainerList, requiredPickContainerCount, e_21;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 6, , 7]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/container/" + containerId + "?moquiSessionToken=" + token)];
                case 1:
                    response = _b.sent();
                    console.log('createPickContainer', response);
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, thunkAPI.dispatch(getPickRunContainers())];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(pickMovePickContainer({
                            containerId: containerId,
                            fromCart: true,
                            setErrorMsgText: setErrorMsgText,
                            subscreenName: ''
                        }))];
                case 3:
                    _b.sent();
                    setTotesList(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ toteData: inputVal, count: prev.length + 1 }], false); });
                    pickRunContainerList = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList) {
                        pickRunContainerList = JSON.parse(pickRunContainerList);
                    }
                    else {
                        pickRunContainerList = [];
                    }
                    localStorage.setItem('pickRunContainerList', JSON.stringify(pickRunContainerList));
                    requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
                    requiredPickContainerCount *= 1;
                    if (pickRunTypeId !== 'PrtSingle' && pickRunTypeId !== 'PrtOrderLevel') {
                        requiredPickContainerCount = 1;
                    }
                    if (totesList.length + 1 === requiredPickContainerCount) {
                        // setCurrentActiveSubscreen(subscreenName)
                        setIncorrect(false);
                    }
                    return [2 /*return*/, response];
                case 4: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_21 = _b.sent();
                    console.log('Error', e_21.response.data);
                    setIncorrect(true);
                    setErrorMsgText(e_21.response.data.errors ? e_21.response.data.errors : 'Something went wrong!');
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_21.response.data)];
                case 7: return [2 /*return*/];
            }
        });
    });
});
//Integrated the pick move items rest API
export var pickMoveItem = createAsyncThunk('auth/pickMoveItem', function (setScannedMoveIncorrect, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, e_22;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                return [4 /*yield*/, axios.post("/rest/s1/handheld/pickMove", {
                        workEffortId: '101313',
                        shipmentId: '124277',
                        productId: '197312',
                        quantity: '1',
                        toContainerId: 'C100051',
                        toLocationSeqId: 'CART-01'
                    }, {
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _a.sent();
                console.log('pick move item', response);
                if (response.status === 200) {
                    if (response.data && response.data.result === false) {
                        setScannedMoveIncorrect(false);
                        notification['error']({
                            message: 'Something went wrong, please try again later.'
                        });
                    }
                    return [2 /*return*/, response];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_22 = _a.sent();
                console.log('Error', e_22.response.data);
                notification['error']({
                    message: 'Error',
                    description: e_22.response.data.errors
                });
                return [2 /*return*/, thunkAPI.rejectWithValue(e_22.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
//get EnumerationList REST APIs
export var getEnumerationList = createAsyncThunk('auth/getEnumerationList', function (_a, thunkAPI) {
    var setEnumTypeList = _a.setEnumTypeList, enumType = _a.enumType, fromLookup = _a.fromLookup, setModalVisible = _a.setModalVisible;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_23;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/fp/enum?enumTypeId=" + enumType, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('getEnumerationList', response);
                    if (response.status === 200) {
                        if (fromLookup) {
                            if (enumType === 'ContainerType') {
                                localStorage.setItem('containerEnumsList', JSON.stringify(response.data.enumTypeList));
                            }
                            else {
                                localStorage.setItem('locationEnumsList', JSON.stringify(response.data.enumTypeList));
                            }
                        }
                        else {
                            setEnumTypeList(response.data.enumTypeList);
                            setModalVisible(true);
                        }
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_23 = _b.sent();
                    console.log('Error', e_23.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_23.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getStatusList = createAsyncThunk('auth/getStatusList', function (_a, thunkAPI) {
    var statusTypeId = _a.statusTypeId, setShipmentStatusList = _a.setShipmentStatusList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_24;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/fp/status?statusTypeId=" + statusTypeId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('get status list', response);
                    if (response.status === 200) {
                        localStorage.setItem('statusTypeList', JSON.stringify(response.data.statusList));
                        if (setShipmentStatusList) {
                            setShipmentStatusList(response.data.statusList);
                        }
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_24 = _b.sent();
                    console.log('Error', e_24.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_24.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getFacilityLocationContainers = createAsyncThunk('auth/getFacilityLocationContainers', function (_a, thunkAPI) {
    var setBtnDisabled = _a.setBtnDisabled, forMoveToSorting = _a.forMoveToSorting, locationSeqId = _a.locationSeqId, setFacilitiesLocationList = _a.setFacilitiesLocationList, functionCall = _a.functionCall;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, paramObj, response, facilitiesLocationList_1, e_25;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    paramObj = {
                        locationTypeEnumId: forMoveToSorting ? 'FltDropzone' : 'FltPod'
                    };
                    paramObj['containerTypeEnumId'] = 'CtPickContainer';
                    if (locationSeqId) {
                        paramObj['locationSeqId'] = locationSeqId;
                    }
                    else {
                    }
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/locationContainer", {
                            params: paramObj,
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _d.sent();
                    console.log('facilitiesLocationList', response);
                    if (response.status === 200) {
                        if (response.data &&
                            response.data.facilityLocationContainers &&
                            response.data.facilityLocationContainers.length > 0) {
                            if (forMoveToSorting) {
                                localStorage.setItem('dropzoneFacilityLocationContainersList', JSON.stringify(response.data.facilityLocationContainers));
                            }
                            else {
                                localStorage.setItem('podFacilityLocationContainersList', JSON.stringify(response.data.facilityLocationContainers));
                            }
                        }
                        if (functionCall === 'taskSelect') {
                            if (response.data &&
                                response.data.facilityLocationContainers &&
                                response.data.facilityLocationContainers.length > 0) {
                                if (setBtnDisabled === 'setMoveToSortingBtnDisabled') {
                                    thunkAPI.dispatch(setMoveToSortingBtnDisabled(false));
                                }
                                else {
                                    thunkAPI.dispatch(setSortingBtnDisabled(false));
                                }
                            }
                            else {
                                if (setBtnDisabled === 'setMoveToSortingBtnDisabled') {
                                    thunkAPI.dispatch(setMoveToSortingBtnDisabled(true));
                                }
                                else {
                                    thunkAPI.dispatch(setSortingBtnDisabled(true));
                                }
                            }
                        }
                        else if (functionCall === 'authSlice') {
                            facilitiesLocationList_1 = [];
                            (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.facilityLocationContainers) === null || _c === void 0 ? void 0 : _c.forEach(function (facility) {
                                facilitiesLocationList_1.push(facility.containerId);
                            });
                            setFacilitiesLocationList(facilitiesLocationList_1);
                        }
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_25 = _d.sent();
                    console.log('Error', e_25.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_25.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get getHostAddress REST API
export var getHostAddress = createAsyncThunk('auth/getHostAddress', function (_a, thunkAPI) {
    var setHostAddress = _a.setHostAddress;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_26;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/fp/getHostAddress", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('get host Address===', response);
                    if (response.status === 200) {
                        setHostAddress(response.data.hostAddress);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_26 = _b.sent();
                    console.log('Error', e_26.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_26.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//Report Picking process exception API
export var reportPicking = createAsyncThunk('auth/reportPicking', function (_a, thunkAPI) {
    var enumId = _a.enumId, setCurrentScreen = _a.setCurrentScreen, from = _a.from, currentPickRunTypeId = _a.currentPickRunTypeId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, currentOrderId_2, currentShipmentId_2, orderContainerList, newOrderContainerList_1, currIndex, hospitalContainers, packingStationContainers, containerId_1, foundIndex_2, foundIndexInHospitalArray_1, foundIndexInHospitalArray_2, goToLocationData, shouldGoToHospitalLocation, hospitalContainers, e_27;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/pickRunItem/" + localStorage.getItem('pickRunItemId') + "?exceptionTypeEnumId=" + enumId + "&moquiSessionToken=" + token)];
                case 1:
                    response = _b.sent();
                    console.log('reportPicking', response);
                    if (response.status === 200) {
                        localStorage.removeItem('recommendedContainer');
                        currentOrderId_2 = localStorage.getItem('currentOrderId');
                        currentShipmentId_2 = localStorage.getItem('currentShipmentId');
                        orderContainerList = localStorage.getItem('orderContainerList');
                        if (orderContainerList) {
                            orderContainerList = JSON.parse(orderContainerList);
                        }
                        else {
                            orderContainerList = [];
                        }
                        newOrderContainerList_1 = [];
                        orderContainerList.forEach(function (item) {
                            if (item.orderId !== "" + currentOrderId_2 + currentShipmentId_2) {
                                newOrderContainerList_1.push(item);
                            }
                        });
                        localStorage.setItem('orderContainerList', JSON.stringify(newOrderContainerList_1));
                        currIndex = localStorage.getItem('currIndexInPickRunDetailsArr');
                        if (!currIndex) {
                            currIndex = 0;
                            localStorage.setItem('currIndexInPickRunDetailsArr', currIndex);
                        }
                        else {
                            currIndex++;
                            localStorage.setItem('currIndexInPickRunDetailsArr', currIndex);
                        }
                        // let scannedOrderIds: any = localStorage.getItem('scannedOrderIds')
                        // if (scannedOrderIds) {
                        //   scannedOrderIds = JSON.parse(scannedOrderIds)
                        // } else {
                        //   scannedOrderIds = []
                        // }
                        // if (scannedOrderIds.indexOf(currentOrderId) > -1) {
                        //   let isFound = false
                        //   hospitalContainers.forEach((item: any) => {
                        //     if (item.orderId === currentOrderId) {
                        //       isFound = true
                        //     }
                        //   })
                        //   let containerId: any = ''
                        //   let newPackingStationData: any = []
                        //   if (!isFound) {
                        //     packingStationContainers.forEach((item: any) => {
                        //       if (item.orderId === currentOrderId) {
                        //         containerId = item.containerId
                        //       } else {
                        //         newPackingStationData.push({
                        //           orderId: item.orderId,
                        //           containerId: item.containerId
                        //         })
                        //       }
                        //     })
                        //     hospitalContainers.push({
                        //       orderId: currentOrderId,
                        //       containerId
                        //     })
                        //     localStorage.setItem('hospitalContainers', JSON.stringify(hospitalContainers))
                        //     localStorage.setItem('packingStationContainers', JSON.stringify(newPackingStationData))
                        //   }
                        // } else {
                        //   hospitalContainers.push({
                        //     orderId: currentOrderId,
                        //     containerId: ''
                        //   })
                        //   localStorage.setItem('hospitalContainers', JSON.stringify(hospitalContainers))
                        //   scannedOrderIds.push(currentOrderId)
                        //   localStorage.setItem('scannedOrderIds', JSON.stringify(scannedOrderIds))
                        // }
                        if (currentPickRunTypeId === 'PrtBulkSingle' ||
                            currentPickRunTypeId === 'PrtSingle' ||
                            currentPickRunTypeId === 'PrtOrderLevel') {
                            hospitalContainers = localStorage.getItem('hospitalContainers');
                            if (hospitalContainers) {
                                hospitalContainers = JSON.parse(hospitalContainers);
                            }
                            else {
                                hospitalContainers = [];
                            }
                            packingStationContainers = localStorage.getItem('packingStationContainers');
                            if (packingStationContainers) {
                                packingStationContainers = JSON.parse(packingStationContainers);
                            }
                            else {
                                packingStationContainers = [];
                            }
                            containerId_1 = '';
                            foundIndex_2 = -1;
                            packingStationContainers.forEach(function (item, index) {
                                if (item.orderId === "" + currentOrderId_2 + currentShipmentId_2) {
                                    containerId_1 = item.containerId;
                                    foundIndex_2 = index;
                                }
                            });
                            if (foundIndex_2 > -1) {
                                foundIndexInHospitalArray_1 = -1;
                                packingStationContainers.splice(foundIndex_2, 1);
                                localStorage.setItem('packingStationContainers', JSON.stringify(packingStationContainers));
                                hospitalContainers.forEach(function (item, index) {
                                    if (item.orderId === "" + currentOrderId_2 + currentShipmentId_2) {
                                        foundIndexInHospitalArray_1 = index;
                                    }
                                });
                                if (foundIndexInHospitalArray_1 > -1) {
                                    hospitalContainers.splice(foundIndexInHospitalArray_1, 1);
                                }
                                hospitalContainers.push({
                                    orderId: "" + currentOrderId_2 + currentShipmentId_2,
                                    containerId: containerId_1
                                });
                                localStorage.setItem('hospitalContainers', JSON.stringify(hospitalContainers));
                            }
                            else {
                                foundIndexInHospitalArray_2 = -1;
                                hospitalContainers.forEach(function (item, index) {
                                    if (item.orderId === "" + currentOrderId_2 + currentShipmentId_2) {
                                        foundIndexInHospitalArray_2 = index;
                                    }
                                });
                                if (foundIndexInHospitalArray_2 <= -1) {
                                    hospitalContainers.push({
                                        orderId: "" + currentOrderId_2 + currentShipmentId_2,
                                        containerId: ''
                                    });
                                    localStorage.setItem('hospitalContainers', JSON.stringify(hospitalContainers));
                                }
                            }
                        }
                        goToLocationData = localStorage.getItem('goToLocationData');
                        goToLocationData = JSON.parse(goToLocationData);
                        localStorage.removeItem('visitedPickRunItemQty');
                        if (goToLocationData.length === currIndex) {
                            if (from === 'pickSingle') {
                                shouldGoToHospitalLocation = false;
                                if (currentPickRunTypeId === 'PrtBulkSingle' ||
                                    currentPickRunTypeId === 'PrtSingle' ||
                                    currentPickRunTypeId === 'PrtOrderLevel') {
                                    hospitalContainers = localStorage.getItem('hospitalContainers');
                                    if (hospitalContainers) {
                                        hospitalContainers = JSON.parse(hospitalContainers);
                                    }
                                    else {
                                        hospitalContainers = [];
                                    }
                                    if (hospitalContainers.length > 0) {
                                        shouldGoToHospitalLocation = true;
                                    }
                                }
                                if (shouldGoToHospitalLocation) {
                                    setCurrentScreen('hospitalLocation');
                                }
                                else {
                                    setCurrentScreen('packingStationLocation');
                                }
                            }
                            else {
                                setCurrentScreen('scanDropzoneLocation');
                            }
                        }
                        else {
                            setCurrentScreen('scanLocation');
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_27 = _b.sent();
                    console.log('Error', e_27.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_27.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var pickRunItemToCartContainer = createAsyncThunk('auth/pickRunItemToCartContainer', function (_a, thunkAPI) {
    var containerId = _a.containerId, containerDescription = _a.containerDescription, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, fromPickMultis = _a.fromPickMultis, subscreenName = _a.subscreenName, setErrorMsgText = _a.setErrorMsgText, setScannedToteIncorrect = _a.setScannedToteIncorrect, scanToteId = _a.scanToteId, pickedQuantity = _a.pickedQuantity;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, params, response, visitedPickRunItemQty, itemsCountData, currTotalPickRunItemQty, picklistContainerCounts, requiredPickContainerCount, currentWorkEffortId, workEffortIdsList, currentWorkEffortId, workEffortIdsList, orderContainerList, currentOrderId_3, currentShipmentId_3, orderContainerExists_1, currIndex, goToLocationData, toteExist, containerList, scannedContainerList, filteredContainer, e_28;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 7, , 8]);
                    token = localStorage.getItem('moquiSessionToken');
                    params = {
                        containerId: containerId,
                        cartId: localStorage.getItem('cartId')
                    };
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/pickRunItem/" + localStorage.getItem('pickRunItemId') + "/pickMove", params, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('pick move item', response);
                    if (!(response.status === 200)) return [3 /*break*/, 5];
                    if (!(response.data && response.data.result === false)) return [3 /*break*/, 2];
                    notification['error']({
                        message: response.data.message
                            ? response.data.message
                            : response.data.messages
                                ? response.data.messages
                                : 'Something went wrong, please try again!'
                    });
                    return [3 /*break*/, 4];
                case 2:
                    visitedPickRunItemQty = localStorage.getItem('visitedPickRunItemQty');
                    if (!visitedPickRunItemQty) {
                        visitedPickRunItemQty = 1;
                    }
                    else {
                        visitedPickRunItemQty *= 1;
                        visitedPickRunItemQty++;
                    }
                    itemsCountData = localStorage.getItem('itemsCountData');
                    if (itemsCountData) {
                        itemsCountData = JSON.parse(itemsCountData);
                    }
                    else {
                        itemsCountData = {
                            totalItemsCount: 0,
                            pickedItemsCount: 0
                        };
                    }
                    console.log('====line 2787====authSlice===before increment picked count====', itemsCountData);
                    if (itemsCountData['pickedItemsCount'] < itemsCountData['totalItemsCount']) {
                        itemsCountData['pickedItemsCount'] += 1;
                    }
                    console.log('====line 2789====authSlice===after increment picked count====', itemsCountData);
                    return [4 /*yield*/, localStorage.setItem('itemsCountData', JSON.stringify(itemsCountData))];
                case 3:
                    _c.sent();
                    console.log('====visitedPickItemQty=====//2384====', visitedPickRunItemQty);
                    currTotalPickRunItemQty = localStorage.getItem('currentTotalPickRunItemQty');
                    console.log('====currTotalPickRunItemQty=====//2392====', currTotalPickRunItemQty);
                    currTotalPickRunItemQty *= 1;
                    localStorage.setItem('recommendedContainer', containerDescription);
                    console.log('====fromPickMulti=====//2395====', fromPickMultis);
                    if (fromPickMultis) {
                        picklistContainerCounts = localStorage.getItem('picklistContainerCounts');
                        if (picklistContainerCounts) {
                            picklistContainerCounts = JSON.parse(picklistContainerCounts);
                        }
                        else {
                            picklistContainerCounts = {};
                        }
                        requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
                        if (Object.keys(picklistContainerCounts).length === requiredPickContainerCount) {
                            currentWorkEffortId = localStorage.getItem('currentWorkEffortId');
                            workEffortIdsList = localStorage.getItem('workEffortIdsList');
                            if (workEffortIdsList) {
                                workEffortIdsList = JSON.parse(workEffortIdsList);
                            }
                            else {
                                workEffortIdsList = {};
                            }
                            if (!workEffortIdsList[currentWorkEffortId]) {
                                workEffortIdsList[currentWorkEffortId] = containerDescription;
                            }
                            localStorage.setItem('workEffortIdsList', JSON.stringify(workEffortIdsList));
                        }
                        else {
                            currentWorkEffortId = localStorage.getItem('currentWorkEffortId');
                            workEffortIdsList = localStorage.getItem('workEffortIdsList');
                            if (workEffortIdsList) {
                                workEffortIdsList = JSON.parse(workEffortIdsList);
                            }
                            else {
                                workEffortIdsList = {};
                            }
                            if (!workEffortIdsList[currentWorkEffortId]) {
                                workEffortIdsList[currentWorkEffortId] = [];
                                workEffortIdsList[currentWorkEffortId].push(containerDescription);
                            }
                            else {
                                if (!workEffortIdsList[currentWorkEffortId].includes(containerDescription)) {
                                    workEffortIdsList[currentWorkEffortId].push(containerDescription);
                                }
                            }
                            localStorage.setItem('workEffortIdsList', JSON.stringify(workEffortIdsList));
                        }
                    }
                    orderContainerList = localStorage.getItem('orderContainerList');
                    if (orderContainerList) {
                        orderContainerList = JSON.parse(orderContainerList);
                    }
                    else {
                        orderContainerList = [];
                    }
                    currentOrderId_3 = localStorage.getItem('currentOrderId');
                    currentShipmentId_3 = localStorage.getItem('currentShipmentId');
                    orderContainerExists_1 = false;
                    orderContainerList.forEach(function (item) {
                        if (item.orderId === "" + currentOrderId_3 + currentShipmentId_3) {
                            orderContainerExists_1 = true;
                        }
                    });
                    if (!orderContainerExists_1) {
                        orderContainerList.push({
                            orderId: "" + currentOrderId_3 + currentShipmentId_3,
                            containerId: containerDescription
                        });
                    }
                    localStorage.setItem('orderContainerList', JSON.stringify(orderContainerList));
                    localStorage.removeItem('currentOrderId');
                    if (visitedPickRunItemQty !== currTotalPickRunItemQty) {
                        localStorage.setItem('visitedPickRunItemQty', visitedPickRunItemQty);
                        setCurrentActiveSubscreen('scanLocation');
                        return [2 /*return*/];
                    }
                    else {
                        localStorage.removeItem('recommendedContainer');
                    }
                    currIndex = localStorage.getItem('currIndexInPickRunDetailsArr');
                    if (!currIndex) {
                        currIndex = 0;
                        localStorage.setItem('currIndexInPickRunDetailsArr', currIndex);
                    }
                    else {
                        currIndex++;
                        localStorage.setItem('currIndexInPickRunDetailsArr', currIndex);
                    }
                    console.log('====currIndexInPickRunDetailsArr=====//2462====', currIndex);
                    goToLocationData = localStorage.getItem('goToLocationData');
                    goToLocationData = JSON.parse(goToLocationData);
                    console.log('====goToLocationData.length=====//2465====', goToLocationData.length);
                    if (goToLocationData.length === currIndex) {
                        setCurrentActiveSubscreen(subscreenName);
                        return [2 /*return*/, response];
                    }
                    toteExist = false;
                    containerList = localStorage.getItem('pickRunContainerList');
                    scannedContainerList = localStorage.getItem('scannedContainerList');
                    console.log('====scannedContainerList=====//2473====', scannedContainerList);
                    if (scannedContainerList) {
                        scannedContainerList = JSON.parse(scannedContainerList);
                    }
                    else {
                        scannedContainerList = [];
                    }
                    containerList = JSON.parse(containerList);
                    filteredContainer = containerList.filter(function (item) {
                        return item.containerId.toLowerCase() === scanToteId.toLowerCase() ||
                            item.serialNumber.toLowerCase() === scanToteId.toLowerCase();
                    });
                    if (filteredContainer.length > 0) {
                        toteExist = true;
                        scannedContainerList.push((_b = filteredContainer[0]) === null || _b === void 0 ? void 0 : _b.serialNumber);
                    }
                    if (!toteExist) {
                        setScannedToteIncorrect(true);
                        setErrorMsgText('Incorrect tote, scan again!');
                    }
                    else {
                        localStorage.setItem('scannedContainerList', JSON.stringify(scannedContainerList));
                        localStorage.removeItem('visitedPickRunItemQty');
                        localStorage.removeItem('pickRunDtlsLocationSeqId1');
                        setCurrentActiveSubscreen('scanLocation');
                    }
                    _c.label = 4;
                case 4: return [2 /*return*/, response];
                case 5: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 6: return [3 /*break*/, 8];
                case 7:
                    e_28 = _c.sent();
                    console.log('Error', e_28.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_28.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_28.response.data)];
                case 8: return [2 /*return*/];
            }
        });
    });
});
export var pickRunMove = createAsyncThunk('auth/pickRunMove', function (_a, thunkAPI) {
    var containerId = _a.containerId, containerDescription = _a.containerDescription, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, fromPickMultis = _a.fromPickMultis, subscreenName = _a.subscreenName, setErrorMsgText = _a.setErrorMsgText, setScannedToteIncorrect = _a.setScannedToteIncorrect, scanToteId = _a.scanToteId, bulkPickedQuantity = _a.bulkPickedQuantity, lotId = _a.lotId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, params, currIndex, locationObj, pickRunItemIdList, pickRunItemQty, locationSeqId, locationSeqId1, response, visitedPickRunItemQty, itemsCountData, bulkPickItemsData, currTotalPickRunItemQty, picklistContainerCounts, requiredPickContainerCount, currentWorkEffortId, workEffortIdsList, currentWorkEffortId, workEffortIdsList, orderContainerList, currentOrderId_4, currentShipmentId_4, orderContainerExists_2, currIndex_1, goToLocationData, toteExist, containerList, scannedContainerList, filteredContainer, e_29;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 8, , 9]);
                    token = localStorage.getItem('moquiSessionToken');
                    params = {
                        containerId: containerId,
                        cartId: localStorage.getItem('cartId')
                    };
                    currIndex = localStorage.getItem('currIndexInPickRunDetailsArr');
                    locationObj = localStorage.getItem('goToLocationData');
                    if (locationObj) {
                        locationObj = JSON.parse(locationObj);
                    }
                    else {
                        locationObj = [];
                    }
                    if (!currIndex) {
                        currIndex = 0;
                    }
                    pickRunItemIdList = (_c = (_b = locationObj[currIndex]) === null || _b === void 0 ? void 0 : _b['pickRunItems']) !== null && _c !== void 0 ? _c : [];
                    pickRunItemQty = (_e = (_d = locationObj[currIndex]) === null || _d === void 0 ? void 0 : _d['pickRunItemQty']) !== null && _e !== void 0 ? _e : 0;
                    locationSeqId = localStorage.getItem('pickRunDtlsLocationSeqId');
                    locationSeqId1 = localStorage.getItem('pickRunDtlsLocationSeqId1');
                    if (bulkPickedQuantity) {
                        params = __assign(__assign({}, params), { bulkPickedQuantity: bulkPickedQuantity, pickRunItemIdList: pickRunItemIdList, pickRunItemQty: pickRunItemQty, pickedLocationSeqId: locationSeqId1 !== null && locationSeqId1 !== void 0 ? locationSeqId1 : locationSeqId, lotId: lotId });
                    }
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/bulkPickMove", params, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    console.log('bulk pick move item', response);
                    if (!(response.status === 200)) return [3 /*break*/, 6];
                    if (!(response.data && response.data.result === false)) return [3 /*break*/, 2];
                    notification['error']({
                        message: response.data.message
                            ? response.data.message
                            : response.data.messages
                                ? response.data.messages
                                : 'Something went wrong, please try again!'
                    });
                    return [3 /*break*/, 5];
                case 2:
                    visitedPickRunItemQty = localStorage.getItem('visitedPickRunItemQty');
                    if (!visitedPickRunItemQty) {
                        // visitedPickRunItemQty = 1
                        visitedPickRunItemQty = bulkPickedQuantity;
                    }
                    else {
                        visitedPickRunItemQty *= 1;
                        // visitedPickRunItemQty++
                        visitedPickRunItemQty += bulkPickedQuantity;
                    }
                    itemsCountData = localStorage.getItem('itemsCountData');
                    bulkPickItemsData = localStorage.getItem('bulkPickItemsData');
                    if (itemsCountData) {
                        itemsCountData = JSON.parse(itemsCountData);
                    }
                    else {
                        itemsCountData = {
                            totalItemsCount: 0,
                            pickedItemsCount: 0
                        };
                    }
                    if (bulkPickItemsData) {
                        bulkPickItemsData = JSON.parse(bulkPickItemsData);
                    }
                    else {
                        bulkPickItemsData = {
                            totalItemsCount: 0,
                            pickedItemsCount: 0
                        };
                    }
                    console.log('====line 2787====authSlice===before increment picked count====', itemsCountData);
                    if (itemsCountData['pickedItemsCount'] < itemsCountData['totalItemsCount']) {
                        // itemsCountData['pickedItemsCount'] += 1
                        itemsCountData['pickedItemsCount'] += bulkPickedQuantity;
                        bulkPickItemsData['pickedItemsCount'] += bulkPickedQuantity;
                    }
                    console.log('====line 2789====authSlice===after increment picked count====', itemsCountData);
                    return [4 /*yield*/, localStorage.setItem('itemsCountData', JSON.stringify(itemsCountData))];
                case 3:
                    _f.sent();
                    return [4 /*yield*/, localStorage.setItem('bulkPickItemsData', JSON.stringify(bulkPickItemsData))];
                case 4:
                    _f.sent();
                    console.log('====visitedPickItemQty=====//2384====', visitedPickRunItemQty);
                    currTotalPickRunItemQty = localStorage.getItem('currentTotalPickRunItemQty');
                    console.log('====currTotalPickRunItemQty=====//2392====', currTotalPickRunItemQty);
                    currTotalPickRunItemQty *= 1;
                    localStorage.setItem('recommendedContainer', containerDescription);
                    console.log('====fromPickMulti=====//2395====', fromPickMultis);
                    if (fromPickMultis) {
                        picklistContainerCounts = localStorage.getItem('picklistContainerCounts');
                        if (picklistContainerCounts) {
                            picklistContainerCounts = JSON.parse(picklistContainerCounts);
                        }
                        else {
                            picklistContainerCounts = {};
                        }
                        requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
                        if (Object.keys(picklistContainerCounts).length === requiredPickContainerCount) {
                            currentWorkEffortId = localStorage.getItem('currentWorkEffortId');
                            workEffortIdsList = localStorage.getItem('workEffortIdsList');
                            if (workEffortIdsList) {
                                workEffortIdsList = JSON.parse(workEffortIdsList);
                            }
                            else {
                                workEffortIdsList = {};
                            }
                            if (!workEffortIdsList[currentWorkEffortId]) {
                                workEffortIdsList[currentWorkEffortId] = containerDescription;
                            }
                            localStorage.setItem('workEffortIdsList', JSON.stringify(workEffortIdsList));
                        }
                        else {
                            currentWorkEffortId = localStorage.getItem('currentWorkEffortId');
                            workEffortIdsList = localStorage.getItem('workEffortIdsList');
                            if (workEffortIdsList) {
                                workEffortIdsList = JSON.parse(workEffortIdsList);
                            }
                            else {
                                workEffortIdsList = {};
                            }
                            if (!workEffortIdsList[currentWorkEffortId]) {
                                workEffortIdsList[currentWorkEffortId] = [];
                                workEffortIdsList[currentWorkEffortId].push(containerDescription);
                            }
                            else {
                                if (!workEffortIdsList[currentWorkEffortId].includes(containerDescription)) {
                                    workEffortIdsList[currentWorkEffortId].push(containerDescription);
                                }
                            }
                            localStorage.setItem('workEffortIdsList', JSON.stringify(workEffortIdsList));
                        }
                    }
                    orderContainerList = localStorage.getItem('orderContainerList');
                    if (orderContainerList) {
                        orderContainerList = JSON.parse(orderContainerList);
                    }
                    else {
                        orderContainerList = [];
                    }
                    currentOrderId_4 = localStorage.getItem('currentOrderId');
                    currentShipmentId_4 = localStorage.getItem('currentShipmentId');
                    orderContainerExists_2 = false;
                    orderContainerList.forEach(function (item) {
                        if (item.orderId === "" + currentOrderId_4 + currentShipmentId_4) {
                            orderContainerExists_2 = true;
                        }
                    });
                    if (!orderContainerExists_2) {
                        orderContainerList.push({
                            orderId: "" + currentOrderId_4 + currentShipmentId_4,
                            containerId: containerDescription
                        });
                    }
                    localStorage.setItem('orderContainerList', JSON.stringify(orderContainerList));
                    localStorage.removeItem('currentOrderId');
                    if (visitedPickRunItemQty !== currTotalPickRunItemQty) {
                        localStorage.setItem('visitedPickRunItemQty', visitedPickRunItemQty);
                        setCurrentActiveSubscreen('scanLocation');
                        return [2 /*return*/];
                    }
                    else {
                        localStorage.removeItem('recommendedContainer');
                    }
                    currIndex_1 = localStorage.getItem('currIndexInPickRunDetailsArr');
                    if (!currIndex_1) {
                        currIndex_1 = 0;
                        localStorage.setItem('currIndexInPickRunDetailsArr', currIndex_1);
                    }
                    else {
                        if (itemsCountData['pickedItemsCount'] >= itemsCountData['totalItemsCount']) {
                            currIndex_1++;
                            localStorage.setItem('currIndexInPickRunDetailsArr', currIndex_1);
                        }
                    }
                    console.log('====currIndexInPickRunDetailsArr=====//2462====', currIndex_1);
                    goToLocationData = localStorage.getItem('goToLocationData');
                    goToLocationData = JSON.parse(goToLocationData);
                    console.log('====goToLocationData.length=====//2465====', goToLocationData.length);
                    if (goToLocationData.length === currIndex_1) {
                        setCurrentActiveSubscreen(subscreenName);
                        localStorage.removeItem('itemsCountData');
                        return [2 /*return*/, response];
                    }
                    toteExist = false;
                    containerList = localStorage.getItem('pickRunContainerList');
                    scannedContainerList = localStorage.getItem('scannedContainerList');
                    console.log('====scannedContainerList=====//2473====', scannedContainerList);
                    if (scannedContainerList) {
                        scannedContainerList = JSON.parse(scannedContainerList);
                    }
                    else {
                        scannedContainerList = [];
                    }
                    containerList = JSON.parse(containerList);
                    filteredContainer = containerList.filter(function (item) {
                        return item.containerId.toLowerCase() === scanToteId.toLowerCase() ||
                            item.serialNumber.toLowerCase() === scanToteId.toLowerCase();
                    });
                    if (filteredContainer.length > 0) {
                        toteExist = true;
                        scannedContainerList.push(filteredContainer[0].description);
                    }
                    if (!toteExist) {
                        setScannedToteIncorrect(true);
                        setErrorMsgText('Incorrect tote, scan again!');
                    }
                    else {
                        localStorage.setItem('scannedContainerList', JSON.stringify(scannedContainerList));
                        localStorage.removeItem('visitedPickRunItemQty');
                        localStorage.removeItem('pickRunDtlsLocationSeqId1');
                        setCurrentActiveSubscreen('scanLocation');
                    }
                    _f.label = 5;
                case 5: return [2 /*return*/, response];
                case 6: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_29 = _f.sent();
                    console.log('Error', e_29.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_29.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_29.response.data)];
                case 9: return [2 /*return*/];
            }
        });
    });
});
// Integrate the pick move pick container REST API
export var pickMovePickContainer = createAsyncThunk('auth/pickMovePickContainer', function (_a, thunkAPI) {
    var containerId = _a.containerId, setContinuePickMovePickContainer = _a.setContinuePickMovePickContainer, fromCart = _a.fromCart, fromPod = _a.fromPod, setErrorMsgText = _a.setErrorMsgText, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setTotesList = _a.setTotesList, subscreenName = _a.subscreenName, continuePickMovePickContainer = _a.continuePickMovePickContainer, isPickMoved = _a.isPickMoved;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, token, dataObj, response, e_30;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    facilityId = localStorage.getItem('facilityId');
                    token = localStorage.getItem('moquiSessionToken');
                    dataObj = {
                        locationSeqId: fromCart
                            ? localStorage.getItem('newCartScannedId')
                            : fromPod
                                ? localStorage.getItem('currentPodLocationSeqId')
                                : localStorage.getItem('dropzoneLocationSeqId'),
                        containerId: containerId,
                        pickRunId: localStorage.getItem('pickRunId')
                    };
                    if (fromCart && subscreenName !== 'scanSortingPodLocation') {
                        dataObj['isEmptyContainer'] = true;
                    }
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/facility/" + facilityId + "/pickMovePickContainer", dataObj, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('pick move item', response);
                    if (!(response.status === 200)) return [3 /*break*/, 6];
                    if (!(response.data && response.data.result === false)) return [3 /*break*/, 2];
                    setContinuePickMovePickContainer(false);
                    notification['error']({
                        message: 'Something went wrong, please try again.'
                    });
                    if (subscreenName === 'moveToSortingFinalScreen') {
                        isPickMoved = false;
                    }
                    setErrorMsgText('Something went wrong, please try again later.');
                    return [3 /*break*/, 5];
                case 2:
                    if (!(fromCart && subscreenName === 'scanSortingPodLocation')) return [3 /*break*/, 4];
                    return [4 /*yield*/, thunkAPI.dispatch(getPodsDetails({ setCurrentActiveSubscreen: setCurrentActiveSubscreen, subscreenName: subscreenName }))];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    if (!fromCart && !fromPod) {
                        setTotesList([]);
                        localStorage.removeItem('containerIdStr');
                        localStorage.removeItem('scannedContainerIds');
                        localStorage.removeItem('scannedPodItemsList');
                        setCurrentActiveSubscreen(subscreenName);
                    }
                    _b.label = 5;
                case 5: return [2 /*return*/, response];
                case 6: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_30 = _b.sent();
                    console.log('Error', e_30.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_30.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_30.response.data)];
                case 9: return [2 /*return*/];
            }
        });
    });
});
export var setProductToShippingContainer = createAsyncThunk('auth/setProductToShippingContainer', function (_a, thunkAPI) {
    var data = _a.data;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_31;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/facility/" + facilityId + "/pickMoveProductToShippingContainer", __assign({}, data), {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        localStorage.setItem('productToShippingContainer', response.data.result);
                        localStorage.setItem('productToShippingContainerMsg', response.data.message);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_31 = _b.sent();
                    console.log('Error', e_31.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_31.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_31.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//32) API to pick move ProductToShippingContainer:
export var updatePickrunDropzone = createAsyncThunk('auth/updatePickrunDropzone', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, e_32;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                return [4 /*yield*/, axios.put("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/dropzone", {
                        dropzoneId: localStorage.getItem('pickRunDetailsDropzoneId')
                    }, {
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    return [2 /*return*/, response];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_32 = _a.sent();
                console.log('Error', e_32.response.data);
                notification['error']({
                    message: 'Error',
                    description: e_32.response.data.errors
                });
                return [2 /*return*/, thunkAPI.rejectWithValue(e_32.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
//Integrate REST API to get tote list on pod basis
export var getPodsDetails = createAsyncThunk('auth/getPodsDetails', function (_a, thunkAPI) {
    var setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, cartLocationSeqId, token, response, resp_1, outputArr_1, e_33;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    facilityId = localStorage.getItem('facilityId');
                    cartLocationSeqId = localStorage.getItem('cartLocationSeqId');
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/cart/" + cartLocationSeqId + "/pods", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('get pods details', response);
                    if (response.status === 200) {
                        if (response.data && response.data.pods) {
                            resp_1 = response.data.pods;
                            outputArr_1 = [];
                            // eslint-disable-next-line
                            Object.keys(resp_1).map(function (key) {
                                outputArr_1.push({ podName: resp_1[key]['locationSeqId'], totes: resp_1[key]['totes'] });
                            });
                            localStorage.setItem('podsDetailsArray', JSON.stringify(outputArr_1));
                        }
                        setCurrentActiveSubscreen(subscreenName);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_33 = _b.sent();
                    console.log('Error', e_33.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_33.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Integrate the pick move pick container to packing station REST API
export var pickMoveContainerToPackStation = createAsyncThunk('auth/pickMoveContainerToPackStation', function (_a, thunkAPI) {
    var containerId = _a.containerId, setPickMoveContainerToPackingStation = _a.setPickMoveContainerToPackingStation;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, token, response, e_34;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 6, , 7]);
                    facilityId = localStorage.getItem('facilityId');
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/facility/" + facilityId + "/pickMoveToPackStation", {
                            containerId: containerId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('pick move item to packing station', response);
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    if (!(response.data && response.data.result === false)) return [3 /*break*/, 3];
                    setPickMoveContainerToPackingStation(false);
                    return [4 /*yield*/, localStorage.setItem('isConfirmDropoffAborted', 'true')];
                case 2:
                    _b.sent();
                    notification['error']({
                        message: 'Something went wrong, please try again later.'
                    });
                    _b.label = 3;
                case 3: return [2 /*return*/, response];
                case 4: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_34 = _b.sent();
                    console.log('Error', e_34.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_34.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_34.response.data)];
                case 7: return [2 /*return*/];
            }
        });
    });
});
//Integrate the API to change pick run status
export var updatePickRunStatus = createAsyncThunk('auth/updatePickRunStatus', function (_a, thunkAPI) {
    var statusId = _a.statusId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, bodyParams, response, e_35;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    bodyParams = {
                        assignedToUserId: localStorage.getItem('userId')
                    };
                    if (statusId) {
                        bodyParams['statusId'] = statusId;
                    }
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pickRun/" + localStorage.getItem('pickRunId') + "/updateStatus", bodyParams, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('updateStatus', response);
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_35 = _b.sent();
                    console.log('Error', e_35.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_35.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getLookup = createAsyncThunk('auth/getLookup', function (_a, thunkAPI) {
    var lookupId = _a.lookupId, setErrorMsgText = _a.setErrorMsgText, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, setScannedObj = _a.setScannedObj, setPrintPackingSliping = _a.setPrintPackingSliping, _b = _a.isGlobalLookup, isGlobalLookup = _b === void 0 ? false : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_3, token, organizationPartyId, facilityId, params, response, objToPush_1, containerTypesArray_1, statusTypesArray_1, containerTypesArray_2, locationTypesArray_1, statusTypesArray_2, availableToPromiseTotal_1, quantityOnHandTotal_1, e_36;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17;
        return __generator(this, function (_18) {
            switch (_18.label) {
                case 0:
                    _18.trys.push([0, 12, , 13]);
                    console.log('\n🟢 === getLookup CALLED ===');
                    console.log('🟢 lookupId:', lookupId);
                    console.log('🟢 isGlobalLookup:', isGlobalLookup);
                    originalSetErrorMsgText_3 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        console.log('🔴 AUTO-CAPTURE [Lookup]: setErrorMsgText called with:', msg);
                        originalSetErrorMsgText_3 === null || originalSetErrorMsgText_3 === void 0 ? void 0 : originalSetErrorMsgText_3(msg);
                        console.log('✅ AUTO-CAPTURE [Lookup]: Error captured');
                    };
                    token = localStorage.getItem('moquiSessionToken');
                    organizationPartyId = localStorage.getItem('activeOrgId');
                    facilityId = localStorage.getItem('facilityId');
                    params = {};
                    if (!isGlobalLookup) {
                        params.ownerPartyId = organizationPartyId;
                    }
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/lookupProduct?scanId=" + lookupId, {
                            params: params,
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _18.sent();
                    console.log('get lookup detail', response);
                    if (!(response.status === 200)) return [3 /*break*/, 10];
                    objToPush_1 = {};
                    if (response.data &&
                        response.data.responseMap &&
                        !response.data.responseMap.product &&
                        !response.data.responseMap.locationSeqId) {
                        setScannedLocationIncorrect(true);
                        setErrorMsgText('Incorrect UPC, Location or Container, scan again!');
                        return [2 /*return*/];
                    }
                    if (!(response.data &&
                        response.data.responseMap &&
                        !response.data.responseMap.product &&
                        response.data.responseMap.locationSeqId)) return [3 /*break*/, 5];
                    objToPush_1['locationSeqId'] = (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.responseMap) === null || _d === void 0 ? void 0 : _d.locationSeqId;
                    if (!(((_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.responseMap) === null || _f === void 0 ? void 0 : _f.assetList) &&
                        ((_h = (_g = response.data) === null || _g === void 0 ? void 0 : _g.responseMap) === null || _h === void 0 ? void 0 : _h.assetList.length) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            enumType: 'ContainerType',
                            fromLookup: true
                        }))];
                case 2:
                    _18.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getStatusList({
                            statusTypeId: 'Asset'
                        }))];
                case 3:
                    _18.sent();
                    containerTypesArray_1 = localStorage.getItem('containerEnumsList');
                    if (containerTypesArray_1) {
                        containerTypesArray_1 = JSON.parse(containerTypesArray_1);
                    }
                    else {
                        containerTypesArray_1 = [];
                    }
                    statusTypesArray_1 = localStorage.getItem('statusTypeList');
                    if (statusTypesArray_1) {
                        statusTypesArray_1 = JSON.parse(statusTypesArray_1);
                    }
                    else {
                        statusTypesArray_1 = [];
                    }
                    (_k = (_j = response.data) === null || _j === void 0 ? void 0 : _j.responseMap) === null || _k === void 0 ? void 0 : _k.assetList.forEach(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var containerTypeEnum_1, statusTypeId_1, containerEnumToMatch_1, statusToMatch_1;
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            if ((_a = item === null || item === void 0 ? void 0 : item.facilityLocationDetail) === null || _a === void 0 ? void 0 : _a.locationTypeEnumId) {
                                containerTypeEnum_1 = '';
                                statusTypeId_1 = '';
                                containerEnumToMatch_1 = item.containerDetail && item.containerDetail.containerTypeEnumId
                                    ? item.containerDetail.containerTypeEnumId
                                    : '';
                                containerTypesArray_1.forEach(function (item) {
                                    if (item.enumId === containerEnumToMatch_1) {
                                        containerTypeEnum_1 = item.description;
                                    }
                                });
                                statusToMatch_1 = item.statusId ? item.statusId : '';
                                statusTypesArray_1.forEach(function (item) {
                                    if (item.statusId === statusToMatch_1) {
                                        statusTypeId_1 = item.description;
                                    }
                                });
                                if (objToPush_1['locationsList'] && objToPush_1['locationsList'].length > 0) {
                                    objToPush_1['locationsList'].push({
                                        productName: item === null || item === void 0 ? void 0 : item.productName,
                                        sku: item === null || item === void 0 ? void 0 : item.productSku,
                                        upc: item === null || item === void 0 ? void 0 : item.productUpc,
                                        container: (_b = item === null || item === void 0 ? void 0 : item.containerDetail) === null || _b === void 0 ? void 0 : _b.serialNumber,
                                        containerType: containerTypeEnum_1,
                                        quantity: item === null || item === void 0 ? void 0 : item.quantityOnHandTotal,
                                        atp: item === null || item === void 0 ? void 0 : item.availableToPromiseTotal,
                                        status: statusTypeId_1,
                                        productImage: (_c = item === null || item === void 0 ? void 0 : item.image) !== null && _c !== void 0 ? _c : ''
                                    });
                                }
                                else {
                                    objToPush_1['locationsList'] = [];
                                    objToPush_1['locationsList'].push({
                                        productName: item === null || item === void 0 ? void 0 : item.productName,
                                        sku: item === null || item === void 0 ? void 0 : item.productSku,
                                        upc: item === null || item === void 0 ? void 0 : item.productUpc,
                                        container: (_d = item === null || item === void 0 ? void 0 : item.containerDetail) === null || _d === void 0 ? void 0 : _d.serialNumber,
                                        containerType: containerTypeEnum_1,
                                        quantity: item === null || item === void 0 ? void 0 : item.quantityOnHandTotal,
                                        atp: item === null || item === void 0 ? void 0 : item.availableToPromiseTotal,
                                        status: statusTypeId_1,
                                        productImage: (_e = item === null || item === void 0 ? void 0 : item.image) !== null && _e !== void 0 ? _e : ''
                                    });
                                }
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    _18.label = 4;
                case 4: return [3 /*break*/, 9];
                case 5:
                    objToPush_1['productName'] = (_o = (_m = (_l = response.data) === null || _l === void 0 ? void 0 : _l.responseMap) === null || _m === void 0 ? void 0 : _m.product) === null || _o === void 0 ? void 0 : _o.productName;
                    objToPush_1['ownedBy'] = (_r = (_q = (_p = response.data) === null || _p === void 0 ? void 0 : _p.responseMap) === null || _q === void 0 ? void 0 : _q.product) === null || _r === void 0 ? void 0 : _r.ownerPartyId;
                    objToPush_1['productType'] = (_t = (_s = response.data) === null || _s === void 0 ? void 0 : _s.responseMap) === null || _t === void 0 ? void 0 : _t.productTypeDescription;
                    if (((_v = (_u = response.data) === null || _u === void 0 ? void 0 : _u.responseMap) === null || _v === void 0 ? void 0 : _v.idList) && ((_x = (_w = response.data) === null || _w === void 0 ? void 0 : _w.responseMap) === null || _x === void 0 ? void 0 : _x.idList.length) > 0) {
                        (_z = (_y = response.data) === null || _y === void 0 ? void 0 : _y.responseMap) === null || _z === void 0 ? void 0 : _z.idList.forEach(function (item) {
                            if (item.idTypeId === 'PidtMfgModelNum') {
                                objToPush_1['mfgModelNumber'] = item.idValue;
                            }
                            else if (item.idTypeId === 'PidtSku') {
                                objToPush_1['sku'] = item.idValue;
                            }
                            else if (item.idTypeId === 'PidtUpca') {
                                objToPush_1['upca'] = item.idValue;
                            }
                        });
                    }
                    if (((_1 = (_0 = response.data) === null || _0 === void 0 ? void 0 : _0.responseMap) === null || _1 === void 0 ? void 0 : _1.featureList) &&
                        ((_3 = (_2 = response.data) === null || _2 === void 0 ? void 0 : _2.responseMap) === null || _3 === void 0 ? void 0 : _3.featureList.length) > 0) {
                        (_5 = (_4 = response.data) === null || _4 === void 0 ? void 0 : _4.responseMap) === null || _5 === void 0 ? void 0 : _5.featureList.forEach(function (item) {
                            if (item.productFeatureTypeEnumId === 'PftSize') {
                                objToPush_1['size'] = item.description;
                            }
                            else if (item.productFeatureTypeEnumId === 'PftColor') {
                                objToPush_1['color'] = item.description;
                            }
                        });
                    }
                    if (((_7 = (_6 = response.data) === null || _6 === void 0 ? void 0 : _6.responseMap) === null || _7 === void 0 ? void 0 : _7.contentList) &&
                        ((_9 = (_8 = response.data) === null || _8 === void 0 ? void 0 : _8.responseMap) === null || _9 === void 0 ? void 0 : _9.contentList.length) > 0) {
                        (_11 = (_10 = response.data) === null || _10 === void 0 ? void 0 : _10.responseMap) === null || _11 === void 0 ? void 0 : _11.contentList.forEach(function (item) {
                            if (item.productContentTypeEnumId === 'PcntImageUrlOriginal') {
                                objToPush_1['url'] = item.description;
                            }
                        });
                    }
                    if (!(((_13 = (_12 = response.data) === null || _12 === void 0 ? void 0 : _12.responseMap) === null || _13 === void 0 ? void 0 : _13.assetList) &&
                        ((_15 = (_14 = response.data) === null || _14 === void 0 ? void 0 : _14.responseMap) === null || _15 === void 0 ? void 0 : _15.assetList.length) > 0)) return [3 /*break*/, 9];
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            enumType: 'ContainerType',
                            fromLookup: true
                        }))];
                case 6:
                    _18.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            enumType: 'FacilityLocationType',
                            fromLookup: true
                        }))];
                case 7:
                    _18.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getStatusList({
                            statusTypeId: 'Asset'
                        }))];
                case 8:
                    _18.sent();
                    containerTypesArray_2 = localStorage.getItem('containerEnumsList');
                    if (containerTypesArray_2) {
                        containerTypesArray_2 = JSON.parse(containerTypesArray_2);
                    }
                    else {
                        containerTypesArray_2 = [];
                    }
                    locationTypesArray_1 = localStorage.getItem('locationEnumsList');
                    if (locationTypesArray_1) {
                        locationTypesArray_1 = JSON.parse(locationTypesArray_1);
                    }
                    else {
                        locationTypesArray_1 = [];
                    }
                    statusTypesArray_2 = localStorage.getItem('statusTypeList');
                    if (statusTypesArray_2) {
                        statusTypesArray_2 = JSON.parse(statusTypesArray_2);
                    }
                    else {
                        statusTypesArray_2 = [];
                    }
                    availableToPromiseTotal_1 = 0, quantityOnHandTotal_1 = 0;
                    (_17 = (_16 = response.data) === null || _16 === void 0 ? void 0 : _16.responseMap) === null || _17 === void 0 ? void 0 : _17.assetList.forEach(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var containerTypeEnum_2, locationTypeEnum_1, statusTypeId_2, containerEnumToMatch_2, locationEnumToMatch_1, statusToMatch_2;
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        return __generator(this, function (_j) {
                            availableToPromiseTotal_1 += (_a = item === null || item === void 0 ? void 0 : item.availableToPromiseTotal) !== null && _a !== void 0 ? _a : 0;
                            quantityOnHandTotal_1 += (_b = item === null || item === void 0 ? void 0 : item.quantityOnHandTotal) !== null && _b !== void 0 ? _b : 0;
                            if ((_c = item === null || item === void 0 ? void 0 : item.facilityLocationDetail) === null || _c === void 0 ? void 0 : _c.locationTypeEnumId) {
                                containerTypeEnum_2 = '';
                                locationTypeEnum_1 = '';
                                statusTypeId_2 = '';
                                containerEnumToMatch_2 = item.containerDetail && item.containerDetail.containerTypeEnumId
                                    ? item.containerDetail.containerTypeEnumId
                                    : '';
                                containerTypesArray_2.forEach(function (item) {
                                    if (item.enumId === containerEnumToMatch_2) {
                                        containerTypeEnum_2 = item.description;
                                    }
                                });
                                locationEnumToMatch_1 = item.facilityLocationDetail && item.facilityLocationDetail.locationTypeEnumId
                                    ? item.facilityLocationDetail.locationTypeEnumId
                                    : '';
                                locationTypesArray_1.forEach(function (item) {
                                    if (item.enumId === locationEnumToMatch_1) {
                                        locationTypeEnum_1 = item.description;
                                    }
                                });
                                statusToMatch_2 = item.statusId ? item.statusId : '';
                                statusTypesArray_2.forEach(function (item) {
                                    if (item.statusId === statusToMatch_2) {
                                        statusTypeId_2 = item.description;
                                    }
                                });
                                objToPush_1['productImage'] = (_d = item === null || item === void 0 ? void 0 : item.image) !== null && _d !== void 0 ? _d : '';
                                if (objToPush_1['locationsList'] && objToPush_1['locationsList'].length > 0) {
                                    objToPush_1['locationsList'].push({
                                        location: (_e = item.facilityLocationDetail) === null || _e === void 0 ? void 0 : _e.locationSeqId,
                                        locationType: locationTypeEnum_1,
                                        container: (_f = item === null || item === void 0 ? void 0 : item.containerDetail) === null || _f === void 0 ? void 0 : _f.serialNumber,
                                        containerType: containerTypeEnum_2,
                                        quantity: item === null || item === void 0 ? void 0 : item.quantityOnHandTotal,
                                        atp: item === null || item === void 0 ? void 0 : item.availableToPromiseTotal,
                                        status: statusTypeId_2
                                    });
                                }
                                else {
                                    objToPush_1['locationsList'] = [];
                                    objToPush_1['locationsList'].push({
                                        location: (_g = item.facilityLocationDetail) === null || _g === void 0 ? void 0 : _g.locationSeqId,
                                        locationType: locationTypeEnum_1,
                                        container: (_h = item === null || item === void 0 ? void 0 : item.containerDetail) === null || _h === void 0 ? void 0 : _h.serialNumber,
                                        containerType: containerTypeEnum_2,
                                        quantity: item === null || item === void 0 ? void 0 : item.quantityOnHandTotal,
                                        atp: item === null || item === void 0 ? void 0 : item.availableToPromiseTotal,
                                        status: statusTypeId_2
                                    });
                                }
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    objToPush_1['availableToPromiseTotal'] = availableToPromiseTotal_1;
                    objToPush_1['quantityOnHandTotal'] = quantityOnHandTotal_1;
                    _18.label = 9;
                case 9:
                    setScannedObj(objToPush_1);
                    setPrintPackingSliping('printPackingSlippinig');
                    return [2 /*return*/, response.data];
                case 10: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 11: return [3 /*break*/, 13];
                case 12:
                    e_36 = _18.sent();
                    console.log('Error', e_36.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_36.response.data)];
                case 13: return [2 /*return*/];
            }
        });
    });
});
export var getUserAssociatedOrganization = createAsyncThunk('auth/getUserAssociatedOrganization', function (setUserAssociationData, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, mappedArray, e_37;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                return [4 /*yield*/, axios.get('/rest/s1/handheld/user/organization', {
                        // params: {},
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    console.log('user associated organization', response);
                    mappedArray = response.data.organizationList.map(function (item) {
                        return {
                            key: item.partyId,
                            value: item.organizationName
                        };
                    });
                    // setUserAssociationData(mappedArray)
                    return [2 /*return*/, mappedArray];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_37 = _a.sent();
                console.log('Error', e_37.response.data);
                return [2 /*return*/, thunkAPI.rejectWithValue(e_37.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
// Integrated the receiveInventory REST API
export var receiveInventory = createAsyncThunk('auth/receiveInventory', function (_a, thunkAPI) {
    var data = _a.data;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, token, response, e_38;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    facilityId = localStorage.getItem('facilityId');
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("rest/s1/handheld/facility/" + facilityId + "/receiveInventory ", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('pick move item', response);
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: 'Inventory Received Successfully.'
                        });
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_38 = _b.sent();
                    console.log('Error', e_38.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_38.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_38.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get suggested locations
export var getSuggestedLocations = createAsyncThunk('auth/getSuggestedLocations', function (_a, thunkAPI) {
    var productId = _a.productId, setSuggestedLocations = _a.setSuggestedLocations, shipmentLocationTypeList = _a.shipmentLocationTypeList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, data, e_39;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scannedProductLocationDetails?scanId=" + productId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _e.sent();
                    if (response.status === 200) {
                        data = (_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.scannedProductLocationDetails) === null || _c === void 0 ? void 0 : _c.assetList) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                            var facilityLocation = shipmentLocationTypeList === null || shipmentLocationTypeList === void 0 ? void 0 : shipmentLocationTypeList.find(function (data) { return (data === null || data === void 0 ? void 0 : data.enumId) === (item === null || item === void 0 ? void 0 : item.locationTypeEnumId); });
                            return {
                                key: item === null || item === void 0 ? void 0 : item.locationSeqId,
                                value: (item === null || item === void 0 ? void 0 : item.locationSeqId) + " - " + (facilityLocation === null || facilityLocation === void 0 ? void 0 : facilityLocation.description)
                            };
                        });
                        setSuggestedLocations(data || []);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_39 = _e.sent();
                    console.log('Error', e_39.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_39.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get product location detail
export var getProductLocationDetail = createAsyncThunk('auth/getProductLocationDetail', function (_a, thunkAPI) {
    var scanLocationId = _a.scanLocationId, setProductLocationList = _a.setProductLocationList, setProductAssetList = _a.setProductAssetList, setProductName = _a.setProductName, setFromLocation = _a.setFromLocation, setErrorMsgText = _a.setErrorMsgText, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, productAssetList = _a.productAssetList, setToLocation = _a.setToLocation, setIsValue = _a.setIsValue, setIsProductDetail = _a.setIsProductDetail, setProductDetail = _a.setProductDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_4, token, facilityId, response, objToPush_2, locationTypesArray_2, e_40;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        return __generator(this, function (_t) {
            switch (_t.label) {
                case 0:
                    _t.trys.push([0, 8, , 9]);
                    console.log('\n🟢 === getProductLocationDetail CALLED ===');
                    console.log('🟢 scanLocationId:', scanLocationId);
                    originalSetErrorMsgText_4 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        console.log('🔴 AUTO-CAPTURE [MoveAsset]: setErrorMsgText called with:', msg);
                        originalSetErrorMsgText_4 === null || originalSetErrorMsgText_4 === void 0 ? void 0 : originalSetErrorMsgText_4(msg);
                        console.log('✅ AUTO-CAPTURE [MoveAsset]: Error captured');
                    };
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scannedProductLocationDetails?scanId=" + scanLocationId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _t.sent();
                    console.log('getProductLocationDetails', response);
                    if (!(response.status === 200)) return [3 /*break*/, 6];
                    if (!(((_b = response.data) === null || _b === void 0 ? void 0 : _b.messages) && ((_c = response.data) === null || _c === void 0 ? void 0 : _c.scannedProductLocationDetails))) return [3 /*break*/, 2];
                    setErrorMsgText('Incorrect product or location, scan again');
                    setScannedLocationIncorrect(true);
                    return [3 /*break*/, 5];
                case 2:
                    if (!((_d = response.data) === null || _d === void 0 ? void 0 : _d.scannedProductLocationDetails.productId)) return [3 /*break*/, 4];
                    setProductName((_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.scannedProductLocationDetails) === null || _f === void 0 ? void 0 : _f.productName);
                    setProductLocationList((_g = response.data) === null || _g === void 0 ? void 0 : _g.scannedProductLocationDetails);
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            enumType: 'FacilityLocationType',
                            fromLookup: true
                        }))];
                case 3:
                    _t.sent();
                    objToPush_2 = {};
                    locationTypesArray_2 = localStorage.getItem('locationEnumsList');
                    if (locationTypesArray_2) {
                        locationTypesArray_2 = JSON.parse(locationTypesArray_2);
                    }
                    else {
                        locationTypesArray_2 = [];
                    }
                    response.data.scannedProductLocationDetails.assetList.forEach(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var locationTypeEnum_2, locationEnumToMatch_2;
                        return __generator(this, function (_a) {
                            if (item.locationTypeEnumId) {
                                locationTypeEnum_2 = '';
                                locationEnumToMatch_2 = item === null || item === void 0 ? void 0 : item.locationTypeEnumId;
                                locationTypesArray_2.forEach(function (item) {
                                    if ((item === null || item === void 0 ? void 0 : item.enumId) === locationEnumToMatch_2) {
                                        locationTypeEnum_2 = item === null || item === void 0 ? void 0 : item.description;
                                    }
                                });
                                if (objToPush_2['assetList'] && objToPush_2['assetList'].length > 0) {
                                    objToPush_2['assetList'].push({
                                        locationSeqId: item === null || item === void 0 ? void 0 : item.locationSeqId,
                                        locationTypeEnumId: locationTypeEnum_2,
                                        availableToPromiseTotal: item === null || item === void 0 ? void 0 : item.availableToPromiseTotal,
                                        quantityOnHandTotal: item === null || item === void 0 ? void 0 : item.quantityOnHandTotal,
                                        statusDescription: item === null || item === void 0 ? void 0 : item.statusDescription
                                    });
                                }
                                else {
                                    objToPush_2['assetList'] = [];
                                    objToPush_2['assetList'].push({
                                        locationSeqId: item === null || item === void 0 ? void 0 : item.locationSeqId,
                                        locationTypeEnumId: locationTypeEnum_2,
                                        availableToPromiseTotal: item.availableToPromiseTotal,
                                        quantityOnHandTotal: item === null || item === void 0 ? void 0 : item.quantityOnHandTotal,
                                        statusDescription: item === null || item === void 0 ? void 0 : item.statusDescription
                                    });
                                }
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    setProductAssetList(objToPush_2['assetList']);
                    localStorage.setItem('scanLocationId', scanLocationId);
                    setIsProductDetail(true);
                    return [3 /*break*/, 5];
                case 4:
                    if (!localStorage.getItem('fromLocation')) {
                        setFromLocation((_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.scannedProductLocationDetails) === null || _j === void 0 ? void 0 : _j.locationSeqId);
                        setIsValue(true);
                        localStorage.setItem('fromLocation', (_l = (_k = response.data) === null || _k === void 0 ? void 0 : _k.scannedProductLocationDetails) === null || _l === void 0 ? void 0 : _l.locationSeqId);
                    }
                    else if ((_o = (_m = response.data) === null || _m === void 0 ? void 0 : _m.scannedProductLocationDetails) === null || _o === void 0 ? void 0 : _o.locationSeqId) {
                        setToLocation((_q = (_p = response.data) === null || _p === void 0 ? void 0 : _p.scannedProductLocationDetails) === null || _q === void 0 ? void 0 : _q.locationSeqId);
                        localStorage.setItem('toLocation', (_s = (_r = response.data) === null || _r === void 0 ? void 0 : _r.scannedProductLocationDetails) === null || _s === void 0 ? void 0 : _s.locationSeqId);
                    }
                    _t.label = 5;
                case 5: return [2 /*return*/, response];
                case 6: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_40 = _t.sent();
                    console.log('Error', e_40.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_40.response.data)];
                case 9: return [2 /*return*/];
            }
        });
    });
});
// move asset REST API
export var getMoveProduct = createAsyncThunk('auth/getMoveProduct', function (_a, thunkAPI) {
    var productId = _a.productId, quantity = _a.quantity, setQuantity = _a.setQuantity, setQtyFieldFocused = _a.setQtyFieldFocused, setIsProductDetail = _a.setIsProductDetail, setProductName = _a.setProductName, setFromLocation = _a.setFromLocation, setToLocation = _a.setToLocation, setMoveAssetsMessage = _a.setMoveAssetsMessage;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_41;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/moveProduct?productId=" + productId + "&locationSeqId=" + localStorage.getItem('fromLocation') + "&toLocationSeqId=" + localStorage.getItem('toLocation') + "&quantity=" + quantity, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('getMoveProductAsset', response);
                    if (response.status === 200) {
                        setMoveAssetsMessage(response.data.messages);
                        setIsProductDetail(false);
                        setQtyFieldFocused(false);
                        setQuantity('');
                        setProductName('');
                        setFromLocation('');
                        setToLocation('');
                        localStorage.removeItem('fromLocation');
                        localStorage.removeItem('toLocation');
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_41 = _b.sent();
                    console.log('Error', e_41.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_41.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getActiveOrg = createAsyncThunk('auth/getActiveOrg', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, e_42;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                return [4 /*yield*/, axios.get('/rest/s1/fp/user/activeOrganization', {
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _g.sent();
                console.log('get active org data', response);
                if (response.status === 200) {
                    if ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.organization) === null || _b === void 0 ? void 0 : _b.partyId) {
                        localStorage.setItem('activeOrgId', (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.organization) === null || _d === void 0 ? void 0 : _d.partyId);
                        localStorage.setItem('activeOrgName', (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.organization) === null || _f === void 0 ? void 0 : _f.organizationName);
                    }
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_42 = _g.sent();
                console.log('Error', e_42.response.data);
                return [2 /*return*/, thunkAPI.rejectWithValue(e_42.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var changeActiveOrg = createAsyncThunk('auth/changeActiveOrg', function (_a, thunkAPI) {
    var orgId = _a.orgId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_43;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put('/rest/s1/handheld/user/changeActiveOrganization', {
                            organizationPartyId: orgId
                        }, {
                            headers: {
                                //api_key: localStorage.getItem('apiKey'),
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('change active org data', response);
                    if (response.status === 200) {
                        localStorage.setItem('activeOrgId', orgId);
                        localStorage.setItem('isOrgSelected', 'true');
                        window.location.reload();
                        return [2 /*return*/, orgId];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_43 = _b.sent();
                    console.log('Error', e_43.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_43.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var searchPickRunId = createAsyncThunk('auth/searchPickRunId', function (_a, thunkAPI) {
    var pickRunId = _a.pickRunId, setPickRunErrorMsgText = _a.setPickRunErrorMsgText, setScannedPickRunIdIncorrect = _a.setScannedPickRunIdIncorrect, setPickRunDetails = _a.setPickRunDetails, setContinueBtnDisabled = _a.setContinueBtnDisabled, setLookUpVisible = _a.setLookUpVisible;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, pickRunItems, totalItemsCount_1, pickedItemsCount_1, itemsCountData, disableBtn_1, pickedItemsArr_2, locationData, results, key, item, pickedQuantity, quantity, obj, i, shipmentItem, newObj, e_44;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        return __generator(this, function (_6) {
            switch (_6.label) {
                case 0:
                    _6.trys.push([0, 14, , 15]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + localStorage.getItem('facilityId') + "/lookupPickRun?pickRunId=" + pickRunId + "&organizationPartyId=" + localStorage.getItem('activeOrgId'), {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _6.sent();
                    if (!response) {
                        setScannedPickRunIdIncorrect(true);
                        setPickRunErrorMsgText('Pick Run not found!');
                    }
                    if (!(response.status === 200)) return [3 /*break*/, 12];
                    return [4 /*yield*/, clearLocalStorage()];
                case 2:
                    _6.sent();
                    return [4 /*yield*/, localStorage.setItem('pickRunId', pickRunId)];
                case 3:
                    _6.sent();
                    pickRunItems = (response === null || response === void 0 ? void 0 : response.data) &&
                        ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.responseMap) &&
                        ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.responseMap) === null || _d === void 0 ? void 0 : _d.pickRun) &&
                        ((_g = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.responseMap) === null || _f === void 0 ? void 0 : _f.pickRun) === null || _g === void 0 ? void 0 : _g.items) &&
                        ((_l = (_k = (_j = (_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.responseMap) === null || _j === void 0 ? void 0 : _j.pickRun) === null || _k === void 0 ? void 0 : _k.items) === null || _l === void 0 ? void 0 : _l.length) > 0
                        ? (_p = (_o = (_m = response === null || response === void 0 ? void 0 : response.data) === null || _m === void 0 ? void 0 : _m.responseMap) === null || _o === void 0 ? void 0 : _o.pickRun) === null || _p === void 0 ? void 0 : _p.items
                        : [];
                    return [4 /*yield*/, localStorage.setItem('completeLocationData', JSON.stringify(pickRunItems))];
                case 4:
                    _6.sent();
                    totalItemsCount_1 = 0;
                    pickedItemsCount_1 = 1;
                    pickRunItems.forEach(function (item) {
                        if (item.quantity) {
                            totalItemsCount_1 += item.quantity;
                        }
                        if (item.pickedQuantity) {
                            pickedItemsCount_1 += item.pickedQuantity;
                        }
                    });
                    if (pickedItemsCount_1 > totalItemsCount_1) {
                        pickedItemsCount_1 = totalItemsCount_1;
                    }
                    console.log('====line 3813====totalItemsCount====pickedItemsCount==', totalItemsCount_1, pickedItemsCount_1);
                    itemsCountData = {
                        totalItemsCount: totalItemsCount_1,
                        pickedItemsCount: pickedItemsCount_1
                    };
                    return [4 /*yield*/, localStorage.setItem('itemsCountData', JSON.stringify(itemsCountData))];
                case 5:
                    _6.sent();
                    disableBtn_1 = false;
                    pickedItemsArr_2 = [];
                    pickRunItems === null || pickRunItems === void 0 ? void 0 : pickRunItems.forEach(function (item) {
                        if ((item === null || item === void 0 ? void 0 : item.exceptionTypeEnumId) || (item === null || item === void 0 ? void 0 : item.pickedQuantity) === (item === null || item === void 0 ? void 0 : item.quantity)) {
                            disableBtn_1 = true;
                            pickedItemsArr_2.push(item);
                        }
                        else {
                            disableBtn_1 = false;
                        }
                    });
                    if (!disableBtn_1) return [3 /*break*/, 9];
                    if (!(((_s = (_r = (_q = response === null || response === void 0 ? void 0 : response.data) === null || _q === void 0 ? void 0 : _q.responseMap) === null || _r === void 0 ? void 0 : _r.pickRun) === null || _s === void 0 ? void 0 : _s.statusId) === 'PrInProgress')) return [3 /*break*/, 7];
                    return [4 /*yield*/, localStorage.setItem('pickedItemsArr', JSON.stringify(pickedItemsArr_2))];
                case 6:
                    _6.sent();
                    setContinueBtnDisabled(false);
                    return [3 /*break*/, 8];
                case 7:
                    setContinueBtnDisabled(true);
                    _6.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, localStorage.setItem('pickedItemsArr', JSON.stringify(pickedItemsArr_2))];
                case 10:
                    _6.sent();
                    setContinueBtnDisabled(false);
                    _6.label = 11;
                case 11:
                    if (((_v = (_u = (_t = response === null || response === void 0 ? void 0 : response.data) === null || _t === void 0 ? void 0 : _t.responseMap) === null || _u === void 0 ? void 0 : _u.pickRun) === null || _v === void 0 ? void 0 : _v.pickRunTypeId) === 'PrtBulkPick') {
                        locationData = [];
                        results = (_z = (_y = (_x = (_w = response === null || response === void 0 ? void 0 : response.data) === null || _w === void 0 ? void 0 : _w.responseMap) === null || _x === void 0 ? void 0 : _x.pickRun) === null || _y === void 0 ? void 0 : _y.items) === null || _z === void 0 ? void 0 : _z.reduce(function (acc, curr) {
                            var productId = curr.productId, locationSeqId = curr.locationSeqId;
                            var key = productId + "-" + locationSeqId;
                            if (!acc[key]) {
                                acc[key] = [];
                            }
                            acc[key].push(curr);
                            return acc;
                        }, {});
                        for (key in results) {
                            item = results[key];
                            pickedQuantity = 0, quantity = 0;
                            obj = {};
                            if (Array.isArray(item)) {
                                for (i = 0; i < item.length; i++) {
                                    shipmentItem = item[i];
                                    pickedQuantity += shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.pickedQuantity;
                                    quantity += shipmentItem === null || shipmentItem === void 0 ? void 0 : shipmentItem.quantity;
                                    obj = shipmentItem;
                                }
                            }
                            newObj = Object.assign({}, obj, {
                                pickedQuantity: pickedQuantity,
                                quantity: quantity
                            });
                            locationData.push(newObj);
                        }
                        setPickRunDetails(__assign(__assign({}, (_1 = (_0 = response === null || response === void 0 ? void 0 : response.data) === null || _0 === void 0 ? void 0 : _0.responseMap) === null || _1 === void 0 ? void 0 : _1.pickRun), { items: locationData }));
                    }
                    else {
                        setPickRunDetails((_3 = (_2 = response === null || response === void 0 ? void 0 : response.data) === null || _2 === void 0 ? void 0 : _2.responseMap) === null || _3 === void 0 ? void 0 : _3.pickRun);
                    }
                    setLookUpVisible(true);
                    return [2 /*return*/, response];
                case 12: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 13: return [3 /*break*/, 15];
                case 14:
                    e_44 = _6.sent();
                    console.log('Error', (_4 = e_44.response) === null || _4 === void 0 ? void 0 : _4.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue((_5 = e_44.response) === null || _5 === void 0 ? void 0 : _5.data)];
                case 15: return [2 /*return*/];
            }
        });
    });
});
export var getRequiredContainerCount = createAsyncThunk('auth/getRequiredContainerCount', function (_a, thunkAPI) {
    var pickRunId = _a.pickRunId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_45;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    _m.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pickRun/" + pickRunId + "/pickContainerCount?facilityId=" + facilityId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _m.sent();
                    console.log('getRequiredContainerCount=====>', response);
                    if (response.status === 200) {
                        if ((response === null || response === void 0 ? void 0 : response.data) &&
                            ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.responseMap) &&
                            ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.responseMap) === null || _d === void 0 ? void 0 : _d.requiredPickContainerCount)) {
                            localStorage.setItem('requiredPickContainerCount', (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.responseMap) === null || _f === void 0 ? void 0 : _f.requiredPickContainerCount);
                        }
                        if ((response === null || response === void 0 ? void 0 : response.data) &&
                            ((_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.responseMap) &&
                            ((_j = (_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.responseMap) === null || _j === void 0 ? void 0 : _j.picklistContainerCounts)) {
                            localStorage.setItem('picklistContainerCounts', JSON.stringify((_l = (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.responseMap) === null || _l === void 0 ? void 0 : _l.picklistContainerCounts));
                        }
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_45 = _m.sent();
                    console.log('Error', e_45.response.data);
                    notification['error']({
                        message: 'Error',
                        description: e_45.response.data.errors
                    });
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_45.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getListOfPickRuns = createAsyncThunk('auth/getListOfPickRuns', function (_a, thunkAPI) {
    var setPickRunsList = _a.setPickRunsList, queryString = _a.queryString, statusId = _a.statusId, setMaxPageIndex = _a.setMaxPageIndex, setRecordCount = _a.setRecordCount, pageIndex = _a.pageIndex, _b = _a.allUsers, allUsers = _b === void 0 ? false : _b, appliedFilters = _a.appliedFilters, orderByFields = _a.orderByFields;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, userId, facilityId, activeOrgId, filtersArr, index, extractedQuery, joinedFilters, url, response, e_46;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    userId = localStorage.getItem('userId');
                    facilityId = localStorage.getItem('facilityId');
                    activeOrgId = localStorage.getItem('activeOrgId');
                    if (queryString) {
                        if (appliedFilters) {
                            filtersArr = appliedFilters.split("&");
                            index = filtersArr.findIndex(function (item) {
                                return item.includes("queryString");
                            });
                            if (index > -1) {
                                extractedQuery = filtersArr[index];
                                extractedQuery += " AND " + queryString;
                                filtersArr[index] = extractedQuery;
                                joinedFilters = filtersArr.join("&");
                                appliedFilters = joinedFilters;
                            }
                            else {
                                appliedFilters += "&queryString=" + queryString;
                            }
                        }
                        else {
                            appliedFilters += "queryString=" + queryString;
                        }
                    }
                    url = "/rest/s1/handheld/pickRun?pageSize=10&pageIndex=" + pageIndex;
                    if (appliedFilters) {
                        url = "/rest/s1/handheld/pickRun?pageSize=10&pageIndex=" + pageIndex + "&" + appliedFilters;
                    }
                    if (allUsers) {
                        url = "/rest/s1/handheld/pickRun/all?pageSize=10&pageIndex=" + pageIndex;
                        if (appliedFilters) {
                            url = "/rest/s1/handheld/pickRun/all?pageSize=10&pageIndex=" + pageIndex + "&" + appliedFilters;
                        }
                    }
                    return [4 /*yield*/, axios.get(url, {
                            params: __assign(__assign({}, (!allUsers && { userId: userId })), { facilityId: facilityId, statusId: statusId, orderByFields: orderByFields, organizationPartyId: activeOrgId }),
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    console.log('industry types data', response);
                    if (response.status === 200) {
                        setPickRunsList((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.pickRunList);
                        setRecordCount((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.pickRunListCount);
                        setMaxPageIndex(((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.pickRunListPageMaxIndex) + 1);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_46 = _f.sent();
                    console.log('Error', e_46.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_46.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getPickRunItemContainers = createAsyncThunk('auth/getPickRunItemContainers', function (_a, thunkAPI) {
    var pickRunId = _a.pickRunId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, goToLocationData_1, pickRunContainerList_1, hospitalContainers_1, packingStationContainers_1, resultArray_1, exceptionTrackingArray_1, orderContainerList_1, formattedResultsArray_1, e_47;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pickRun/" + pickRunId + "/itemContainers", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('getPickRunItemContainers=====', response);
                    if (response.status === 200) {
                        goToLocationData_1 = localStorage.getItem('completeLocationData');
                        if (goToLocationData_1) {
                            goToLocationData_1 = JSON.parse(goToLocationData_1);
                        }
                        else {
                            goToLocationData_1 = [];
                        }
                        pickRunContainerList_1 = localStorage.getItem('pickRunContainerList');
                        if (pickRunContainerList_1) {
                            pickRunContainerList_1 = JSON.parse(pickRunContainerList_1);
                        }
                        else {
                            pickRunContainerList_1 = [];
                        }
                        hospitalContainers_1 = localStorage.getItem('hospitalContainers');
                        if (hospitalContainers_1) {
                            hospitalContainers_1 = JSON.parse(hospitalContainers_1);
                        }
                        else {
                            hospitalContainers_1 = [];
                        }
                        packingStationContainers_1 = localStorage.getItem('packingStationContainers');
                        if (packingStationContainers_1) {
                            packingStationContainers_1 = JSON.parse(packingStationContainers_1);
                        }
                        else {
                            packingStationContainers_1 = [];
                        }
                        resultArray_1 = [];
                        if (response.data &&
                            response.data.pickRunItemContainerList &&
                            response.data.pickRunItemContainerList.length > 0) {
                            resultArray_1 = response.data.pickRunItemContainerList;
                        }
                        exceptionTrackingArray_1 = [];
                        goToLocationData_1.forEach(function (item) {
                            if (item.exceptionTypeEnumId) {
                                if (exceptionTrackingArray_1.indexOf("" + item.orderId + item.shipmentId) <= -1) {
                                    exceptionTrackingArray_1.push("" + item.orderId + item.shipmentId);
                                }
                            }
                        });
                        console.log('=====line 3994====exceptionTrackingArray=====', exceptionTrackingArray_1);
                        resultArray_1.forEach(function (item) {
                            goToLocationData_1.forEach(function (innerItem) {
                                if (item.pickRunId === innerItem.pickRunId &&
                                    item.pickRunItemId === innerItem.pickRunItemId) {
                                    if (innerItem.exceptionTypeEnumId) {
                                        var isFoundIndex_1 = -1;
                                        packingStationContainers_1.forEach(function (packItem, index) {
                                            if (packItem.orderId === "" + innerItem.orderId + innerItem.shipmentId) {
                                                isFoundIndex_1 = index;
                                            }
                                        });
                                        if (isFoundIndex_1 > -1) {
                                            packingStationContainers_1.splice(isFoundIndex_1, 1);
                                            localStorage.setItem('packingStationContainers', JSON.stringify(packingStationContainers_1));
                                        }
                                        var isExist_2 = false;
                                        hospitalContainers_1.forEach(function (hospitalItem) {
                                            if ("" + innerItem.orderId + innerItem.shipmentId === hospitalItem.orderId) {
                                                isExist_2 = true;
                                            }
                                        });
                                        if (!isExist_2) {
                                            var containerId_2 = '';
                                            pickRunContainerList_1.forEach(function (pickItem) {
                                                if (pickItem.containerId === item.containerId) {
                                                    containerId_2 = pickItem.serialNumber
                                                        ? pickItem.serialNumber
                                                        : pickItem.description
                                                            ? pickItem.description
                                                            : '';
                                                }
                                            });
                                            hospitalContainers_1.push({
                                                orderId: "" + innerItem.orderId + innerItem.shipmentId,
                                                containerId: containerId_2
                                            });
                                        }
                                    }
                                    else {
                                        var isExist_3 = false;
                                        packingStationContainers_1.forEach(function (packItem) {
                                            if ("" + innerItem.orderId + innerItem.shipmentId === packItem.orderId) {
                                                isExist_3 = true;
                                            }
                                        });
                                        var isExceptionMarked = false;
                                        if (exceptionTrackingArray_1.indexOf("" + innerItem.orderId + innerItem.shipmentId) > -1) {
                                            isExceptionMarked = true;
                                        }
                                        if (!isExist_3 && !isExceptionMarked) {
                                            var containerId_3 = '';
                                            pickRunContainerList_1.forEach(function (pickItem) {
                                                if (pickItem.containerId === item.containerId) {
                                                    containerId_3 = pickItem.serialNumber
                                                        ? pickItem.serialNumber
                                                        : pickItem.description
                                                            ? pickItem.description
                                                            : '';
                                                }
                                            });
                                            packingStationContainers_1.push({
                                                orderId: "" + innerItem.orderId + innerItem.shipmentId,
                                                containerId: containerId_3
                                            });
                                        }
                                    }
                                }
                            });
                        });
                        goToLocationData_1.forEach(function (item) {
                            var isFound = false;
                            resultArray_1.forEach(function (innerItem) {
                                if (item.pickRunId === innerItem.pickRunId &&
                                    item.pickRunItemId === innerItem.pickRunItemId) {
                                    isFound = true;
                                }
                            });
                            if (!isFound && item.exceptionTypeEnumId) {
                                var isFoundInHospitalArray_1 = false;
                                hospitalContainers_1.forEach(function (hospitalItem) {
                                    if ("" + item.orderId + item.shipmentId === hospitalItem.orderId) {
                                        isFoundInHospitalArray_1 = true;
                                    }
                                });
                                if (!isFoundInHospitalArray_1) {
                                    hospitalContainers_1.push({
                                        orderId: "" + item.orderId + item.shipmentId,
                                        containerId: ''
                                    });
                                }
                            }
                        });
                        localStorage.setItem('hospitalContainers', JSON.stringify(hospitalContainers_1));
                        localStorage.setItem('packingStationContainers', JSON.stringify(packingStationContainers_1));
                        orderContainerList_1 = [];
                        formattedResultsArray_1 = [];
                        resultArray_1.forEach(function (item) {
                            pickRunContainerList_1.forEach(function (innerItem) {
                                if (item.containerId === innerItem.containerId) {
                                    formattedResultsArray_1.push(__assign(__assign({}, item), { containerDescription: innerItem.serialNumber
                                            ? innerItem.serialNumber
                                            : innerItem.description
                                                ? innerItem.description
                                                : '' }));
                                }
                            });
                        });
                        console.log('======line 3773======formattedResultsArray====', formattedResultsArray_1);
                        formattedResultsArray_1.forEach(function (item) {
                            goToLocationData_1.forEach(function (innerItem) {
                                console.log('======line 3779====innerItem====', innerItem.pickRunId, innerItem.pickRunItemId, innerItem.orderId);
                                if (item.pickRunId === innerItem.pickRunId &&
                                    item.pickRunItemId === innerItem.pickRunItemId &&
                                    !innerItem.exceptionTypeEnumId) {
                                    var isFound_2 = false;
                                    orderContainerList_1.forEach(function (item) {
                                        if (item.orderId === "" + innerItem.orderId + innerItem.shipmentId &&
                                            item.containerId === item.containerDescription) {
                                            isFound_2 = true;
                                        }
                                    });
                                    if (!isFound_2) {
                                        orderContainerList_1.push({
                                            orderId: "" + innerItem.orderId + innerItem.shipmentId,
                                            containerId: item.containerDescription
                                        });
                                    }
                                }
                            });
                        });
                        localStorage.setItem('orderContainerList', JSON.stringify(orderContainerList_1));
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_47 = _b.sent();
                    console.log('Error', e_47.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_47.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var confirmDropoff = createAsyncThunk('auth/confirmDropoff', function (_a, thunkAPI) {
    var scanId = _a.scanId, fromHospital = _a.fromHospital, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, currentActiveSubscreen = _a.currentActiveSubscreen, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setErrorMsgText = _a.setErrorMsgText, pickMoveContainerToPackingStation = _a.pickMoveContainerToPackingStation, setPickMoveContainerToPackingStation = _a.setPickMoveContainerToPackingStation, pickRunTypeId = _a.pickRunTypeId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, hospitalContainers, packingStationContainers_2, pickRunContainerList_2, hospitalLocationSeqId, _loop_2, i, state_1, packingStationSeqId, i, _loop_3, i, state_2, e_48;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    _p.trys.push([0, 30, , 31]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral", {
                            params: {
                                scanId: scanId
                            },
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _p.sent();
                    console.log('confirmDropoff=====>', response);
                    if (!(response.status === 200)) return [3 /*break*/, 28];
                    hospitalContainers = localStorage.getItem('hospitalContainers');
                    if (hospitalContainers) {
                        hospitalContainers = JSON.parse(hospitalContainers);
                    }
                    else {
                        hospitalContainers = [];
                    }
                    packingStationContainers_2 = localStorage.getItem('packingStationContainers');
                    if (packingStationContainers_2) {
                        packingStationContainers_2 = JSON.parse(packingStationContainers_2);
                    }
                    else {
                        packingStationContainers_2 = [];
                    }
                    pickRunContainerList_2 = localStorage.getItem('pickRunContainerList');
                    if (pickRunContainerList_2) {
                        pickRunContainerList_2 = JSON.parse(pickRunContainerList_2);
                    }
                    else {
                        pickRunContainerList_2 = [];
                    }
                    if (!fromHospital) return [3 /*break*/, 11];
                    if (!(response.data.facilityLocation &&
                        response.data.facilityLocation.locationTypeEnumId === 'FltResearch')) return [3 /*break*/, 9];
                    hospitalLocationSeqId = ((_b = response.data) === null || _b === void 0 ? void 0 : _b.locationSeqId)
                        ? (_c = response.data) === null || _c === void 0 ? void 0 : _c.locationSeqId
                        : ((_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.facilityLocation) === null || _e === void 0 ? void 0 : _e.locationSeqId)
                            ? (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.facilityLocation) === null || _g === void 0 ? void 0 : _g.locationSeqId
                            : '';
                    return [4 /*yield*/, localStorage.setItem('pickMoveLocationSeqId', hospitalLocationSeqId)
                        // if (hospitalContainers && hospitalContainers.length > 0) {
                        // for (let i = 0; i < hospitalContainers.length; i++) {
                        //   if (hospitalContainers[i]['containerId']) {
                        //     if (localStorage.getItem('isConfirmDropoffAborted') !== 'true') {
                        //       let updatedContainerId = ''
                        //       pickRunContainerList.forEach((item: any) => {
                        //         if (
                        //           item.description === hospitalContainers[i]['containerId'] ||
                        //           item.serialNumber === hospitalContainers[i]['containerId']
                        //         ) {
                        //           updatedContainerId = item.containerId
                        //         }
                        //       })
                        //       await thunkAPI.dispatch(
                        //         pickMoveOnConfirmDropoff({
                        //           containerId: updatedContainerId,
                        //           setPickMoveContainerToPackingStation
                        //         })
                        //       )
                        //     } else {
                        //       break
                        //     }
                        //   }
                        // }
                    ];
                case 2:
                    _p.sent();
                    _loop_2 = function (i) {
                        var isFound_3;
                        return __generator(this, function (_q) {
                            switch (_q.label) {
                                case 0:
                                    if (!(localStorage.getItem('isConfirmDropoffAborted') !== 'true')) return [3 /*break*/, 3];
                                    isFound_3 = false;
                                    packingStationContainers_2.forEach(function (item) {
                                        if (item.containerId.toLowerCase() ===
                                            pickRunContainerList_2[i]['serialNumber'].toLowerCase() ||
                                            item.containerId.toLowerCase() ===
                                                pickRunContainerList_2[i]['description'].toLowerCase()) {
                                            isFound_3 = true;
                                        }
                                    });
                                    if (!!isFound_3) return [3 /*break*/, 2];
                                    return [4 /*yield*/, thunkAPI.dispatch(pickMoveOnConfirmDropoff({
                                            containerId: pickRunContainerList_2[i]['containerId'],
                                            setPickMoveContainerToPackingStation: setPickMoveContainerToPackingStation
                                        }))];
                                case 1:
                                    _q.sent();
                                    _q.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3: return [2 /*return*/, "break"];
                                case 4: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _p.label = 3;
                case 3:
                    if (!(i < pickRunContainerList_2.length)) return [3 /*break*/, 6];
                    return [5 /*yield**/, _loop_2(i)];
                case 4:
                    state_1 = _p.sent();
                    if (state_1 === "break")
                        return [3 /*break*/, 6];
                    _p.label = 5;
                case 5:
                    i++;
                    return [3 /*break*/, 3];
                case 6:
                    if (!pickMoveContainerToPackingStation) return [3 /*break*/, 8];
                    return [4 /*yield*/, localStorage.removeItem('isConfirmDropoffAborted')];
                case 7:
                    _p.sent();
                    if (packingStationContainers_2.length > 0) {
                        setCurrentActiveSubscreen('packingStationLocation');
                    }
                    else {
                        setCurrentActiveSubscreen('completion');
                    }
                    _p.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect location, scan again');
                    _p.label = 10;
                case 10: return [3 /*break*/, 27];
                case 11:
                    if (!(response.data.facilityLocation &&
                        response.data.facilityLocation.locationTypeEnumId === 'FltPack')) return [3 /*break*/, 26];
                    packingStationSeqId = ((_h = response.data) === null || _h === void 0 ? void 0 : _h.locationSeqId)
                        ? (_j = response.data) === null || _j === void 0 ? void 0 : _j.locationSeqId
                        : ((_l = (_k = response.data) === null || _k === void 0 ? void 0 : _k.facilityLocation) === null || _l === void 0 ? void 0 : _l.locationSeqId)
                            ? (_o = (_m = response.data) === null || _m === void 0 ? void 0 : _m.facilityLocation) === null || _o === void 0 ? void 0 : _o.locationSeqId
                            : '';
                    return [4 /*yield*/, localStorage.setItem('pickMoveLocationSeqId', packingStationSeqId)];
                case 12:
                    _p.sent();
                    if (!(pickRunTypeId !== 'PrtSingle' &&
                        pickRunTypeId !== 'PrtOrderLevel' &&
                        pickRunContainerList_2 &&
                        pickRunContainerList_2.length > 0)) return [3 /*break*/, 19];
                    i = 0;
                    _p.label = 13;
                case 13:
                    if (!(i < pickRunContainerList_2.length)) return [3 /*break*/, 17];
                    if (!(localStorage.getItem('isConfirmDropoffAborted') !== 'true')) return [3 /*break*/, 15];
                    return [4 /*yield*/, thunkAPI.dispatch(pickMoveOnConfirmDropoff({
                            containerId: pickRunContainerList_2[i]['containerId'],
                            setPickMoveContainerToPackingStation: setPickMoveContainerToPackingStation
                        }))];
                case 14:
                    _p.sent();
                    return [3 /*break*/, 16];
                case 15: return [3 /*break*/, 17];
                case 16:
                    i++;
                    return [3 /*break*/, 13];
                case 17:
                    if (!pickMoveContainerToPackingStation) return [3 /*break*/, 19];
                    return [4 /*yield*/, localStorage.removeItem('isConfirmDropoffAborted')];
                case 18:
                    _p.sent();
                    setCurrentActiveSubscreen('completion');
                    _p.label = 19;
                case 19:
                    if (!((pickRunTypeId === 'PrtSingle' || pickRunTypeId === 'PrtOrderLevel') &&
                        packingStationContainers_2 &&
                        packingStationContainers_2.length > 0)) return [3 /*break*/, 25];
                    _loop_3 = function (i) {
                        var isExist_4, updatedContainerId_1;
                        return __generator(this, function (_r) {
                            switch (_r.label) {
                                case 0:
                                    if (!packingStationContainers_2[i]['containerId']) return [3 /*break*/, 3];
                                    isExist_4 = false;
                                    hospitalContainers.forEach(function (item) {
                                        if (item.containerId === packingStationContainers_2[i]['containerId']) {
                                            isExist_4 = true;
                                        }
                                    });
                                    if (!!isExist_4) return [3 /*break*/, 3];
                                    if (!(localStorage.getItem('isConfirmDropoffAborted') !== 'true')) return [3 /*break*/, 2];
                                    updatedContainerId_1 = '';
                                    pickRunContainerList_2.forEach(function (item) {
                                        if (item.serialNumber === packingStationContainers_2[i]['containerId'] ||
                                            item.description === packingStationContainers_2[i]['containerId']) {
                                            updatedContainerId_1 = item.containerId;
                                        }
                                    });
                                    return [4 /*yield*/, thunkAPI.dispatch(pickMoveOnConfirmDropoff({
                                            containerId: updatedContainerId_1,
                                            setPickMoveContainerToPackingStation: setPickMoveContainerToPackingStation
                                        }))];
                                case 1:
                                    _r.sent();
                                    return [3 /*break*/, 3];
                                case 2: return [2 /*return*/, "break"];
                                case 3: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _p.label = 20;
                case 20:
                    if (!(i < packingStationContainers_2.length)) return [3 /*break*/, 23];
                    return [5 /*yield**/, _loop_3(i)];
                case 21:
                    state_2 = _p.sent();
                    if (state_2 === "break")
                        return [3 /*break*/, 23];
                    _p.label = 22;
                case 22:
                    i++;
                    return [3 /*break*/, 20];
                case 23:
                    if (!pickMoveContainerToPackingStation) return [3 /*break*/, 25];
                    return [4 /*yield*/, localStorage.removeItem('isConfirmDropoffAborted')];
                case 24:
                    _p.sent();
                    setCurrentActiveSubscreen('completion');
                    _p.label = 25;
                case 25: return [3 /*break*/, 27];
                case 26:
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect location, scan again');
                    _p.label = 27;
                case 27: return [2 /*return*/, response];
                case 28: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 29: return [3 /*break*/, 31];
                case 30:
                    e_48 = _p.sent();
                    console.log('Error', e_48.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_48.response.data)];
                case 31: return [2 /*return*/];
            }
        });
    });
});
export var pickMoveOnConfirmDropoff = createAsyncThunk('auth/pickMoveOnConfirmDropoff', function (_a, thunkAPI) {
    var containerId = _a.containerId, setPickMoveContainerToPackingStation = _a.setPickMoveContainerToPackingStation;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, token, dataObj, response, e_49;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 6, , 7]);
                    facilityId = localStorage.getItem('facilityId');
                    token = localStorage.getItem('moquiSessionToken');
                    dataObj = {
                        locationSeqId: localStorage.getItem('pickMoveLocationSeqId'),
                        containerId: containerId,
                        pickRunId: localStorage.getItem('pickRunId')
                    };
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/facility/" + facilityId + "/pickMovePickContainer", dataObj, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('pick move item', response);
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    if (!(response.data && response.data.result === false)) return [3 /*break*/, 3];
                    setPickMoveContainerToPackingStation(false);
                    return [4 /*yield*/, localStorage.setItem('isConfirmDropoffAborted', 'true')];
                case 2:
                    _b.sent();
                    notification['error']({
                        message: 'Something went wrong, please try again.'
                    });
                    _b.label = 3;
                case 3: return [2 /*return*/, response];
                case 4: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_49 = _b.sent();
                    console.log('Error', e_49.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_49.response.data)];
                case 7: return [2 /*return*/];
            }
        });
    });
});
export var lookupGeneral = createAsyncThunk('auth/lookupGeneral', function (_a, thunkAPI) {
    var scanId = _a.scanId, setErrorMsgText = _a.setErrorMsgText, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, setScannedObj = _a.setScannedObj, setPrintPackingSliping = _a.setPrintPackingSliping, setLookUpProductList = _a.setLookUpProductList, setLookUpContainerDetails = _a.setLookUpContainerDetails, setEnumTypeList = _a.setEnumTypeList, _b = _a.isGlobalLookup, isGlobalLookup = _b === void 0 ? false : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, organizationPartyId, facilityId, params, response, e_50;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 7, , 8]);
                    token = localStorage.getItem('moquiSessionToken');
                    organizationPartyId = localStorage.getItem('activeOrgId');
                    facilityId = localStorage.getItem('facilityId');
                    params = {};
                    if (!isGlobalLookup) {
                        params.ownerPartyId = organizationPartyId;
                    }
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanId, {
                            params: params,
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _e.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 5];
                    if (!(response.data.productId || response.data.locationSeqId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, thunkAPI.dispatch(getLookup({
                            lookupId: scanId,
                            setErrorMsgText: setErrorMsgText,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setScannedObj: setScannedObj,
                            setPrintPackingSliping: setPrintPackingSliping,
                            isGlobalLookup: isGlobalLookup
                        }))];
                case 2:
                    _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setScannedLocationIncorrect(true);
                    setErrorMsgText('Incorrect Product SKU/UPC or Facility Location, scan again!');
                    _e.label = 4;
                case 4: return [2 /*return*/, response.data];
                case 5: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 6: return [3 /*break*/, 8];
                case 7:
                    e_50 = _e.sent();
                    console.log('❌ LOOKUP GENERAL API ERROR CAUGHT:');
                    console.log('  📍 Error Object:', e_50);
                    console.log('  📍 Response Data:', (_c = e_50.response) === null || _c === void 0 ? void 0 : _c.data);
                    console.log('  📍 Status Code:', (_d = e_50.response) === null || _d === void 0 ? void 0 : _d.status);
                    console.log('  📍 Error Message:', e_50.message);
                    console.log('  📍 Full Response:', JSON.stringify(e_50.response, null, 2));
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_50.response.data)];
                case 8: return [2 /*return*/];
            }
        });
    });
});
//Scan Shipment Id Rest Api For Receiving screen
export var getScannedCartForReceiving = createAsyncThunk('auth/getScannedCartForReceiving', function (_a, thunkAPI) {
    var scanId = _a.scanId, setErrorMsgText = _a.setErrorMsgText, functionCall = _a.functionCall, setScanShipmentIncorrect = _a.setScanShipmentIncorrect, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, setReceivingLocationIncorrect = _a.setReceivingLocationIncorrect, setScanProductUpcIncorrect = _a.setScanProductUpcIncorrect, setScanRecivingAgainstShipmentIncorrect = _a.setScanRecivingAgainstShipmentIncorrect, setScannedLpIncorrect = _a.setScannedLpIncorrect, setShipmentIdData = _a.setShipmentIdData, setShipmentId = _a.setShipmentId, shipmentId = _a.shipmentId, setShipmentContainerList = _a.setShipmentContainerList, shipmentContainerList = _a.shipmentContainerList, setCreateSuccessfully = _a.setCreateSuccessfully, setScanReceivingLocationData = _a.setScanReceivingLocationData, setScanProductData = _a.setScanProductData, shipmentItemDetailList = _a.shipmentItemDetailList, setAlreadyScannedProductId = _a.setAlreadyScannedProductId, alreadyScannedProductId = _a.alreadyScannedProductId, setIsDamagedStagingLocation = _a.setIsDamagedStagingLocation, setCurrContainerId = _a.setCurrContainerId, currContainerId = _a.currContainerId, setScanNewIncorrect = _a.setScanNewIncorrect, setScanNewLocationData = _a.setScanNewLocationData, setLookupContainerInformationIncorrect = _a.setLookupContainerInformationIncorrect, setLookupContainerList = _a.setLookupContainerList, existingContainerId = _a.existingContainerId, fromScanNewLocation = _a.fromScanNewLocation, setLookupLocationData = _a.setLookupLocationData, setScanOriginLocationIncorrect = _a.setScanOriginLocationIncorrect, setScannedContainerId = _a.setScannedContainerId, setIsMoveConatiner = _a.setIsMoveConatiner, currentScanItemDetail = _a.currentScanItemDetail, setCurrentScanItemDetail = _a.setCurrentScanItemDetail, setLotList = _a.setLotList, setOrganizationLotList = _a.setOrganizationLotList, setSuggestedLocations = _a.setSuggestedLocations, shipmentLocationTypeList = _a.shipmentLocationTypeList;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_5, token, facilityId, activeOrgId, response_4, isExist, associatedProductDetail_1, incorrectProductHandler, shipmentContainArr, e_51;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56;
        return __generator(this, function (_57) {
            switch (_57.label) {
                case 0:
                    _57.trys.push([0, 12, , 13]);
                    console.log('\n🟢🟢🟢 === getScannedCartForReceiving CALLED ===');
                    console.log('🟢 scanId:', scanId);
                    console.log('🟢 functionCall:', functionCall);
                    console.log('🟢 Time:', new Date().toISOString());
                    console.log('🟢 ============================================\n');
                    // FORCE ALERT ON FUNCTION ENTRY
                    alert('⚠️ getScannedCartForReceiving CALLED\nScanId: ' + scanId + '\nFunctionCall: ' + functionCall);
                    // CRITICAL FIX: Wrap setErrorMsgText to auto-capture ALL errors in this function
                    console.log('🔧🔧🔧 INSTALLING AUTO-CAPTURE WRAPPER...');
                    console.log('🔧 Original setErrorMsgText type:', typeof setErrorMsgText);
                    console.log('🔧 Original setErrorMsgText:', (setErrorMsgText === null || setErrorMsgText === void 0 ? void 0 : setErrorMsgText.name) || 'anonymous');
                    originalSetErrorMsgText_5 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        console.log('\n');
                        console.log('╔═══════════════════════════════════════════════════════════╗');
                        console.log('║   🔴🔴🔴 AUTO-CAPTURE WRAPPER TRIGGERED! 🔴🔴🔴            ║');
                        console.log('╚═══════════════════════════════════════════════════════════╝');
                        console.log('📝 Error Message:', msg);
                        console.log('🔧 Calling original setErrorMsgText...');
                        originalSetErrorMsgText_5 === null || originalSetErrorMsgText_5 === void 0 ? void 0 : originalSetErrorMsgText_5(msg);
                        console.log('✅ UI error message set');
                        console.log('✅✅✅ AUTO-CAPTURE COMPLETE ✅✅✅\n');
                    };
                    console.log('✅✅✅ AUTO-CAPTURE WRAPPER INSTALLED SUCCESSFULLY ✅✅✅');
                    console.log('🎯 Now any call to setErrorMsgText will automatically capture to ErrorStore\n');
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    activeOrgId = localStorage.getItem('activeOrgId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanId + "&ownerPartyId=" + activeOrgId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response_4 = _57.sent();
                    if (!(response_4.status === 200)) return [3 /*break*/, 10];
                    console.log('currContainerId------>', currContainerId, 'shipmentId', shipmentId);
                    console.log('\n🔴🔴🔴 CRITICAL CHECK - functionCall value:', functionCall);
                    console.log('🔴🔴🔴 CRITICAL CHECK - Is onShipmentIdScan?', functionCall === 'onShipmentIdScan');
                    console.log('🔴🔴🔴 CRITICAL CHECK - Is onReceiveAgainstShipmentIdScan?', functionCall === 'onReceiveAgainstShipmentIdScan');
                    if (functionCall === 'onReceiveAgainstShipmentIdScan') {
                        if (((_b = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _b === void 0 ? void 0 : _b.messages) || ((_c = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _c === void 0 ? void 0 : _c.facilityLocation)) {
                            console.log('❌ onReceiveAgainstShipmentIdScan - Error detected');
                            setErrorMsgText('Incorrect shipment ID, scan again');
                            setScanRecivingAgainstShipmentIncorrect(true);
                        }
                        else if (((_e = (_d = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _d === void 0 ? void 0 : _d.product) === null || _e === void 0 ? void 0 : _e.productId) ||
                            ((_g = (_f = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _f === void 0 ? void 0 : _f.container) === null || _g === void 0 ? void 0 : _g.serialNumber)) {
                            setCurrentActiveSubscreen(subscreenName);
                            setScanRecivingAgainstShipmentIncorrect(false);
                            setScanShipmentIncorrect(false);
                        }
                    }
                    if (functionCall === 'onShipmentIdScan') {
                        console.log('\n═══════════════════════════════════════════════════════════');
                        console.log('🎯 [VALIDATION CHECK] onShipmentIdScan validation triggered');
                        console.log('═══════════════════════════════════════════════════════════');
                        console.log('🔍 DEBUG: onShipmentIdScan called with scanId:', scanId);
                        console.log('📦 DEBUG: API Response:', JSON.stringify(response_4 === null || response_4 === void 0 ? void 0 : response_4.data, null, 2));
                        console.log('🔍 Checking if error conditions met...');
                        console.log('   - Has messages?', !!((_h = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _h === void 0 ? void 0 : _h.messages));
                        console.log('   - Has facilityLocation?', !!((_j = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _j === void 0 ? void 0 : _j.facilityLocation));
                        console.log('   - Has container.containerId?', !!((_l = (_k = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _k === void 0 ? void 0 : _k.container) === null || _l === void 0 ? void 0 : _l.containerId));
                        if (((_m = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _m === void 0 ? void 0 : _m.messages) ||
                            ((_o = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _o === void 0 ? void 0 : _o.facilityLocation) ||
                            ((_q = (_p = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _p === void 0 ? void 0 : _p.container) === null || _q === void 0 ? void 0 : _q.containerId)) {
                            setScanShipmentIncorrect(true);
                            setErrorMsgText('Incorrect shipment ID, scan again');
                        }
                        else if ((_s = (_r = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _r === void 0 ? void 0 : _r.product) === null || _s === void 0 ? void 0 : _s.productId) {
                            console.log('✅ Valid product found');
                            setCurrentActiveSubscreen(subscreenName);
                            setScanShipmentIncorrect(false);
                            setShipmentIdData(response_4 === null || response_4 === void 0 ? void 0 : response_4.data);
                            setShipmentId(scanId);
                        }
                        else {
                            // FALLBACK: If no specific condition matched but we have an error indicator
                            console.log('⚠️ FALLBACK: No specific condition matched');
                            console.log('⚠️ response.data:', response_4 === null || response_4 === void 0 ? void 0 : response_4.data);
                            // Check if there's ANY error indicator
                            if (!((_u = (_t = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _t === void 0 ? void 0 : _t.product) === null || _u === void 0 ? void 0 : _u.productId) && !((_v = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _v === void 0 ? void 0 : _v.shipment)) {
                                console.log('❌ FALLBACK ERROR CAPTURE - Invalid scan detected');
                                setErrorMsgText('Invalid scan - please scan correct shipment ID');
                                setScanShipmentIncorrect(true);
                            }
                        }
                    }
                    if (functionCall === 'scanReceivingLocation') {
                        if (((_w = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _w === void 0 ? void 0 : _w.messages) ||
                            (
                            // response?.data?.container?.containerId ||
                            // response?.data?.product?.productId ||
                            // (response?.data?.facilityId && response?.data?.productId) ||
                            (_x = ['FltCart', 'FltPack']) === null || _x === void 0 ? void 0 : _x.includes((_z = (_y = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _y === void 0 ? void 0 : _y.facilityLocation) === null || _z === void 0 ? void 0 : _z.locationTypeEnumId))) {
                            setErrorMsgText('Incorrect receiving location, scan again');
                            setReceivingLocationIncorrect(true);
                        }
                        else {
                            setScanReceivingLocationData((_0 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _0 === void 0 ? void 0 : _0.locationSeqId);
                            // const newCurrentScanItemDetail = {
                            //   ...currentScanItemDetail,
                            //   locationSeqId: response?.data?.locationSeqId
                            // }
                            // console.log(newCurrentScanItemDetail)
                            // setCurrentScanItemDetail(newCurrentScanItemDetail)
                            setCurrentActiveSubscreen(subscreenName);
                            setReceivingLocationIncorrect(false);
                        }
                    }
                    if (functionCall === 'scanNewLocation') {
                        if (((_1 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _1 === void 0 ? void 0 : _1.messages) ||
                            ((_3 = (_2 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _2 === void 0 ? void 0 : _2.product) === null || _3 === void 0 ? void 0 : _3.productId) ||
                            (((_4 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _4 === void 0 ? void 0 : _4.facilityId) && ((_5 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _5 === void 0 ? void 0 : _5.productId)) ||
                            ((_6 = ['FltCart', 'FltPack']) === null || _6 === void 0 ? void 0 : _6.includes((_8 = (_7 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _7 === void 0 ? void 0 : _7.facilityLocation) === null || _8 === void 0 ? void 0 : _8.locationTypeEnumId))) {
                            if (subscreenName === 'movingContainer') {
                                setErrorMsgText('Invalid item, please scan again');
                                setLookupContainerInformationIncorrect(true);
                            }
                            else {
                                setErrorMsgText('Incorrect location, scan again');
                                setScanNewIncorrect(true);
                            }
                        }
                        else if (!['FltPack', 'FltCart'].includes((_10 = (_9 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _9 === void 0 ? void 0 : _9.facilityLocation) === null || _10 === void 0 ? void 0 : _10.locationTypeEnumId) ||
                            ((_12 = (_11 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _11 === void 0 ? void 0 : _11.container) === null || _12 === void 0 ? void 0 : _12.containerTypeEnumId) === 'CtMovable') {
                            isExist = existingContainerId === null || existingContainerId === void 0 ? void 0 : existingContainerId.some(function (containerItem) {
                                if (containerItem.containerId === scanId)
                                    return true;
                                return false;
                            });
                            if (isExist || fromScanNewLocation) {
                                setCurrentActiveSubscreen(subscreenName);
                                if (subscreenName === 'movingContainer') {
                                    setLookupContainerInformationIncorrect(false);
                                    setLookupContainerList((_13 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _13 === void 0 ? void 0 : _13.containerId);
                                    setScannedContainerId(scanId);
                                    if ((_14 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _14 === void 0 ? void 0 : _14.containerId) {
                                        setIsMoveConatiner(true);
                                    }
                                }
                                else {
                                    setScanNewIncorrect(false);
                                    setScanNewLocationData(((_15 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _15 === void 0 ? void 0 : _15.locationSeqId) || ((_16 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _16 === void 0 ? void 0 : _16.containerId));
                                }
                            }
                            else {
                                if (subscreenName === 'movingContainer') {
                                    setErrorMsgText('Invalid item, please scan again');
                                    setLookupContainerInformationIncorrect(true);
                                }
                                else {
                                    setScanNewIncorrect(true);
                                    setErrorMsgText('Incorrect Location, scan again');
                                }
                            }
                        }
                        else {
                            if (subscreenName === 'movingContainer') {
                                setLookupContainerInformationIncorrect(true);
                                setErrorMsgText('Invalid item, please scan again');
                            }
                            else {
                                setScanNewIncorrect(true);
                                setErrorMsgText('Incorrect Location, scan again');
                            }
                        }
                    }
                    if (functionCall === 'scanDamagedStagingLocation') {
                        if (((_17 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _17 === void 0 ? void 0 : _17.messages) ||
                            ((_19 = (_18 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _18 === void 0 ? void 0 : _18.container) === null || _19 === void 0 ? void 0 : _19.containerId) ||
                            ((_21 = (_20 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _20 === void 0 ? void 0 : _20.product) === null || _21 === void 0 ? void 0 : _21.productId) ||
                            (((_22 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _22 === void 0 ? void 0 : _22.facilityId) && ((_23 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _23 === void 0 ? void 0 : _23.productId)) ||
                            ((_25 = (_24 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _24 === void 0 ? void 0 : _24.facilityLocation) === null || _25 === void 0 ? void 0 : _25.locationTypeEnumId) === 'FltCart') {
                            setErrorMsgText('Incorrect receiving location, scan again');
                            setReceivingLocationIncorrect(true);
                        }
                        else if (((_27 = (_26 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _26 === void 0 ? void 0 : _26.facilityLocation) === null || _27 === void 0 ? void 0 : _27.locationTypeEnumId) === 'FltPod') {
                            setScanReceivingLocationData((_28 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _28 === void 0 ? void 0 : _28.locationSeqId);
                            setReceivingLocationIncorrect(false);
                            setIsDamagedStagingLocation(true);
                        }
                    }
                    if (functionCall === 'scanProductUpc') {
                        if ((_29 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _29 === void 0 ? void 0 : _29.productId) {
                            associatedProductDetail_1 = shipmentItemDetailList === null || shipmentItemDetailList === void 0 ? void 0 : shipmentItemDetailList.filter(function (shipmentItem) { var _a; return shipmentItem.productId === ((_a = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _a === void 0 ? void 0 : _a.productId); });
                            incorrectProductHandler = function (already) {
                                var _a, _b;
                                setScanProductUpcIncorrect(true);
                                setErrorMsgText("" + (already === true
                                    ? "This productId is already scanned"
                                    : ((_a = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _a === void 0 ? void 0 : _a.messages)
                                        ? (_b = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _b === void 0 ? void 0 : _b.messages
                                        : "This product is not associated with the shipment."));
                            };
                            if (Array.isArray(associatedProductDetail_1) && (associatedProductDetail_1 === null || associatedProductDetail_1 === void 0 ? void 0 : associatedProductDetail_1.length) > 0) {
                                if (((_30 = associatedProductDetail_1[0]) === null || _30 === void 0 ? void 0 : _30.ownerPartyId) !== activeOrgId) {
                                    setScanProductUpcIncorrect(true);
                                    setErrorMsgText("Incorrect Product Upc, Org don't match");
                                    return [2 /*return*/];
                                }
                            }
                            if ((Array.isArray(associatedProductDetail_1) && !(associatedProductDetail_1 === null || associatedProductDetail_1 === void 0 ? void 0 : associatedProductDetail_1.length)) ||
                                (Array.isArray(associatedProductDetail_1) &&
                                    ((_32 = (_31 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _31 === void 0 ? void 0 : _31.messages) === null || _32 === void 0 ? void 0 : _32.includes('Found multiple products')))) {
                                if (Array.isArray(alreadyScannedProductId) && !(alreadyScannedProductId === null || alreadyScannedProductId === void 0 ? void 0 : alreadyScannedProductId.length)) {
                                    incorrectProductHandler(false);
                                }
                                else {
                                    if (alreadyScannedProductId.includes((_33 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _33 === void 0 ? void 0 : _33.productId)) {
                                        incorrectProductHandler(true);
                                    }
                                    else {
                                        incorrectProductHandler(false);
                                    }
                                }
                            }
                            else {
                                // console.log('associatedProductDetail--->', associatedProductDetail[0])
                                // console.log('currContainerId------>', currContainerId, 'shipmentId', shipmentId)
                                // await thunkAPI.dispatch(
                                //   createShipmentItemContainer({
                                //     shipmentId,
                                //     containerId: currContainerId,
                                //     productId: associatedProductDetail[0].productId,
                                //     quantity: associatedProductDetail[0].quantity
                                //   })
                                // )
                                setAlreadyScannedProductId(function (prev) {
                                    var _a;
                                    return __spreadArray(__spreadArray([], prev, true), [
                                        (_a = associatedProductDetail_1[0]) === null || _a === void 0 ? void 0 : _a.productId
                                    ], false);
                                });
                                setCurrentScanItemDetail(function (prev) {
                                    var _a;
                                    return (__assign(__assign({}, prev), { productId: (_a = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _a === void 0 ? void 0 : _a.productId }));
                                });
                                thunkAPI.dispatch(getLotList({
                                    shipmentId: shipmentId,
                                    productId: (_34 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _34 === void 0 ? void 0 : _34.productId,
                                    setLotList: setLotList,
                                    setOrganizationLotList: setOrganizationLotList
                                }));
                                thunkAPI.dispatch(getSuggestedLocations({
                                    productId: (_35 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _35 === void 0 ? void 0 : _35.productId,
                                    setSuggestedLocations: setSuggestedLocations,
                                    shipmentLocationTypeList: shipmentLocationTypeList
                                }));
                                setCurrentActiveSubscreen(subscreenName);
                                setScanProductUpcIncorrect(false);
                                setScanProductData({
                                    productId: (_36 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _36 === void 0 ? void 0 : _36.productId,
                                    associatedProductDetail: associatedProductDetail_1[0]
                                });
                            }
                        }
                        else {
                            setScanProductUpcIncorrect(true);
                            setErrorMsgText('Incorrect Product Upc, scan again');
                        }
                    }
                    if (!(functionCall === 'onLpScan')) return [3 /*break*/, 6];
                    if (!(response_4.data.messages ||
                        ((_37 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _37 === void 0 ? void 0 : _37.facilityLocation) ||
                        ((_38 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _38 === void 0 ? void 0 : _38.productId))) return [3 /*break*/, 2];
                    setScannedLpIncorrect(true);
                    setErrorMsgText('Incorrect LP, scan again');
                    return [3 /*break*/, 6];
                case 2:
                    if (!((_40 = (_39 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _39 === void 0 ? void 0 : _39.container) === null || _40 === void 0 ? void 0 : _40.containerId)) return [3 /*break*/, 6];
                    setScannedLpIncorrect(false);
                    shipmentContainArr = shipmentContainerList === null || shipmentContainerList === void 0 ? void 0 : shipmentContainerList.map(function (_a) {
                        var containerId = _a.containerId;
                        return containerId;
                    });
                    if (!shipmentContainArr.includes(scanId)) return [3 /*break*/, 3];
                    setScannedLpIncorrect(true);
                    setErrorMsgText('Shipment is already present');
                    return [3 /*break*/, 6];
                case 3:
                    if (!(((_42 = (_41 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _41 === void 0 ? void 0 : _41.container) === null || _42 === void 0 ? void 0 : _42.containerTypeEnumId) === 'CtMovable')) return [3 /*break*/, 5];
                    setCurrContainerId((_44 = (_43 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _43 === void 0 ? void 0 : _43.container) === null || _44 === void 0 ? void 0 : _44.containerId);
                    return [4 /*yield*/, thunkAPI.dispatch(createShipmentContainer({
                            containerId: (_46 = (_45 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _45 === void 0 ? void 0 : _45.container) === null || _46 === void 0 ? void 0 : _46.containerId,
                            shipmentId: shipmentId,
                            setShipmentContainerList: setShipmentContainerList,
                            setCreateSuccessfully: setCreateSuccessfully,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen
                        }))];
                case 4:
                    _57.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setScannedLpIncorrect(true);
                    setErrorMsgText("No Movable Container " + scanId + " found");
                    _57.label = 6;
                case 6:
                    if (!(functionCall === 'scanOriginLoc')) return [3 /*break*/, 9];
                    if (!(((_47 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _47 === void 0 ? void 0 : _47.messages) ||
                        ((_49 = (_48 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _48 === void 0 ? void 0 : _48.product) === null || _49 === void 0 ? void 0 : _49.productId) ||
                        (((_50 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _50 === void 0 ? void 0 : _50.facilityId) && ((_51 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _51 === void 0 ? void 0 : _51.productId)) ||
                        ((_52 = ['FltCart', 'FltPack']) === null || _52 === void 0 ? void 0 : _52.includes((_54 = (_53 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _53 === void 0 ? void 0 : _53.facilityLocation) === null || _54 === void 0 ? void 0 : _54.locationTypeEnumId)))) return [3 /*break*/, 7];
                    setErrorMsgText('Incorrect location, scan again');
                    setScanOriginLocationIncorrect(true);
                    return [3 /*break*/, 9];
                case 7:
                    if (!!['FltCart', 'FltPack'].includes((_56 = (_55 = response_4 === null || response_4 === void 0 ? void 0 : response_4.data) === null || _55 === void 0 ? void 0 : _55.facilityLocation) === null || _56 === void 0 ? void 0 : _56.locationTypeEnumId)) return [3 /*break*/, 9];
                    return [4 /*yield*/, thunkAPI.dispatch(getLookupLocation({
                            scanId: scanId,
                            setLookupLocationData: setLookupLocationData,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            setScanOriginLocationIncorrect: setScanOriginLocationIncorrect,
                            setErrorMsgText: setErrorMsgText
                        }))];
                case 8:
                    _57.sent();
                    _57.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10: return [2 /*return*/, thunkAPI.rejectWithValue(response_4)];
                case 11: return [3 /*break*/, 13];
                case 12:
                    e_51 = _57.sent();
                    console.log('Error', e_51.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_51.response.data)];
                case 13: return [2 /*return*/];
            }
        });
    });
});
export var getScannedProductforPacking = createAsyncThunk('auth/getScannedProductforPacking', function (_a, thunkAPI) {
    var scanId = _a.scanId, data = _a.data, setScannedCartIncorrect = _a.setScannedCartIncorrect, shipmentItemDetailList = _a.shipmentItemDetailList, kitComponentProduct = _a.kitComponentProduct, getShipmentDetail = _a.getShipmentDetail, setErrorMsgText = _a.setErrorMsgText, shipmentLists = _a.shipmentLists, getFreightPalletInfo = _a.getFreightPalletInfo, shipmentId = _a.shipmentId, packPalletform = _a.packPalletform, setIsLoading = _a.setIsLoading;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_6, token, facilityId, ownerPartyId, encodedURI, response_5, isMatched, kitIdMatched, error_1, errorMessage;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _l.trys.push([0, 7, , 8]);
                    console.log('\n🟢 === getScannedProductforPacking CALLED ===');
                    console.log('🟢 scanId:', scanId);
                    originalSetErrorMsgText_6 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        console.log('🔴 AUTO-CAPTURE [Packing]: setErrorMsgText called with:', msg);
                        originalSetErrorMsgText_6 === null || originalSetErrorMsgText_6 === void 0 ? void 0 : originalSetErrorMsgText_6(msg);
                        console.log('✅ AUTO-CAPTURE [Packing]: Error captured');
                    };
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    ownerPartyId = localStorage.getItem("activeOrgId");
                    encodedURI = "/rest/s1/handheld/facility/" + encodeURIComponent(facilityId) + "/scanIdGeneral?scanId=" + encodeURIComponent(scanId) + "&ownerPartyId=" + encodeURIComponent(ownerPartyId);
                    return [4 /*yield*/, axios.get(encodedURI, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response_5 = _l.sent();
                    if (!(response_5.status === 200)) return [3 /*break*/, 6];
                    isMatched = shipmentItemDetailList.some(function (item) {
                        var _a, _b;
                        return item.productId === response_5.data.productId ||
                            item.pseudoId === ((_b = (_a = response_5 === null || response_5 === void 0 ? void 0 : response_5.data) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.pseudoId);
                    });
                    kitIdMatched = kitComponentProduct.some(function (item) { var _a; return item.componentProductId === ((_a = response_5 === null || response_5 === void 0 ? void 0 : response_5.data) === null || _a === void 0 ? void 0 : _a.productId); });
                    if (!kitIdMatched) return [3 /*break*/, 3];
                    // If kitIdMatched is true, set isMatched to true
                    isMatched = true;
                    return [4 /*yield*/, thunkAPI.dispatch(shipmentPackItem({
                            data: data,
                            setScannedCartIncorrect: setScannedCartIncorrect,
                            setErrorMsgText: setErrorMsgText,
                            getShipmentDetail: getShipmentDetail,
                            productId: (_b = response_5 === null || response_5 === void 0 ? void 0 : response_5.data) === null || _b === void 0 ? void 0 : _b.productId,
                            shipmentLists: shipmentLists,
                            getFreightPalletInfo: getFreightPalletInfo,
                            shipmentId: shipmentId,
                            packPalletform: packPalletform,
                            setIsLoading: setIsLoading
                        }))];
                case 2:
                    _l.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!isMatched) return [3 /*break*/, 5];
                    // If kitIdMatched is false, you can set isMatched to false here if needed
                    kitIdMatched = true;
                    return [4 /*yield*/, thunkAPI.dispatch(shipmentPackItem({
                            data: data,
                            setScannedCartIncorrect: setScannedCartIncorrect,
                            setErrorMsgText: setErrorMsgText,
                            getShipmentDetail: getShipmentDetail,
                            productId: (_c = response_5 === null || response_5 === void 0 ? void 0 : response_5.data) === null || _c === void 0 ? void 0 : _c.productId,
                            shipmentLists: shipmentLists,
                            getFreightPalletInfo: getFreightPalletInfo,
                            shipmentId: shipmentId,
                            packPalletform: packPalletform,
                            setIsLoading: setIsLoading
                        }))];
                case 4:
                    _l.sent();
                    _l.label = 5;
                case 5:
                    if (!isMatched || !kitIdMatched || response_5.data.messages) {
                        console.log('❌ Kit validation failed - Capturing error');
                        setScannedCartIncorrect(true);
                        setErrorMsgText('Incorrect product, Scan again');
                        return [2 /*return*/];
                    }
                    console.log('✅ getScannedCartForReceiving completed successfully');
                    return [2 /*return*/, response_5];
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _l.sent();
                    console.log('\n❌ [CATCH BLOCK] getScannedCartForReceiving API ERROR');
                    console.log('📍 Status Code:', (_d = error_1.response) === null || _d === void 0 ? void 0 : _d.status);
                    console.log('📍 Error Data:', (_e = error_1.response) === null || _e === void 0 ? void 0 : _e.data);
                    console.log('📍 Scan ID:', scanId);
                    errorMessage = ((_g = (_f = error_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.errors) || ((_j = (_h = error_1.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.message) || 'Scan validation failed';
                    setErrorMsgText(errorMessage);
                    return [2 /*return*/, thunkAPI.rejectWithValue(((_k = error_1.response) === null || _k === void 0 ? void 0 : _k.data) || error_1.message)];
                case 8: return [2 /*return*/];
            }
        });
    });
});
//packing product close
export var closeShipmentPackage = createAsyncThunk('auth/closeShipmentPackage', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setShipmentData = _a.setShipmentData, setShipmentId = _a.setShipmentId, activePackageSeqId = _a.activePackageSeqId, selectBoxType = _a.selectBoxType, packageWeight = _a.packageWeight, weightUomId = _a.weightUomId, getShipmentDetail = _a.getShipmentDetail, updateActivePackageSeqId = _a.updateActivePackageSeqId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_52, errorMessage;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + activePackageSeqId + "/close", {
                            shipmentId: shipmentId,
                            shipmentPackageSeqId: activePackageSeqId,
                            shipmentRouteSegmentSeqId: '01',
                            shipmentBoxTypeId: selectBoxType,
                            weight: packageWeight,
                            weightUomId: weightUomId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    if (response.status === 200) {
                        // setShipmentPackageClose(true)
                        getShipmentDetail(shipmentId);
                        notification['success']({
                            message: 'Success',
                            description: "Shipment package is closed Successfully."
                        });
                        updateActivePackageSeqId();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_52 = _f.sent();
                    console.log('\n❌ [CATCH BLOCK] closeShipmentPackage API ERROR');
                    console.log('📍 Status Code:', (_b = e_52.response) === null || _b === void 0 ? void 0 : _b.status);
                    console.log('📍 Error Data:', (_c = e_52.response) === null || _c === void 0 ? void 0 : _c.data);
                    console.log('📍 Shipment ID:', shipmentId);
                    console.log('📍 Package Seq ID:', activePackageSeqId);
                    errorMessage = ((_e = (_d = e_52.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors) || 'Failed to close shipment package';
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_52.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//package cancel API
export var cancelPackage = createAsyncThunk('auth/generatePackingSlip', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/cancel", {
                            headers: moquiSessionToken
                        })];
                case 1:
                    response = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.log('error', error_2.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_2.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var UpdateAddress = createAsyncThunk('auth/UpdateAddress', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, data = _a.data;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/address?moquiSessionToken=" + moquiSessionToken, __assign({ shipmentId: shipmentId }, data), {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.data === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Shipment Address Updated Sucessfully"
                        });
                        return [2 /*return*/, response];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.log('error', error_3.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_3.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getCountriesList = createAsyncThunk('auth/getCountriesList', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setCountriesList = _a.setCountriesList;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, mappedArray, error_4;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/geos", {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _d.sent();
                    console.log('country geo id', response === null || response === void 0 ? void 0 : response.data);
                    if (response.status === 200) {
                        mappedArray = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.geoList.map(function (geo) {
                            return {
                                key: geo === null || geo === void 0 ? void 0 : geo.geoId,
                                value: geo === null || geo === void 0 ? void 0 : geo.geoName
                            };
                        });
                        setCountriesList(mappedArray);
                        return [2 /*return*/, response.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _d.sent();
                    console.log('error', (_c = error_4.response) === null || _c === void 0 ? void 0 : _c.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_4.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getStatesList = createAsyncThunk('auth/getStatesList', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, stateId = _a.stateId, setStatesList = _a.setStatesList;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, mappedArray, error_5;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/geos/" + stateId + "/regions", {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _d.sent();
                    console.log('country regions state id', response === null || response === void 0 ? void 0 : response.data);
                    if (response.status === 200) {
                        mappedArray = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.resultList.map(function (geo) {
                            return {
                                key: geo === null || geo === void 0 ? void 0 : geo.geoId,
                                value: geo === null || geo === void 0 ? void 0 : geo.geoName
                            };
                        });
                        setStatesList(mappedArray);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _d.sent();
                    console.log('error', (_c = error_5.response) === null || _c === void 0 ? void 0 : _c.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_5.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//1 .) API to get ShipmentDetail
export var getShipmentDetails = createAsyncThunk('auth/getShipmentDetails', function (_a, thunkAPI) {
    var setShipmentData = _a.setShipmentData, shipmentId = _a.shipmentId, productIdScanned = _a.productIdScanned, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, setShipmentId = _a.setShipmentId, setUpdatedShipmentItemDetailList = _a.setUpdatedShipmentItemDetailList, updatedShipmentItemDetailList = _a.updatedShipmentItemDetailList, setErrorMsgText = _a.setErrorMsgText, setScanRecivingAgainstShipmentIncorrect = _a.setScanRecivingAgainstShipmentIncorrect, setShipmentStatus = _a.setShipmentStatus, _b = _a.isReturnShipment, isReturnShipment = _b === void 0 ? false : _b, setReturnId = _a.setReturnId, setReceivedItems = _a.setReceivedItems, setShipmentLocationTypeList = _a.setShipmentLocationTypeList, setReturnedItems = _a.setReturnedItems, isIncoming = _a.isIncoming, currentScanItemDetail = _a.currentScanItemDetail, connectWithPrinter = _a.connectWithPrinter;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, activeOrgId, response, shipmentItemDetailList_1, assetId, url, shipmentItemDetailList, groupedData_1, orderId_1, orderPartSeqId_1, shipmentData, e_53;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        return __generator(this, function (_z) {
            switch (_z.label) {
                case 0:
                    _z.trys.push([0, 13, , 14]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    activeOrgId = localStorage.getItem('activeOrgId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/shipment/" + shipmentId + "?isReturnShipment=" + isReturnShipment + "&partyId=" + activeOrgId + "&isIncoming=" + (isIncoming ? 'true' : 'false'), {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _z.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 11];
                    if (subscreenName === "scanProductUPC") {
                        shipmentItemDetailList_1 = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.shipmentItemDetailList;
                        assetId = (_d = shipmentItemDetailList_1[shipmentItemDetailList_1 === null || shipmentItemDetailList_1 === void 0 ? void 0 : shipmentItemDetailList_1.findLastIndex(function (item) { return (item === null || item === void 0 ? void 0 : item.productId) === (currentScanItemDetail === null || currentScanItemDetail === void 0 ? void 0 : currentScanItemDetail.productId); })]) === null || _d === void 0 ? void 0 : _d.assetId;
                        url = process.env.REACT_APP_API_BASE_URL + "/fop/apps/PopcAdmin/Shipment/ReceivingLabelPDF?filename=ReceivingLabel-shipmentId-" + shipmentId + ".pdf&shipmentId=" + shipmentId + "&productId=" + (currentScanItemDetail === null || currentScanItemDetail === void 0 ? void 0 : currentScanItemDetail.productId) + "&assetId=" + assetId;
                        connectWithPrinter('pixel', url);
                    }
                    if (isReturnShipment && ((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.shipmentTypeEnumId) !== 'ShpTpSales') {
                        setScanRecivingAgainstShipmentIncorrect(true);
                        setErrorMsgText('Invalid shipment!');
                        return [2 /*return*/];
                    }
                    shipmentItemDetailList = [];
                    shipmentItemDetailList = shipmentItemDetailList =
                        (_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.shipmentItemDetailList) !== null && _g !== void 0 ? _g : [];
                    if ((shipmentItemDetailList === null || shipmentItemDetailList === void 0 ? void 0 : shipmentItemDetailList.length) === 0 ||
                        (!isReturnShipment &&
                            !((_h = ['ShpTpIncoming', 'ShpTpTransfer']) === null || _h === void 0 ? void 0 : _h.includes((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.shipmentTypeEnumId)))) {
                        setScanRecivingAgainstShipmentIncorrect(true);
                        setErrorMsgText('Invalid shipment Id');
                        return [2 /*return*/];
                    }
                    groupedData_1 = {};
                    if (!isReturnShipment) return [3 /*break*/, 7];
                    shipmentItemDetailList === null || shipmentItemDetailList === void 0 ? void 0 : shipmentItemDetailList.forEach(function (item) {
                        var _a;
                        if (item === null || item === void 0 ? void 0 : item.orderId) {
                            orderId_1 = item.orderId;
                            orderPartSeqId_1 = item === null || item === void 0 ? void 0 : item.orderItemSeqId;
                        }
                        var productId = item.productId;
                        if (!groupedData_1[productId]) {
                            groupedData_1[productId] = __assign({}, item);
                            groupedData_1[productId].returnQuantity = 0;
                        }
                        if ((item === null || item === void 0 ? void 0 : item.returnStatus) !== 'ReturnCancelled') {
                            groupedData_1[productId].returnQuantity += (_a = item === null || item === void 0 ? void 0 : item.returnQuantity) !== null && _a !== void 0 ? _a : 0;
                        }
                    });
                    shipmentItemDetailList = Object.values(groupedData_1);
                    if (!((_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.returnId)) return [3 /*break*/, 3];
                    setReturnId((_l = response === null || response === void 0 ? void 0 : response.data) === null || _l === void 0 ? void 0 : _l.returnId);
                    return [4 /*yield*/, thunkAPI.dispatch(getReceivedItems({
                            returnId: (_m = response === null || response === void 0 ? void 0 : response.data) === null || _m === void 0 ? void 0 : _m.returnId,
                            shipmentId: shipmentId,
                            setReceivedItems: setReceivedItems,
                            shipmentItemDetailList: shipmentItemDetailList,
                            setUpdatedShipmentItemDetailList: setUpdatedShipmentItemDetailList
                        }))];
                case 2:
                    _z.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, setUpdatedShipmentItemDetailList(shipmentItemDetailList)];
                case 4:
                    _z.sent();
                    _z.label = 5;
                case 5: 
                // await thunkAPI.dispatch(
                //   createReturnId({ setReturnId, shipmentId, orderId, orderPartSeqId, setReceivedItems })
                // )
                return [4 /*yield*/, thunkAPI.dispatch(getReturnedItems({ shipmentId: shipmentId, orderId: orderId_1, setReturnedItems: setReturnedItems }))];
                case 6:
                    // await thunkAPI.dispatch(
                    //   createReturnId({ setReturnId, shipmentId, orderId, orderPartSeqId, setReceivedItems })
                    // )
                    _z.sent();
                    return [3 /*break*/, 9];
                case 7:
                    shipmentItemDetailList.forEach(function (item) {
                        var _a, _b;
                        var productId = item.productId;
                        if (!groupedData_1[productId]) {
                            groupedData_1[productId] = __assign(__assign({}, item), { products: [] });
                            groupedData_1[productId].quantityAcceptedTotal = 0;
                            groupedData_1[productId].quantityRejectedTotal = 0;
                        }
                        groupedData_1[productId].products.push(item);
                        groupedData_1[productId].quantityAcceptedTotal += (_a = item === null || item === void 0 ? void 0 : item.quantityAcceptedTotal) !== null && _a !== void 0 ? _a : 0;
                        groupedData_1[productId].quantityRejectedTotal += (_b = item === null || item === void 0 ? void 0 : item.quantityRejectedTotal) !== null && _b !== void 0 ? _b : 0;
                    });
                    shipmentItemDetailList = Object.values(groupedData_1);
                    setShipmentStatus((_o = response === null || response === void 0 ? void 0 : response.data) === null || _o === void 0 ? void 0 : _o.statusId);
                    shipmentData = {
                        shipmentId: (_p = response === null || response === void 0 ? void 0 : response.data) === null || _p === void 0 ? void 0 : _p.shipmentId,
                        externalId: (_r = (_q = response === null || response === void 0 ? void 0 : response.data) === null || _q === void 0 ? void 0 : _q.fromPartyDetail) === null || _r === void 0 ? void 0 : _r.externalId,
                        from: (_t = (_s = response === null || response === void 0 ? void 0 : response.data) === null || _s === void 0 ? void 0 : _s.shipment) === null || _t === void 0 ? void 0 : _t.fromPartyId,
                        inputDate: (_v = (_u = response === null || response === void 0 ? void 0 : response.data) === null || _u === void 0 ? void 0 : _u.shipment) === null || _v === void 0 ? void 0 : _v.entryDate,
                        expectedQty: (_w = response === null || response === void 0 ? void 0 : response.data) === null || _w === void 0 ? void 0 : _w.shipmentItemDetailList[0].quantity,
                        shipmentItemDetailList: shipmentItemDetailList,
                        shipmentItemDetailLength: (_y = Object.entries((_x = response === null || response === void 0 ? void 0 : response.data) === null || _x === void 0 ? void 0 : _x.shipmentItemDetailList)) === null || _y === void 0 ? void 0 : _y.length
                    };
                    setShipmentData(shipmentData);
                    return [4 /*yield*/, setUpdatedShipmentItemDetailList(shipmentItemDetailList)];
                case 8:
                    _z.sent();
                    _z.label = 9;
                case 9: return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                        setEnumTypeList: setShipmentLocationTypeList,
                        enumType: 'FacilityLocationType',
                        fromLookup: false
                    }))];
                case 10:
                    _z.sent();
                    setShipmentId(shipmentId);
                    setCurrentActiveSubscreen(subscreenName);
                    return [3 /*break*/, 12];
                case 11: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 12: return [3 /*break*/, 14];
                case 13:
                    e_53 = _z.sent();
                    console.log('Error', e_53.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_53.response.data)];
                case 14: return [2 /*return*/];
            }
        });
    });
});
export var AwsUserPreference = createAsyncThunk('auth/AwsUserPreference', function (_a, thunkAPI) {
    var setAmazonAws = _a.setAmazonAws;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, awsS3UserPreferences, e_54;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/fp/S3UserPreferences", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        awsS3UserPreferences = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.awsS3UserPreferences;
                        setAmazonAws((awsS3UserPreferences === null || awsS3UserPreferences === void 0 ? void 0 : awsS3UserPreferences.s3Url) + "/" + (awsS3UserPreferences === null || awsS3UserPreferences === void 0 ? void 0 : awsS3UserPreferences.bucketName));
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_54 = _c.sent();
                    console.log('Error', e_54.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_54.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//2.) API to create ShipmentContainer
export var createShipmentContainer = createAsyncThunk('auth/createShipmentContainer', function (_a, thunkAPI) {
    var containerId = _a.containerId, shipmentId = _a.shipmentId, setShipmentContainerList = _a.setShipmentContainerList, setCreateSuccessfully = _a.setCreateSuccessfully, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_55, errorMessage;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 5, , 6]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("rest/s1/handheld/facility/shipment/" + shipmentId + "/movableContainer/" + containerId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    console.log('createShipmentContainer', response);
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    setCurrentActiveSubscreen('shipmentId');
                    setCreateSuccessfully(true);
                    return [4 /*yield*/, thunkAPI.dispatch(getShipmentContainer({
                            shipmentId: shipmentId,
                            setShipmentContainerList: setShipmentContainerList
                        }))];
                case 2:
                    _f.sent();
                    return [2 /*return*/, response.data];
                case 3: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_55 = _f.sent();
                    console.log('\n❌ [CATCH BLOCK] createShipmentContainer API ERROR');
                    console.log('📍 Status Code:', (_b = e_55.response) === null || _b === void 0 ? void 0 : _b.status);
                    console.log('📍 Error Data:', (_c = e_55.response) === null || _c === void 0 ? void 0 : _c.data);
                    console.log('📍 Shipment ID:', shipmentId);
                    console.log('📍 Container ID:', containerId);
                    errorMessage = ((_e = (_d = e_55.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors) || 'Failed to create shipment container';
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_55.response.data)];
                case 6: return [2 /*return*/];
            }
        });
    });
});
//3.) create ShipmentItemContainer
export var createShipmentItemContainer = createAsyncThunk('auth/createShipmentItemContainer', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, containerId = _a.containerId, productId = _a.productId, quantity = _a.quantity;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_56, errorMessage;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("rest/s1/handheld/facility/shipment/" + shipmentId + "/container/" + containerId + "/item", {
                            productId: productId,
                            quantity: quantity
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    console.log('create Shipment Item Container', response);
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_56 = _f.sent();
                    console.log('\n❌ [CATCH BLOCK] createShipmentItemContainer API ERROR');
                    console.log('📍 Status Code:', (_b = e_56.response) === null || _b === void 0 ? void 0 : _b.status);
                    console.log('📍 Error Data:', (_c = e_56.response) === null || _c === void 0 ? void 0 : _c.data);
                    console.log('📍 Shipment ID:', shipmentId);
                    console.log('📍 Product ID:', productId);
                    errorMessage = ((_e = (_d = e_56.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors) || 'Failed to create shipment item container';
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_56.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//4.) API to validate Shipment:
export var getValidateShipment = createAsyncThunk('auth/getValidateShipment', function (_a, thunkAPI) {
    var scanId = _a.scanId, setErrorMsgText = _a.setErrorMsgText, functionCall = _a.functionCall, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, setScanShipmentIncorrect = _a.setScanShipmentIncorrect, setShipmentId = _a.setShipmentId, setScanRecivingAgainstShipmentIncorrect = _a.setScanRecivingAgainstShipmentIncorrect, setShipmentData = _a.setShipmentData, setShipmentContainerList = _a.setShipmentContainerList, setUpdatedShipmentItemDetailList = _a.setUpdatedShipmentItemDetailList, updatedShipmentItemDetailList = _a.updatedShipmentItemDetailList;
    return __awaiter(void 0, void 0, void 0, function () {
        var originalSetErrorMsgText_7, token, response, onShipmentHandler, e_57, errorMessage, facilityId;
        var _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 8, , 9]);
                    console.log('\n🟢 === getValidateShipment CALLED ===');
                    console.log('🟢 scanId:', scanId);
                    console.log('🟢 functionCall:', functionCall);
                    originalSetErrorMsgText_7 = setErrorMsgText;
                    setErrorMsgText = function (msg) {
                        console.log('🔴 AUTO-CAPTURE [ValidateShipment]: setErrorMsgText called with:', msg);
                        originalSetErrorMsgText_7 === null || originalSetErrorMsgText_7 === void 0 ? void 0 : originalSetErrorMsgText_7(msg);
                        console.log('✅ AUTO-CAPTURE [ValidateShipment]: Error captured');
                    };
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/shipment/" + scanId + "/validate", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _j.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 6];
                    onShipmentHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/];
                        });
                    }); };
                    if (!!((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.isValid)) return [3 /*break*/, 2];
                    setErrorMsgText('Incorrect shipment ID, scan again');
                    if (functionCall === 'onShipmentIdScan') {
                        setScanShipmentIncorrect(true);
                    }
                    else {
                        setScanRecivingAgainstShipmentIncorrect(true);
                    }
                    return [3 /*break*/, 5];
                case 2:
                    setShipmentId(scanId);
                    setCurrentActiveSubscreen(subscreenName); //remove
                    if (!(functionCall === 'onShipmentIdScan')) return [3 /*break*/, 4];
                    return [4 /*yield*/, thunkAPI.dispatch(getShipmentContainer({
                            shipmentId: scanId,
                            setShipmentContainerList: setShipmentContainerList
                        }))];
                case 3:
                    _j.sent();
                    _j.label = 4;
                case 4:
                    if (functionCall === 'onShipmentIdScan') {
                        setScanShipmentIncorrect(false);
                        onShipmentHandler();
                    }
                    else {
                        setScanRecivingAgainstShipmentIncorrect(false);
                        onShipmentHandler();
                    }
                    _j.label = 5;
                case 5: return [2 /*return*/, response];
                case 6: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_57 = _j.sent();
                    console.log('\n❌❌❌ [CATCH BLOCK] getValidateShipment API ERROR ❌❌❌');
                    console.log('📍 Error Type:', e_57.constructor.name);
                    console.log('📍 Status Code:', (_c = e_57.response) === null || _c === void 0 ? void 0 : _c.status);
                    console.log('📍 Error Data:', (_d = e_57.response) === null || _d === void 0 ? void 0 : _d.data);
                    console.log('📍 Error Message:', e_57.message);
                    console.log('📍 Entered Shipment ID:', scanId);
                    errorMessage = ((_f = (_e = e_57.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.errors) || ((_h = (_g = e_57.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) || 'Shipment ID not found or API error';
                    facilityId = localStorage.getItem('facilityId') || 'unknown';
                    setErrorMsgText === null || setErrorMsgText === void 0 ? void 0 : setErrorMsgText(errorMessage);
                    setScanShipmentIncorrect === null || setScanShipmentIncorrect === void 0 ? void 0 : setScanShipmentIncorrect(true);
                    setScanRecivingAgainstShipmentIncorrect === null || setScanRecivingAgainstShipmentIncorrect === void 0 ? void 0 : setScanRecivingAgainstShipmentIncorrect(true);
                    console.log('════════════════════════════════════════════════════════\n');
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_57.response.data)];
                case 9: return [2 /*return*/];
            }
        });
    });
});
//5.) API to Get ShipmentContainer
export var getShipmentContainer = createAsyncThunk('auth/getShipmentContainer', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setShipmentContainerList = _a.setShipmentContainerList;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_58;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/shipment/" + shipmentId + "/container")];
                case 1:
                    response = _c.sent();
                    console.log('getShipmentContainer', response === null || response === void 0 ? void 0 : response.data);
                    if (response.status === 200) {
                        setShipmentContainerList((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.shipmentContainerList);
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_58 = _c.sent();
                    console.log('Error', e_58.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_58.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//6.) API to Delete ShipmentContainer:
export var deleteShipmentContainer = createAsyncThunk('auth/deleteShipmentContainer', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, containerIds = _a.containerIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_59;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.delete("/rest/s1/handheld/facility/shipment/" + shipmentId + "/container", {
                            params: { containerIds: containerIds }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('delete Shipment Containers', response === null || response === void 0 ? void 0 : response.data);
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Container Id " + containerIds + " Deleted Successfully."
                        });
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_59 = _b.sent();
                    console.log('Error', e_59.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_59.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//7.) API to receive multiple items:
export var receiveMultipleItems = createAsyncThunk('auth/receiveMultipleItems', function (_a, thunkAPI) {
    var data = _a.data, shipmentId = _a.shipmentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, resMsg, description, e_60;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/facility/shipment/" + shipmentId + "/receiveItems", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('receivi Multiple Items', response);
                    if (response.status === 200) {
                        resMsg = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.messages;
                        description = resMsg.split('\n');
                        description = description.map(function (item) {
                            return item;
                        });
                        notification['success']({
                            message: 'Success',
                            description: description
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_60 = _c.sent();
                    console.log('Error', e_60.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_60.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var moveProduct = createAsyncThunk('auth/moveProduct', function (_a, thunkAPI) {
    var params = _a.params, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setSelectedLot = _a.setSelectedLot;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_61;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/moveProduct", {
                            params: params,
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('Move product from one location to another', response);
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            // description: `Moved ${params?.quantity} quantity from ${params?.locationSeqId} to ${params?.toLocationSeqId}`
                            description: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.messages
                        });
                        setSelectedLot(null);
                        setCurrentActiveSubscreen('');
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_61 = _c.sent();
                    console.log('Error', e_61.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_61.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//10.) Lookup Product
export var getLookupProduct = createAsyncThunk('auth/getLookupProduct', function (_a, thunkAPI) {
    var scanId = _a.scanId, setLookupProductData = _a.setLookupProductData, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, existingProductList = _a.existingProductList, setItemsToMoveIncorrect = _a.setItemsToMoveIncorrect, setErrorMsgText = _a.setErrorMsgText, scannedLocation = _a.scannedLocation;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, productId_1, lotDetails_1, isExist, itemLocationData, e_62;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return __generator(this, function (_q) {
            switch (_q.label) {
                case 0:
                    _q.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/lookupProduct?scanId=" + scanId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _q.sent();
                    console.log('Get Lookup Product', response);
                    if (response.status === 200) {
                        if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.messages) {
                            notification['error']({
                                message: 'Error',
                                description: response.data.messages
                            });
                            return [2 /*return*/];
                        }
                        lotDetails_1 = [];
                        isExist = existingProductList === null || existingProductList === void 0 ? void 0 : existingProductList.some(function (productItem) {
                            if (productItem.productId === scanId ||
                                (productItem === null || productItem === void 0 ? void 0 : productItem.productUpc) === scanId ||
                                (productItem === null || productItem === void 0 ? void 0 : productItem.productSku) === scanId) {
                                // productId = scanId
                                productId_1 = productItem.productId;
                                lotDetails_1 = productItem === null || productItem === void 0 ? void 0 : productItem.lotDetails;
                                return true;
                            }
                            return false;
                        });
                        if (isExist) {
                            setCurrentActiveSubscreen('qtyToMove');
                            itemLocationData = (_e = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.responseMap) === null || _d === void 0 ? void 0 : _d.assetList) === null || _e === void 0 ? void 0 : _e.find(function (availItem) {
                                var _a, _b;
                                return ((_b = (_a = availItem === null || availItem === void 0 ? void 0 : availItem.facilityLocationDetail) === null || _a === void 0 ? void 0 : _a.locationSeqId) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ==
                                    (scannedLocation === null || scannedLocation === void 0 ? void 0 : scannedLocation.toLowerCase());
                            });
                            setLookupProductData({
                                //Validation: locationTypeEnumId	"FltPick" and statusId :AstOnAvailable
                                lookupProductList: (_h = (_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.responseMap) === null || _g === void 0 ? void 0 : _g.assetList) === null || _h === void 0 ? void 0 : _h.map(function (availItem) {
                                    console.log('4013', availItem);
                                    if ((availItem === null || availItem === void 0 ? void 0 : availItem.statusId) === 'AstOnAvailable' &&
                                        (availItem === null || availItem === void 0 ? void 0 : availItem.locationTypeEnumId) === 'FltPick') {
                                        console.log('4018', availItem);
                                        return {
                                            locationSeqId: (availItem === null || availItem === void 0 ? void 0 : availItem.locationSeqId) || '',
                                            qtyAvail: (availItem === null || availItem === void 0 ? void 0 : availItem.availableToPromiseTotal) || 0,
                                            qtyOnHand: (availItem === null || availItem === void 0 ? void 0 : availItem.quantityOnHandTotal) || 0
                                        };
                                    }
                                    return undefined;
                                }),
                                qtyAvail: (itemLocationData === null || itemLocationData === void 0 ? void 0 : itemLocationData.availableToPromiseTotal) || 0,
                                qtyOnHand: (itemLocationData === null || itemLocationData === void 0 ? void 0 : itemLocationData.quantityOnHandTotal) || 0,
                                productName: (_l = (_k = (_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.responseMap) === null || _k === void 0 ? void 0 : _k.product) === null || _l === void 0 ? void 0 : _l.productName,
                                productSku: (_p = (_o = (_m = response === null || response === void 0 ? void 0 : response.data) === null || _m === void 0 ? void 0 : _m.responseMap) === null || _o === void 0 ? void 0 : _o.product) === null || _p === void 0 ? void 0 : _p.pseudoId,
                                productId: productId_1,
                                lotDetails: lotDetails_1
                            });
                        }
                        else {
                            setItemsToMoveIncorrect(true);
                            setErrorMsgText('Invalid Item,please scan again');
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_62 = _q.sent();
                    console.log('Error', e_62.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_62.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//.11) Api to get Lookup Location
export var getLookupLocation = createAsyncThunk('auth/getLookupLocation', function (_a, thunkAPI) {
    var scanId = _a.scanId, setLookupLocationData = _a.setLookupLocationData, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setScanOriginLocationIncorrect = _a.setScanOriginLocationIncorrect, setErrorMsgText = _a.setErrorMsgText;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, organisationPartyId, response_6, RemoveDuplicateContainerId, containerList, productList, groupedProducts_1, e_63;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    organisationPartyId = localStorage.getItem('activeOrgId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/lookupLocation?locationSeqId=" + scanId + "&ownerPartyId=" + organisationPartyId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response_6 = _g.sent();
                    console.log('Get Lookup Location', response_6);
                    if (response_6.status === 200) {
                        // if (response?.data?.containers.length === 0 || response?.data?.products.length === 0) {
                        if (((_b = response_6 === null || response_6 === void 0 ? void 0 : response_6.data) === null || _b === void 0 ? void 0 : _b.products.length) === 0) {
                            setScanOriginLocationIncorrect(true);
                            setErrorMsgText('No container and product');
                        }
                        else {
                            setCurrentActiveSubscreen(function () {
                                var _a, _b;
                                var containerList = (_b = (_a = response_6 === null || response_6 === void 0 ? void 0 : response_6.data) === null || _a === void 0 ? void 0 : _a.containers) !== null && _b !== void 0 ? _b : [];
                                if (containerList.length === 0)
                                    return 'itemsToMove';
                                return 'scannedLocWithContAndAssts';
                                // return 'itemsToMove'
                            });
                            RemoveDuplicateContainerId = function (array, key) {
                                return array.reduce(function (arr, item) {
                                    var removed = arr.filter(function (i) { return i[key] !== item[key]; });
                                    return __spreadArray(__spreadArray([], removed, true), [item], false);
                                }, []);
                            };
                            containerList = RemoveDuplicateContainerId((_d = (_c = response_6 === null || response_6 === void 0 ? void 0 : response_6.data) === null || _c === void 0 ? void 0 : _c.containers) !== null && _d !== void 0 ? _d : [], 'containerId');
                            productList = (_f = (_e = response_6 === null || response_6 === void 0 ? void 0 : response_6.data) === null || _e === void 0 ? void 0 : _e.products) === null || _f === void 0 ? void 0 : _f.map(function (productItem) {
                                return {
                                    productName: (productItem === null || productItem === void 0 ? void 0 : productItem.productName) || 'productName',
                                    productUpc: (productItem === null || productItem === void 0 ? void 0 : productItem.productUpc) || '',
                                    productSku: (productItem === null || productItem === void 0 ? void 0 : productItem.productSku) || '',
                                    quantityOnHandTotal: (productItem === null || productItem === void 0 ? void 0 : productItem.quantityOnHandTotal) || '',
                                    quantityAvail: (productItem === null || productItem === void 0 ? void 0 : productItem.availableToPromiseTotal) || 0,
                                    productId: (productItem === null || productItem === void 0 ? void 0 : productItem.productId) || '',
                                    lotId: (productItem === null || productItem === void 0 ? void 0 : productItem.lotId) || '',
                                    lotNumber: (productItem === null || productItem === void 0 ? void 0 : productItem.lotNumber) || '',
                                    manufacturedDate: (productItem === null || productItem === void 0 ? void 0 : productItem.manufacturedDate) || '',
                                    expirationDate: (productItem === null || productItem === void 0 ? void 0 : productItem.expirationDate) || '',
                                    assetId: productItem === null || productItem === void 0 ? void 0 : productItem.assetId
                                };
                            });
                            groupedProducts_1 = {};
                            productList.forEach(function (product) {
                                var _a, _b, _c, _d;
                                var key = "" + product.productId;
                                if (!groupedProducts_1[key]) {
                                    groupedProducts_1[key] = {
                                        productName: (product === null || product === void 0 ? void 0 : product.productName) || 'productName',
                                        productUpc: (product === null || product === void 0 ? void 0 : product.productUpc) || '',
                                        productSku: (product === null || product === void 0 ? void 0 : product.productSku) || '',
                                        quantityAvail: (product === null || product === void 0 ? void 0 : product.availableToPromiseTotal) || 0,
                                        productId: (product === null || product === void 0 ? void 0 : product.productId) || '',
                                        quantityOnHandTotal: 0,
                                        lotDetails: []
                                    };
                                }
                                groupedProducts_1[key].quantityOnHandTotal += +product.quantityOnHandTotal;
                                groupedProducts_1[key].quantityAvail += +product.quantityAvail;
                                var isExpired = (product === null || product === void 0 ? void 0 : product.expirationDate)
                                    ? (_a = moment()) === null || _a === void 0 ? void 0 : _a.isBefore(moment(product === null || product === void 0 ? void 0 : product.expirationDate))
                                    : true;
                                if (product.lotId && isExpired) {
                                    var existigLot = (_c = (_b = groupedProducts_1[key]) === null || _b === void 0 ? void 0 : _b.lotDetails) === null || _c === void 0 ? void 0 : _c.find(function (lot) { return (lot === null || lot === void 0 ? void 0 : lot.lotId) === (product === null || product === void 0 ? void 0 : product.lotId); });
                                    if (existigLot) {
                                        existigLot.qty += (product === null || product === void 0 ? void 0 : product.quantityOnHandTotal) || 0;
                                    }
                                    else {
                                        (_d = groupedProducts_1[key]) === null || _d === void 0 ? void 0 : _d.lotDetails.push({
                                            lotId: product === null || product === void 0 ? void 0 : product.lotId,
                                            lotNumber: product === null || product === void 0 ? void 0 : product.lotNumber,
                                            manufacturedDate: product === null || product === void 0 ? void 0 : product.manufacturedDate,
                                            expirationDate: product === null || product === void 0 ? void 0 : product.expirationDate,
                                            qty: (product === null || product === void 0 ? void 0 : product.quantityOnHandTotal) || 0,
                                            assetId: product === null || product === void 0 ? void 0 : product.assetId
                                        });
                                    }
                                }
                            });
                            groupedProducts_1 = Object.values(groupedProducts_1);
                            setLookupLocationData({ containerList: containerList, productList: groupedProducts_1 });
                            setScanOriginLocationIncorrect(false);
                        }
                        return [2 /*return*/, response_6.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response_6)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_63 = _g.sent();
                    console.log('Error', e_63.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_63.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//  move container REST API
export var moveContainer = createAsyncThunk('auth/moveContainer', function (_a, thunkAPI) {
    var locationSeqId = _a.locationSeqId, scannedContainerId = _a.scannedContainerId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_64;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.put("rest/s1/handheld/facility/" + facilityId + "/moveContainer?moquiSessionToken=" + token, {
                            containerId: scannedContainerId,
                            locationSeqId: locationSeqId
                        })];
                case 1:
                    response = _b.sent();
                    console.log('Move container======>', response);
                    if (response.status === 200) {
                        setCurrentActiveSubscreen('');
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_64 = _b.sent();
                    console.log('Error', e_64.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_64.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//7.) API to receive multiple items:
export var receiveItems = createAsyncThunk('auth/receiveItems', function (_a, thunkAPI) {
    var data = _a.data, shipmentId = _a.shipmentId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, resetHandler = _a.resetHandler, onValidateShipmentHandler = _a.onValidateShipmentHandler, setSelectedLocation = _a.setSelectedLocation;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_65;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/shipment/" + shipmentId + "/receive?facilityId=" + facilityId, {
                            receivedItemList: data
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _d.sent();
                    console.log('receive Items', response);
                    if (!((response === null || response === void 0 ? void 0 : response.status) === 200)) return [3 /*break*/, 3];
                    if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.messages) {
                        notification['error']({
                            message: 'Error',
                            description: response.data.messages
                        });
                        return [2 /*return*/];
                    }
                    setCurrentActiveSubscreen('scanProductUPC');
                    notification['success']({
                        message: 'Success',
                        description: "Sucessfully received on location " + ((_c = data[0]) === null || _c === void 0 ? void 0 : _c.locationSeqId)
                    });
                    resetHandler();
                    setSelectedLocation('');
                    return [4 /*yield*/, onValidateShipmentHandler({
                            scanId: shipmentId,
                            functionCall: 'onReceiveAgainstShipmentIdScan',
                            subscreenName: 'scanProductUPC'
                        })];
                case 2:
                    _d.sent();
                    return [2 /*return*/, response.data];
                case 3: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_65 = _d.sent();
                    console.log('Error', e_65.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_65.response.data)];
                case 6: return [2 /*return*/];
            }
        });
    });
});
// Lot listing API
export var getLotList = createAsyncThunk('auth/getLotList', function (_a, thunkAPI) {
    var productId = _a.productId, shipmentId = _a.shipmentId, setLotList = _a.setLotList, setOrganizationLotList = _a.setOrganizationLotList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, organisationPartyId, response, organizationLotResponse, arrayMap, arrayMap, e_66;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    token = localStorage.getItem('moquiSessionToken');
                    organisationPartyId = localStorage.getItem('activeOrgId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/shipment/" + shipmentId + "/lot?productId=" + productId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/shipment/" + shipmentId + "/orgLot?organizationPartyId=" + organisationPartyId + "&productId=" + productId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 2:
                    organizationLotResponse = _f.sent();
                    if (organizationLotResponse.status === 200) {
                        arrayMap = (_c = (_b = organizationLotResponse === null || organizationLotResponse === void 0 ? void 0 : organizationLotResponse.data) === null || _b === void 0 ? void 0 : _b.organizationLotDetailList) === null || _c === void 0 ? void 0 : _c.map(function (lot) {
                            return {
                                key: lot === null || lot === void 0 ? void 0 : lot.lotNumber,
                                value: ((lot === null || lot === void 0 ? void 0 : lot.lotNumber) ? (lot === null || lot === void 0 ? void 0 : lot.lotNumber) + ":" : '') + " " + ((lot === null || lot === void 0 ? void 0 : lot.expirationDate) ? "Exp " + moment(lot === null || lot === void 0 ? void 0 : lot.expirationDate).format('YYYY-MM-DD') : '') + " " + ((lot === null || lot === void 0 ? void 0 : lot.manufacturedDate)
                                    ? "Mfg " + moment(lot === null || lot === void 0 ? void 0 : lot.manufacturedDate).format('YYYY-MM-DD')
                                    : '')
                            };
                        });
                        setOrganizationLotList(arrayMap);
                        // return organizationLotResponse
                    }
                    if (response.status === 200) {
                        arrayMap = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.lotList) === null || _e === void 0 ? void 0 : _e.map(function (lot) {
                            return {
                                key: lot === null || lot === void 0 ? void 0 : lot.lotNumber,
                                value: ((lot === null || lot === void 0 ? void 0 : lot.lotNumber) ? (lot === null || lot === void 0 ? void 0 : lot.lotNumber) + ":" : '') + " " + ((lot === null || lot === void 0 ? void 0 : lot.expirationDate) ? "Exp " + moment(lot === null || lot === void 0 ? void 0 : lot.expirationDate).format('YYYY-MM-DD') : '') + " " + ((lot === null || lot === void 0 ? void 0 : lot.manufacturedDate)
                                    ? "Mfg " + moment(lot === null || lot === void 0 ? void 0 : lot.manufacturedDate).format('YYYY-MM-DD')
                                    : '') + " "
                            };
                        });
                        setLotList(arrayMap);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_66 = _f.sent();
                    console.log('Error', e_66.response.data);
                    return [2 /*return*/, (thunkAPI.rejectWithValue(e_66.response.data),
                            thunkAPI.rejectWithValue(e_66.OrganizationLotResponse.data))];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Complete shipment
export var completeShipment = createAsyncThunk('auth/completeShipment', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setShipmentStatus = _a.setShipmentStatus;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_67;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/shipment/" + shipmentId + "/deliver", {}, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('Shipment deliver', response);
                    if (response.status === 200) {
                        setShipmentStatus('ShipDelivered');
                        notification['success']({
                            message: 'Success',
                            description: "Shipment successfully delivered"
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_67 = _b.sent();
                    console.log('Error', e_67.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_67.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//Scan receiving tag REST API
export var getScannedReceivingTag = createAsyncThunk('auth/getScannedReceivingTag', function (_a, thunkAPI) {
    var scanId = _a.scanId, setErrorMsgText = _a.setErrorMsgText, setScanReceivingTagIncorrect = _a.setScanReceivingTagIncorrect, setItemList = _a.setItemList, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setShipmentId = _a.setShipmentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_68;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/putAway?scanId=" + scanId, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _f.sent();
                    console.log('Scan receiving tag', response);
                    if (response.status === 200) {
                        setItemList((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.receivedShipment) === null || _c === void 0 ? void 0 : _c.itemList);
                        setShipmentId((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.receivedShipment) === null || _e === void 0 ? void 0 : _e.shipmentId);
                        setCurrentActiveSubscreen('receivingList');
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_68 = _f.sent();
                    console.log('Error', e_68.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_68.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Download receiving label
export var getReceivingPrintingLabel = createAsyncThunk('auth/getReceivingPrintingLabel', function (_a, thunkAPI) {
    var url = _a.url, connectWithPrinter = _a.connectWithPrinter;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, labelUrl, e_69;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('receiving label', response);
                    if (response.status === 200) {
                        labelUrl = "" + process.env.REACT_APP_API_BASE_URL + ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.redirectUrl);
                        connectWithPrinter(labelUrl);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_69 = _c.sent();
                    console.log('Error', e_69.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_69.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get printers details
export var getPrinterDetails = createAsyncThunk('auth/getPrinterDetails', function (_a, thunkAPI) {
    var setServerHost = _a.setServerHost, setServerPort = _a.setServerPort, setCurrPrinterName = _a.setCurrPrinterName;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, e_70;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/printerDetail", {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _e.sent();
                    console.log('printer details', response);
                    if (response.status === 200) {
                        setServerHost((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.printerIpAddress);
                        setServerPort((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.printerPort);
                        setCurrPrinterName((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.printerName);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_70 = _e.sent();
                    console.log('Error', e_70.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_70.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//Scan receiving tag REST API
export var putAwayItem = createAsyncThunk('auth/putAwayItem', function (_a, thunkAPI) {
    var data = _a.data, setErrorMsgText = _a.setErrorMsgText, setScanReceivingTagIncorrect = _a.setScanReceivingTagIncorrect, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, form = _a.form;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_71;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/putAway", __assign(__assign({}, data), { facilityId: facilityId }), {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('Put away', response);
                    if (response.status === 200) {
                        form === null || form === void 0 ? void 0 : form.resetFields();
                        setCurrentActiveSubscreen('');
                        notification['success']({
                            message: 'Success',
                            description: "Sucessfully moved quantity from " + (data === null || data === void 0 ? void 0 : data.fromLocation) + " to " + (data === null || data === void 0 ? void 0 : data.toLocation)
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_71 = _b.sent();
                    console.log('Error', e_71.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_71.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Create returnId REST API
export var createReturnId = createAsyncThunk('auth/createReturnId', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setReturnId = _a.setReturnId, orderId = _a.orderId, orderPartSeqId = _a.orderPartSeqId, setReceivedItems = _a.setReceivedItems;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_72;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 5, , 6]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/shipment/" + shipmentId + "/return", {
                            isReturnShipment: true,
                            orderId: orderId,
                            orderPartSeqId: orderPartSeqId
                        }, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _f.sent();
                    console.log('ReturnId', response);
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    setReturnId((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.returnFromOrder) === null || _c === void 0 ? void 0 : _c.returnId);
                    return [4 /*yield*/, thunkAPI.dispatch(getReceivedItems({
                            returnId: (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.returnFromOrder) === null || _e === void 0 ? void 0 : _e.returnId,
                            shipmentId: shipmentId,
                            setReceivedItems: setReceivedItems
                        }))];
                case 2:
                    _f.sent();
                    return [2 /*return*/, response.data];
                case 3: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_72 = _f.sent();
                    console.log('Error', e_72.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_72.response.data)];
                case 6: return [2 /*return*/];
            }
        });
    });
});
// get receivedItems REST API
export var getReceivedItems = createAsyncThunk('auth/getReceivedItems', function (_a, thunkAPI) {
    var returnId = _a.returnId, shipmentId = _a.shipmentId, setReceivedItems = _a.setReceivedItems, resetHandler = _a.resetHandler, shipmentItemDetailList = _a.shipmentItemDetailList, setUpdatedShipmentItemDetailList = _a.setUpdatedShipmentItemDetailList, fromConfirmScreen = _a.fromConfirmScreen, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, receivedItemList_1, groupedData_2, isAllItemsReceived, updatedData, e_73;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/return/" + returnId + "/item?shipmentId=" + shipmentId, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _d.sent();
                    console.log('Received items data', response);
                    if (response.status === 200) {
                        receivedItemList_1 = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.returnItemList) !== null && _c !== void 0 ? _c : [];
                        groupedData_2 = {};
                        receivedItemList_1.forEach(function (item) {
                            var _a;
                            var productId = item.productId;
                            if (!groupedData_2[productId]) {
                                groupedData_2[productId] = __assign({}, item);
                                groupedData_2[productId].returnQuantity = 0;
                            }
                            groupedData_2[productId].returnQuantity += (_a = item === null || item === void 0 ? void 0 : item.returnQuantity) !== null && _a !== void 0 ? _a : 0;
                            groupedData_2[productId].returnReasonEnumId = item === null || item === void 0 ? void 0 : item.returnReasonEnumId;
                        });
                        receivedItemList_1 = Object.values(groupedData_2);
                        setReceivedItems(receivedItemList_1);
                        isAllItemsReceived = receivedItemList_1 === null || receivedItemList_1 === void 0 ? void 0 : receivedItemList_1.every(function (item) { return (item === null || item === void 0 ? void 0 : item.shipmentStatus) === 'SisReceived'; });
                        if (shipmentItemDetailList) {
                            updatedData = shipmentItemDetailList === null || shipmentItemDetailList === void 0 ? void 0 : shipmentItemDetailList.map(function (item) {
                                var itemsDetails = receivedItemList_1 === null || receivedItemList_1 === void 0 ? void 0 : receivedItemList_1.find(function (recItem) { return (recItem === null || recItem === void 0 ? void 0 : recItem.productId) === (item === null || item === void 0 ? void 0 : item.productId); });
                                return __assign(__assign({}, item), { itemsDetails: itemsDetails });
                            });
                            setUpdatedShipmentItemDetailList(updatedData);
                        }
                        if (isAllItemsReceived && fromConfirmScreen) {
                            resetHandler();
                        }
                        else if (fromConfirmScreen) {
                            console.log('Run****');
                            setCurrentActiveSubscreen('receivedItems');
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_73 = _d.sent();
                    console.error('Error', e_73.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_73.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// get returnedItems REST API
export var getReturnedItems = createAsyncThunk('auth/getReturnedItems', function (_a, thunkAPI) {
    var orderId = _a.orderId, shipmentId = _a.shipmentId, setReturnedItems = _a.setReturnedItems, resetHandler = _a.resetHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, groupedData_3, result, e_74;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/shipment/" + shipmentId + "/return?orderId=" + orderId, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _d.sent();
                    console.log('Returned items data', response);
                    if (response.status === 200) {
                        groupedData_3 = {};
                        (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.returnedItemList) === null || _c === void 0 ? void 0 : _c.forEach(function (item) {
                            var returnId = item.returnId, returnQuantity = item.returnQuantity, receivedQuantity = item.receivedQuantity, description = item.description, productSku = item.productSku, productId = item.productId, productUpc = item.productUpc, itemStatusId = item.itemStatusId, returnReasonEnumId = item.returnReasonEnumId, componentList = item.componentList, rest = __rest(item, ["returnId", "returnQuantity", "receivedQuantity", "description", "productSku", "productId", "productUpc", "itemStatusId", "returnReasonEnumId", "componentList"]);
                            if (!groupedData_3[returnId]) {
                                groupedData_3[returnId] = __assign(__assign({}, rest), { returnId: returnId, items: [] });
                            }
                            groupedData_3[returnId].items.push({
                                description: description,
                                productSku: productSku,
                                productId: productId,
                                productUpc: productUpc,
                                receivedQuantity: receivedQuantity,
                                returnQuantity: returnQuantity,
                                itemStatusId: itemStatusId,
                                returnReasonEnumId: returnReasonEnumId,
                                componentList: componentList
                            });
                        });
                        result = Object.values(groupedData_3);
                        setReturnedItems(result);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_74 = _d.sent();
                    console.error('Error', e_74.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_74.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Scan product SKU/UPC for return REST API
export var scanProductSKU = createAsyncThunk('auth/scanProductSKU', function (_a, thunkAPI) {
    var scanId = _a.scanId, updatedShipmentItemDetailList = _a.updatedShipmentItemDetailList, setCurrentScannedItem = _a.setCurrentScannedItem, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, setErrorMsgText = _a.setErrorMsgText, setCurrentScannedProduct = _a.setCurrentScannedProduct, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response_7, matchedProduct, e_75;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + scanId, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response_7 = _b.sent();
                    if (response_7.status === 200) {
                        matchedProduct = updatedShipmentItemDetailList === null || updatedShipmentItemDetailList === void 0 ? void 0 : updatedShipmentItemDetailList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.productSku) === scanId || (item === null || item === void 0 ? void 0 : item.productUpc) === scanId || (item === null || item === void 0 ? void 0 : item.productEan) === scanId || (item === null || item === void 0 ? void 0 : item.productOther) === scanId; });
                        if (!matchedProduct) {
                            setErrorMsgText('Invalid product');
                            setScannedLocationIncorrect(true);
                            return [2 /*return*/];
                        }
                        setCurrentScannedProduct(matchedProduct);
                        setCurrentScannedItem(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), { productId: (_a = response_7 === null || response_7 === void 0 ? void 0 : response_7.data) === null || _a === void 0 ? void 0 : _a.productId }));
                        });
                        setCurrentActiveSubscreen(subscreenName);
                        return [2 /*return*/, response_7.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response_7)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_75 = _b.sent();
                    console.log('Error', e_75.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_75.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get Product's lot list
export var getProductLotDetails = createAsyncThunk('auth/getProductLotDetails', function (_a, thunkAPI) {
    var locationSeqId = _a.locationSeqId, productId = _a.productId, setLotsList = _a.setLotsList;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_76;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/product/" + productId + "/lot", {
                            params: {
                                facilityId: facilityId,
                                locationSeqId: locationSeqId
                            },
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('product lot details', response);
                    if (response.status === 200) {
                        setLotsList((_b = response.data) === null || _b === void 0 ? void 0 : _b.productLotList);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_76 = _c.sent();
                    console.log('Error', e_76.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_76.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Add/Update item for return REST API
export var addOrUpdateReturnItem = createAsyncThunk('auth/addOrUpdateReturnItem', function (_a, thunkAPI) {
    var data = _a.data, returnId = _a.returnId, shipmentId = _a.shipmentId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, getShipmentDetail = _a.getShipmentDetail, resetHandler = _a.resetHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_77;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/return/" + returnId + "/item", __assign(__assign({}, data), { facilityId: facilityId }), {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getShipmentDetail(shipmentId)];
                case 2:
                    _b.sent();
                    resetHandler('confirmScreen');
                    setCurrentActiveSubscreen('scanProduct');
                    notification['success']({
                        message: 'Success',
                        description: "Item Added successfully."
                    });
                    return [2 /*return*/, response.data];
                case 3: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_77 = _b.sent();
                    console.error('Error', e_77.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_77.response.data)];
                case 6: return [2 /*return*/];
            }
        });
    });
});
// approved return REST API
export var approvedReturn = createAsyncThunk('auth/approvedReturn', function (_a, thunkAPI) {
    var returnId = _a.returnId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, setReturnShipmentId = _a.setReturnShipmentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_78;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/return/" + returnId + "/approve", {}, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        setReturnShipmentId((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.returnShipmentId);
                        setCurrentActiveSubscreen('receivedItems');
                        notification['success']({
                            message: 'Success',
                            description: "Item approved successfully."
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_78 = _c.sent();
                    console.error('Error', e_78.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_78.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// receive single item REST API
export var receiveItem = createAsyncThunk('auth/receiveItem', function (_a, thunkAPI) {
    var data = _a.data, returnId = _a.returnId, shipmentId = _a.shipmentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, e_79;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/return/" + returnId + "/item/receive", __assign(__assign({}, data), { shipmentId: shipmentId, mfgPartyId: localStorage.getItem('activeOrgId'), facilityId: localStorage.getItem('facilityId') }), {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('receive single item data', response);
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_79 = _b.sent();
                    console.error('Error', e_79.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_79.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// receive all items REST API
export var receiveAllItems = createAsyncThunk('auth/receiveAllItems', function (_a, thunkAPI) {
    var returnId = _a.returnId, orderId = _a.orderId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, resetHandler = _a.resetHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_80;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/return/" + returnId + "/receiveAll", {
                            returnId: returnId,
                            orderId: orderId,
                            facilityId: facilityId
                        }, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('received all items data ', response);
                    if (response.status === 200) {
                        resetHandler();
                        notification['success']({
                            message: 'Success',
                            description: "Items Returned successfully."
                        });
                        setCurrentActiveSubscreen('scanShipment');
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_80 = _b.sent();
                    console.error('Error', e_80.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_80.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// receive all items REST API
export var cancelReturn = createAsyncThunk('auth/cancelReturn', function (_a, thunkAPI) {
    var returnId = _a.returnId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, resetHandler = _a.resetHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, facilityId, response, e_81;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/return/" + returnId + "/cancel", {}, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('Cancel return data ', response);
                    if (response.status === 200) {
                        resetHandler();
                        setCurrentActiveSubscreen('scanShipment');
                        notification['success']({
                            message: 'Success',
                            description: "Return canceled successfully"
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_81 = _b.sent();
                    console.error('Error', e_81.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_81.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getShipmentScannedPacking = createAsyncThunk('auth/getShipmentScannedPacking', function (_a, thunkAPI) {
    var scanId = _a.scanId, shipmentId = _a.shipmentId, quantity = _a.quantity, packageSeqId = _a.packageSeqId, setScannedCartIncorrect = _a.setScannedCartIncorrect, setBoxTypeList = _a.setBoxTypeList, setPackageWeight = _a.setPackageWeight, 
    // setCheckShipmentId,
    setErrorMsgText = _a.setErrorMsgText;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_82;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package", {
                            shipmentId: shipmentId,
                            quantity: quantity,
                            scanInput: scanId,
                            packageSeqId: packageSeqId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.messages) {
                            setErrorMsgText('Incorrect Product Id, Scan again');
                            setScannedCartIncorrect(true);
                            return [2 /*return*/];
                        }
                        else {
                            notification['success']({
                                message: 'Success',
                                description: "Shipment Pack Item Successfully."
                            });
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_82 = _c.sent();
                    console.log('Error', e_82.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_82.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//11)Scan id for packing API
/**
 * Endpoint: /rest/s1/handheld/shipment/${shipmentId}
 * Calls fp.ShipmentServices.get#ShipmentDetails -- As of Feb 1 2026 (subject to change, always verify)
 */
export var getPackingShipmentDetails = createAsyncThunk('auth/getShipmentDetails', function (_a, thunkAPI) {
    var setOldShipmentLists = _a.setOldShipmentLists, shipmentLists = _a.shipmentLists, shipmentId = _a.shipmentId, productInputRef = _a.productInputRef, productId = _a.productId, scanItem = _a.scanItem, callEnums = _a.callEnums, setPackagesData = _a.setPackagesData, setShipmentData = _a.setShipmentData, setIsLoading = _a.setIsLoading, setPackageRouteSegList = _a.setPackageRouteSegList, setScanShipmentIncorrect = _a.setScanShipmentIncorrect, setErrorMsgText = _a.setErrorMsgText, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, setShipmentStatusList = _a.setShipmentStatusList, setShipmentTypeList = _a.setShipmentTypeList, setShipmentTypeMethodList = _a.setShipmentTypeMethodList, setFacilitiesData = _a.setFacilitiesData, setShipmentId = _a.setShipmentId, setAllShipmentPackageContentList = _a.setAllShipmentPackageContentList, setAllShipmentPackageOrderItemList = _a.setAllShipmentPackageOrderItemList, setAllShipmentPackageContentSerialNumberList = _a.setAllShipmentPackageContentSerialNumberList, setShipmentPackageSequenceId = _a.setShipmentPackageSequenceId, setShipmentItemDetail = _a.setShipmentItemDetail, setActivePackageItems = _a.setActivePackageItems, setActivePackageSeqId = _a.setActivePackageSeqId, setRemainingActivePackageSeqId = _a.setRemainingActivePackageSeqId, setShipmentPackageList = _a.setShipmentPackageList, setShipmentLocationTypeList = _a.setShipmentLocationTypeList, setAttachmentList = _a.setAttachmentList;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, activeOrgId, url, response_8, assemblyProducts, kitComponentProduct, uniqueKitComponentProduct, existingShipmentData, updatedAllShipmentPackageContentList, updatedShipmentItemDetailList, updatedShipmentItemSourceList, updatedShipmentProductSkuUpcViewList, mergedShipmentData, ShipmentPackageContentList, groupByCategory, packageWithoutBoxType, packageWithoutBoxTypeList, shipmentPackageSeqId, e_83;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    _u.trys.push([0, 12, , 13]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    activeOrgId = localStorage.getItem('activeOrgId');
                    url = void 0;
                    if (scanItem) {
                        url = "/rest/s1/handheld/shipment/" + shipmentId + "/product/" + productId;
                    }
                    else {
                        url = "/rest/s1/handheld/shipment/" + shipmentId + "?isOutgoing=true&partyId=" + activeOrgId;
                    }
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response_8 = _u.sent();
                    if (!(response_8.status === 200)) return [3 /*break*/, 10];
                    if ((_d = (_c = (_b = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _b === void 0 ? void 0 : _b.shipmentItemSourceList) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.orderId) {
                        thunkAPI.dispatch(getAttachmentList({
                            setAttachmentList: setAttachmentList,
                            orderId: (_g = (_f = (_e = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _e === void 0 ? void 0 : _e.shipmentItemSourceList) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.orderId
                        }));
                    }
                    assemblyProducts = (_k = (_j = (_h = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _h === void 0 ? void 0 : _h.assemblyAssetInfo) === null || _j === void 0 ? void 0 : _j.produceWepList) === null || _k === void 0 ? void 0 : _k.map(function (item) {
                        var _a, _b, _c, _d, _e, _f;
                        var product = (_b = (_a = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _a === void 0 ? void 0 : _a.shipmentItemDetailList) === null || _b === void 0 ? void 0 : _b.find(function (pro) { return (pro === null || pro === void 0 ? void 0 : pro.productId) === (item === null || item === void 0 ? void 0 : item.productId); });
                        return __assign(__assign({}, item), { productName: (_c = product === null || product === void 0 ? void 0 : product.productName) !== null && _c !== void 0 ? _c : '', completed: (_f = (_e = (_d = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _d === void 0 ? void 0 : _d.assemblyAssetInfo) === null || _e === void 0 ? void 0 : _e.assemblyReceivedByProduct[item === null || item === void 0 ? void 0 : item.productId]) !== null && _f !== void 0 ? _f : 0 });
                    });
                    kitComponentProduct = (_m = (_l = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _l === void 0 ? void 0 : _l.componentProductList) === null || _m === void 0 ? void 0 : _m.map(function (item) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                        var totalQuantity = (_c = (_b = (_a = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _a === void 0 ? void 0 : _a.assemblyAssetInfo) === null || _b === void 0 ? void 0 : _b.consumeWepList) === null || _c === void 0 ? void 0 : _c.find(function (qty) { return (qty === null || qty === void 0 ? void 0 : qty.productId) === (item === null || item === void 0 ? void 0 : item.componentProductId); });
                        return __assign(__assign({}, item), { totalQty: (_d = item === null || item === void 0 ? void 0 : item.totalQuantity) !== null && _d !== void 0 ? _d : 0, quantityNotIssued: (_e = item === null || item === void 0 ? void 0 : item.quantityNotIssued) !== null && _e !== void 0 ? _e : 0, quantity: totalQuantity === null || totalQuantity === void 0 ? void 0 : totalQuantity.estimatedQuantity, quantityTotal: (_h = (_g = (_f = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _f === void 0 ? void 0 : _f.assemblyAssetInfo) === null || _g === void 0 ? void 0 : _g.componentIssuedQtyByProduct[item === null || item === void 0 ? void 0 : item.componentProductId]) !== null && _h !== void 0 ? _h : 0, usedQuantity: (_l = (_k = (_j = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _j === void 0 ? void 0 : _j.assemblyAssetInfo) === null || _k === void 0 ? void 0 : _k.componentUsedQtyByProduct[item === null || item === void 0 ? void 0 : item.componentProductId]) !== null && _l !== void 0 ? _l : 0, unUsedQuantity: (_p = (_o = (_m = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _m === void 0 ? void 0 : _m.assemblyAssetInfo) === null || _o === void 0 ? void 0 : _o.componentIssuedAvailable[item === null || item === void 0 ? void 0 : item.componentProductId]) !== null && _p !== void 0 ? _p : 0, packDate: (_s = (_r = (_q = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _q === void 0 ? void 0 : _q.shipment) === null || _r === void 0 ? void 0 : _r.estimatedShipDate) !== null && _s !== void 0 ? _s : '' });
                    });
                    console.log('kitComponentProduct', kitComponentProduct);
                    uniqueKitComponentProduct = Object.values(kitComponentProduct.reduce(function (acc, item) {
                        var key = item.componentProductId + "-" + item.orderItemSeqId;
                        if (!acc[key]) {
                            acc[key] = item;
                        }
                        return acc;
                    }, {}));
                    if (scanItem) {
                        existingShipmentData = shipmentLists;
                        updatedAllShipmentPackageContentList = existingShipmentData.allShipmentPackageContentList.map(function (item) {
                            if (item.productId === productId) {
                                var updatedItem = response_8 === null || response_8 === void 0 ? void 0 : response_8.data.allShipmentPackageContentList.find(function (i) { return i.productId === productId && i.productId === item.productId; });
                                return updatedItem || item;
                            }
                            else {
                                return item;
                            }
                        });
                        updatedShipmentItemDetailList = existingShipmentData.shipmentItemDetailList.map(function (item) {
                            if (item.productId === productId) {
                                var updatedItem = response_8 === null || response_8 === void 0 ? void 0 : response_8.data.shipmentItemDetailList.find(function (i) { return i.productId === productId; });
                                if ((item === null || item === void 0 ? void 0 : item.productId) === (updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.productId)) {
                                    item.quantityTotal = (updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.quantityTotal) || 0;
                                }
                            }
                            return item;
                        });
                        updatedShipmentItemSourceList = existingShipmentData.shipmentItemSourceList.map(function (item) {
                            if (item.productId === productId) {
                                var updatedItem = response_8 === null || response_8 === void 0 ? void 0 : response_8.data.shipmentItemSourceList.find(function (i) {
                                    return i.productId === productId && i.shipmentItemSourceId === item.shipmentItemSourceId;
                                });
                                if ((updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.shipmentItemSourceId) === (item === null || item === void 0 ? void 0 : item.shipmentItemSourceId) && productId === (item === null || item === void 0 ? void 0 : item.productId)) {
                                    item.quantityNotHandled = (updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.quantityNotHandled) || 0;
                                }
                            }
                            return item;
                        });
                        updatedShipmentProductSkuUpcViewList = existingShipmentData.shipmentProductSkuUpcViewList.map(function (item) {
                            if (item.productId === productId) {
                                var updatedItem = response_8 === null || response_8 === void 0 ? void 0 : response_8.data.shipmentProductSkuUpcViewList.find(function (i) {
                                    return i.productId === productId && i.orderItemSeqId === item.orderItemSeqId;
                                });
                                return updatedItem || item;
                            }
                            else {
                                return item;
                            }
                        });
                        mergedShipmentData = __assign(__assign(__assign({}, existingShipmentData), response_8 === null || response_8 === void 0 ? void 0 : response_8.data), { shipmentItemDetailList: updatedShipmentItemDetailList, shipmentItemSourceList: updatedShipmentItemSourceList, shipmentProductSkuUpcViewList: updatedShipmentProductSkuUpcViewList, allShipmentPackageContentList: updatedAllShipmentPackageContentList, assetLotList: existingShipmentData === null || existingShipmentData === void 0 ? void 0 : existingShipmentData.assetLotList, assetReservationList: existingShipmentData === null || existingShipmentData === void 0 ? void 0 : existingShipmentData.assetReservationList, assemblyProducts: existingShipmentData === null || existingShipmentData === void 0 ? void 0 : existingShipmentData.assemblyProducts, kitComponentProduct: existingShipmentData === null || existingShipmentData === void 0 ? void 0 : existingShipmentData.kitComponentProduct });
                        setShipmentData(mergedShipmentData);
                    }
                    else {
                        setShipmentData(__assign(__assign({}, response_8 === null || response_8 === void 0 ? void 0 : response_8.data), { assemblyProducts: assemblyProducts, kitComponentProduct: uniqueKitComponentProduct }));
                        setOldShipmentLists(__assign(__assign({}, response_8 === null || response_8 === void 0 ? void 0 : response_8.data), { assemblyProducts: assemblyProducts, kitComponentProduct: uniqueKitComponentProduct }));
                    }
                    return [4 /*yield*/, thunkAPI.dispatch(getShipmentPackage({
                            setPackagesData: setPackagesData,
                            shipmentId: shipmentId,
                            setAllShipmentPackageContentList: setAllShipmentPackageContentList,
                            setAllShipmentPackageOrderItemList: setAllShipmentPackageOrderItemList,
                            setShipmentPackageSequenceId: setShipmentPackageSequenceId,
                            setAllShipmentPackageContentSerialNumberList: setAllShipmentPackageContentSerialNumberList,
                            scanItem: scanItem,
                            setIsLoading: setIsLoading,
                            productInputRef: productInputRef
                        }))];
                case 2:
                    _u.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getStatusList({
                            statusTypeId: 'shipment',
                            setShipmentStatusList: setShipmentStatusList
                        }))];
                case 3:
                    _u.sent();
                    ShipmentPackageContentList = [];
                    ShipmentPackageContentList = (_p = (_o = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _o === void 0 ? void 0 : _o.shipmentPackageList) !== null && _p !== void 0 ? _p : [];
                    groupByCategory = ShipmentPackageContentList === null || ShipmentPackageContentList === void 0 ? void 0 : ShipmentPackageContentList.reduce(function (group, product) {
                        var _a;
                        var shipmentPackageSeqId = product.shipmentPackageSeqId;
                        group[shipmentPackageSeqId] = (_a = group[shipmentPackageSeqId]) !== null && _a !== void 0 ? _a : [];
                        group[shipmentPackageSeqId].push(product);
                        return group;
                    }, []);
                    setShipmentPackageList(groupByCategory);
                    packageWithoutBoxType = (_r = (_q = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _q === void 0 ? void 0 : _q.shipmentPackageList) === null || _r === void 0 ? void 0 : _r.find(function (item) { return !(item === null || item === void 0 ? void 0 : item.weight); });
                    packageWithoutBoxTypeList = (_t = (_s = response_8 === null || response_8 === void 0 ? void 0 : response_8.data) === null || _s === void 0 ? void 0 : _s.shipmentPackageList) === null || _t === void 0 ? void 0 : _t.filter(function (item) { return !(item === null || item === void 0 ? void 0 : item.shipmentBoxTypeId); });
                    setRemainingActivePackageSeqId(packageWithoutBoxTypeList);
                    if (packageWithoutBoxType) {
                        shipmentPackageSeqId = packageWithoutBoxType === null || packageWithoutBoxType === void 0 ? void 0 : packageWithoutBoxType.shipmentPackageSeqId;
                        setActivePackageSeqId(shipmentPackageSeqId);
                    }
                    else {
                        setActivePackageSeqId('');
                    }
                    setCurrentActiveSubscreen(subscreenName);
                    console.log('=================current screen');
                    if (!setCurrentActiveSubscreen) return [3 /*break*/, 9];
                    if (!callEnums) return [3 /*break*/, 8];
                    return [4 /*yield*/, thunkAPI.dispatch(facilitiesList({ setFacilitiesData: setFacilitiesData, history: history }))];
                case 4:
                    _u.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            setEnumTypeList: setShipmentTypeList,
                            enumType: 'ShipmentType',
                            fromLookup: false
                        }))];
                case 5:
                    _u.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            setEnumTypeList: setShipmentLocationTypeList,
                            enumType: 'FacilityLocationType',
                            fromLookup: false
                        }))];
                case 6:
                    _u.sent();
                    return [4 /*yield*/, thunkAPI.dispatch(getEnumerationList({
                            setEnumTypeList: setShipmentTypeMethodList,
                            enumType: 'ShipmentMethod',
                            fromLookup: false
                        }))];
                case 7:
                    _u.sent();
                    _u.label = 8;
                case 8:
                    setShipmentId(response_8 === null || response_8 === void 0 ? void 0 : response_8.data.shipmentId);
                    _u.label = 9;
                case 9: return [2 /*return*/, response_8];
                case 10: return [2 /*return*/, thunkAPI.rejectWithValue(response_8)];
                case 11: return [3 /*break*/, 13];
                case 12:
                    e_83 = _u.sent();
                    console.log('Error', e_83.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_83.response.data)];
                case 13: return [2 /*return*/];
            }
        });
    });
});
/**
 * Gets shipment packages for a shipment
 * Endpoint: /rest/s1/handheld/shipment/${shipmentId}/package
 * Calls fp.ShipmentServices.get#ShipmentPackage -- As of Feb 1 2026 (subject to change, always verify)
 * @param shipmentId - The ID of the shipment
 * @param setAllShipmentPackageContentList - A function to set the shipment package content list
 * @param setAllShipmentPackageOrderItemList - A function to set the shipment package order item list
 * @param setAllShipmentPackageContentSerialNumberList - A function to set the shipment package content serial number list
 * @param setShipmentPackageSequenceId - A function to set the shipment package sequence ID
 */
export var getShipmentPackage = createAsyncThunk('auth/getShipmentPackage', function (_a, thunkAPI) {
    var setPackagesData = _a.setPackagesData, shipmentId = _a.shipmentId, setAllShipmentPackageContentList = _a.setAllShipmentPackageContentList, setAllShipmentPackageOrderItemList = _a.setAllShipmentPackageOrderItemList, setAllShipmentPackageContentSerialNumberList = _a.setAllShipmentPackageContentSerialNumberList, setShipmentPackageSequenceId = _a.setShipmentPackageSequenceId, scanItem = _a.scanItem, setIsLoading = _a.setIsLoading, productInputRef = _a.productInputRef;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, allShipmentPackageContentList, groupByCategory, allShipmentPackageOrderItemList, groupByOrder, allShipmentPackageContentSerialNumberList, groupBy, error_6;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package", {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _h.sent();
                    console.log('response', response);
                    if (response.status === 200) {
                        console.log('respose.dta------', response.data);
                        allShipmentPackageContentList = [];
                        allShipmentPackageContentList = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.shipmentPackageContentList) !== null && _c !== void 0 ? _c : [];
                        groupByCategory = allShipmentPackageContentList.reduce(function (group, product) {
                            var _a;
                            var shipmentPackageSeqId = product.shipmentPackageSeqId;
                            group[shipmentPackageSeqId] = (_a = group[shipmentPackageSeqId]) !== null && _a !== void 0 ? _a : [];
                            group[shipmentPackageSeqId].push(product);
                            return group;
                        }, []);
                        allShipmentPackageOrderItemList = [];
                        allShipmentPackageOrderItemList = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.ShipmentPackageOrderItemList) !== null && _e !== void 0 ? _e : [];
                        groupByOrder = allShipmentPackageOrderItemList.reduce(function (group, product) {
                            var _a;
                            var shipmentPackageSeqId = product.shipmentPackageSeqId;
                            group[shipmentPackageSeqId] = (_a = group[shipmentPackageSeqId]) !== null && _a !== void 0 ? _a : [];
                            group[shipmentPackageSeqId].push(product);
                            return group;
                        }, []);
                        allShipmentPackageContentSerialNumberList = [];
                        allShipmentPackageContentSerialNumberList =
                            (_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.ShipmentPackageContentSerialNumberList) !== null && _g !== void 0 ? _g : [];
                        groupBy = allShipmentPackageContentSerialNumberList.reduce(function (group, product) {
                            var _a;
                            var shipmentPackageSeqId = product.shipmentPackageSeqId;
                            group[shipmentPackageSeqId] = (_a = group[shipmentPackageSeqId]) !== null && _a !== void 0 ? _a : [];
                            group[shipmentPackageSeqId].push(product);
                            return group;
                        }, []);
                        setAllShipmentPackageContentList(groupByCategory);
                        setAllShipmentPackageOrderItemList(groupByOrder);
                        setAllShipmentPackageContentSerialNumberList(groupBy);
                        setPackagesData(response === null || response === void 0 ? void 0 : response.data);
                        if (scanItem) {
                            setIsLoading(false);
                            setTimeout(function () {
                                var _a;
                                (_a = productInputRef === null || productInputRef === void 0 ? void 0 : productInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 1000);
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_6 = _h.sent();
                    console.log('Error', error_6);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_6.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getShipmentItemAssetList = createAsyncThunk('auth/getShipmentItemAssetList', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, error_7;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/itemAsset", {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('getshipmentAssetlist', response);
                    return [3 /*break*/, 3];
                case 2:
                    error_7 = _b.sent();
                    console.log('Error', error_7);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_7.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var packItems = createAsyncThunk('auth/packItems', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, shipmentItemSourceId = _a.shipmentItemSourceId, quantity = _a.quantity, getShipmentDetail = _a.getShipmentDetail, shipmentPackageSeqId = _a.shipmentPackageSeqId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, error_8;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/packItem", {
                            shipmentItemSourceId: shipmentItemSourceId,
                            quantity: quantity,
                            shipmentPackageSeqId: shipmentPackageSeqId
                        }, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status == 200) {
                        getShipmentDetail(shipmentId);
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_8 = _b.sent();
                    console.log('Error', error_8);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_8.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var packKitItems = createAsyncThunk('auth/packItems', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, productId = _a.productId, quantity = _a.quantity, getShipmentDetail = _a.getShipmentDetail, shipmentPackageSeqId = _a.shipmentPackageSeqId, assemblyProductId = _a.assemblyProductId;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, error_9;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/packKitItem", {
                            productId: productId,
                            quantity: quantity,
                            shipmentPackageSeqId: shipmentPackageSeqId,
                            assemblyProductId: assemblyProductId
                        }, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status == 200) {
                        getShipmentDetail(shipmentId);
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_9 = _b.sent();
                    console.log('Error', error_9);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_9.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var unPackItems = createAsyncThunk('auth/unPackItems', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, assetIssuanceId = _a.assetIssuanceId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, error_10;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/unPackItem", {
                            assetIssuanceId: assetIssuanceId
                        }, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status == 200) {
                        getShipmentDetail(shipmentId);
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_10 = _b.sent();
                    console.log('Error', error_10);
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_10.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var shipmentPackItem = createAsyncThunk('auth/shipmentPackItem', function (_a, thunkAPI) {
    var data = _a.data, getShipmentDetail = _a.getShipmentDetail, setScannedCartIncorrect = _a.setScannedCartIncorrect, setErrorMsgText = _a.setErrorMsgText, _b = _a.scanItem, scanItem = _b === void 0 ? true : _b, productId = _a.productId, shipmentLists = _a.shipmentLists, getFreightPalletInfo = _a.getFreightPalletInfo, shipmentId = _a.shipmentId, packPalletform = _a.packPalletform, setIsLoading = _a.setIsLoading;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, url, response, checkComponentItem, seprateComponentProduct, e_84;
        var _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    url = "/rest/s1/handheld/pack/shipment/" + data.shipmentId + "/package/" + ((data === null || data === void 0 ? void 0 : data.carton) && 'bulkPackage');
                    console.log("data?.palletSeqId", data === null || data === void 0 ? void 0 : data.palletSeqId);
                    if (data === null || data === void 0 ? void 0 : data.containerSerialNumber) {
                        url = "/rest/s1/handheld/pack/shipment/" + data.shipmentId + "/package/freightPallet";
                    }
                    return [4 /*yield*/, axios.post(url, __assign(__assign({}, data), { facilityId: localStorage.getItem('facilityId') }), {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _g.sent();
                    if (response.status === 200) {
                        checkComponentItem = (_c = shipmentLists === null || shipmentLists === void 0 ? void 0 : shipmentLists.shipmentItemDetailList) === null || _c === void 0 ? void 0 : _c.some(function (item) {
                            var _a;
                            return (_a = shipmentLists === null || shipmentLists === void 0 ? void 0 : shipmentLists.kitComponentProduct) === null || _a === void 0 ? void 0 : _a.some(function (data) {
                                return (data === null || data === void 0 ? void 0 : data.componentProductId) === (item === null || item === void 0 ? void 0 : item.productId) && (item === null || item === void 0 ? void 0 : item.quantity) === (item === null || item === void 0 ? void 0 : item.quantityTotal) && productId === (data === null || data === void 0 ? void 0 : data.componentProductId);
                            });
                        });
                        seprateComponentProduct = (_d = shipmentLists === null || shipmentLists === void 0 ? void 0 : shipmentLists.kitComponentProduct) === null || _d === void 0 ? void 0 : _d.some(function (data) { var _a; return (data === null || data === void 0 ? void 0 : data.componentProductId) === productId && !((_a = shipmentLists === null || shipmentLists === void 0 ? void 0 : shipmentLists.shipmentItemDetailList) === null || _a === void 0 ? void 0 : _a.some(function (data) { return productId === (data === null || data === void 0 ? void 0 : data.productId); })); });
                        if (checkComponentItem || seprateComponentProduct) {
                            scanItem = false;
                        }
                        if (data === null || data === void 0 ? void 0 : data.containerSerialNumber) {
                            getFreightPalletInfo(shipmentId);
                            packPalletform.resetFields();
                        }
                        if (((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.messages) && response.error) {
                            setErrorMsgText('Incorrect Product Id, Scan again');
                            setScannedCartIncorrect(true);
                            return [2 /*return*/];
                        }
                        else if (((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.messages) === 'This product is not serialized inventory product\n') {
                            notification['error']({
                                message: 'Error',
                                description: response.data.messages
                            });
                            getShipmentDetail(data === null || data === void 0 ? void 0 : data.shipmentId, productId, scanItem);
                            notification['success']({
                                message: 'Success',
                                description: "Shipment Pack Item Successfully."
                            });
                        }
                        else {
                            getShipmentDetail(data.shipmentId, productId, scanItem);
                            notification['success']({
                                message: 'Success',
                                description: "Shipment Pack Item Successfully."
                            });
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_84 = _g.sent();
                    setIsLoading(false);
                    console.log('Error', e_84.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_84.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//Scan shipment Box type
/**
 * Endpoint: /rest/s1/handheld/facility/${facilityId}/boxType
 * Calls fp.FacilityServices.get#FacilityBoxType -- As of Feb 1 2026 (subject to change, always verify)
 */
export var getFacilityBoxType = createAsyncThunk('auth/getFacilityBoxType', function (_a, thunkAPI) {
    var setBoxTypeList = _a.setBoxTypeList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, packageBoxTypeList_1, e_85;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/boxType", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        packageBoxTypeList_1 = [];
                        (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.boxTypeList.forEach(function (item) {
                            packageBoxTypeList_1.push({
                                key: item.shipmentBoxTypeId,
                                value: (item === null || item === void 0 ? void 0 : item.description) || (item === null || item === void 0 ? void 0 : item.pseudoId) || (item === null || item === void 0 ? void 0 : item.shipmentBoxTypeId) || ''
                            });
                        });
                        setBoxTypeList(packageBoxTypeList_1);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_85 = _c.sent();
                    console.log('Error', e_85.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_85.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Scan shipment weight
export var getPackageWeight = createAsyncThunk('auth/getPackageWeight', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, setPackageWeight = _a.setPackageWeight, form = _a.form, hostname = _a.hostname;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, e_86;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    console.log('shipmentPackageSeqId', shipmentPackageSeqId);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/weight?shipmentPackageSeqId=" + shipmentPackageSeqId + "&hostname=" + hostname, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        // console.log('=======response weight', response?.data)
                        if (response === null || response === void 0 ? void 0 : response.data) {
                            setPackageWeight && setPackageWeight(response.data);
                            form === null || form === void 0 ? void 0 : form.setFieldsValue({ weight: response.data });
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_86 = _b.sent();
                    console.log('Error', e_86.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_86.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var updatePallet = createAsyncThunk('auth/updatePallet', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, selectBoxType = _a.selectBoxType, packageWeight = _a.packageWeight, weightUomId = _a.weightUomId, containerLength = _a.containerLength, containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, containerSerialNumber = _a.containerSerialNumber, productId = _a.productId, getFreightPalletInfo = _a.getFreightPalletInfo, packPalletform = _a.packPalletform, shipmentPackageSeqId = _a.shipmentPackageSeqId, dimensionUomId = _a.dimensionUomId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_87;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/freightPallet", {
                            shipmentBoxTypeId: selectBoxType,
                            containerLength: containerLength,
                            containerWidth: containerWidth,
                            containerHeight: containerHeight,
                            weight: packageWeight,
                            containerSerialNumber: containerSerialNumber,
                            productId: productId,
                            weightUomId: weightUomId,
                            shipmentPackageSeqId: shipmentPackageSeqId,
                            dimensionUomId: dimensionUomId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        getFreightPalletInfo(shipmentId);
                        notification['success']({
                            message: 'Success',
                            description: "Pallet Closed Successfully."
                        });
                        packPalletform === null || packPalletform === void 0 ? void 0 : packPalletform.resetFields();
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_87 = _b.sent();
                    console.log('Error', e_87.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_87.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Mark shipment shipped REST API
export var markShipmentShipped = createAsyncThunk('auth/markShipmentShipped', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_88;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/setShipped", {
                            actualStartDate: moment().format('YYYY-MM-DD')
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('markShipmentShipped data', response);
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Shipment mark as shipped!"
                        });
                        setCurrentActiveSubscreen('shipmentId');
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_88 = _b.sent();
                    console.log('Error', e_88.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_88.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Mark shipment Packed
export var markShipmentPacked = createAsyncThunk('auth/markShipmentPacked', function (_a, thunkAPI) {
    var data = _a.data, shipmentId = _a.shipmentId, setShowPackCompletedModal = _a.setShowPackCompletedModal, completeForm = _a.completeForm, getShipmentDetail = _a.getShipmentDetail, connectWithPrinter = _a.connectWithPrinter, serialized = _a.serialized, downloadLabel = _a.downloadLabel;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, URL, url, e_89;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/packComplete", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _g.sent();
                    if (response.status === 200) {
                        URL = process.env.REACT_APP_API_BASE_URL + "/fop/apps/PopcAdmin/Shipping/ShipmentInsert?shipmentId=" + shipmentId;
                        if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.messages) {
                            if ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.messages) === null || _d === void 0 ? void 0 : _d.includes('already has label')) {
                                notification['warning']({
                                    message: 'warning',
                                    description: (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.messages
                                });
                                if (serialized) {
                                    notification['warning']({
                                        message: 'Warning',
                                        description: "You have packed serialized product, regenerate the packing slip."
                                    });
                                    downloadLabel(URL);
                                    connectWithPrinter(URL);
                                }
                                getShipmentDetail(shipmentId);
                                setShowPackCompletedModal(false);
                                completeForm.resetFields({});
                            }
                            else {
                                notification['error']({
                                    message: 'Error',
                                    description: (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.messages
                                });
                            }
                        }
                        else {
                            if (serialized) {
                                notification['warning']({
                                    message: 'Warning',
                                    description: "You have packed serialized product, regenerate the packing slip."
                                });
                                downloadLabel(URL);
                                connectWithPrinter(URL);
                            }
                            else {
                                notification['success']({
                                    message: 'Success',
                                    description: "Shipment mark as packed successfully."
                                });
                            }
                            if (data === null || data === void 0 ? void 0 : data.getLocalPrints) {
                                url = process.env.REACT_APP_API_BASE_URL + "/fop/apps/PopcAdmin/Shipment/ShipmentAllLabel?shipmentId=" + shipmentId;
                                connectWithPrinter(url);
                            }
                            getShipmentDetail(shipmentId);
                            setShowPackCompletedModal(false);
                            completeForm.resetFields({});
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_89 = _g.sent();
                    console.log('Error', e_89.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_89.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// API of get label
export var getLabel = createAsyncThunk('auth/getLabel', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, shipmentRouteSegmentSeqId = _a.shipmentRouteSegmentSeqId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_90;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + shipmentPackageSeqId + "/returnLabel", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _d.sent();
                    if (response.status === 200) {
                        console.log('get----------label', response === null || response === void 0 ? void 0 : response.data);
                        if ((_b = response.data) === null || _b === void 0 ? void 0 : _b.messages) {
                            notification['success']({
                                message: 'Success',
                                description: (_c = response.data) === null || _c === void 0 ? void 0 : _c.messages
                            });
                        }
                        else {
                            getShipmentDetail(shipmentId);
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_90 = _d.sent();
                    console.log('Error', e_90.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_90.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get carton Label
export var getCartonLabel = createAsyncThunk('auth/getLabel', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, productStoreId = _a.productStoreId, connectWithPrinter = _a.connectWithPrinter;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, url, e_91;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/spsCartonLabel?shipmentId=" + shipmentId + "&productStoreId=" + productStoreId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        url = process.env.REACT_APP_API_BASE_URL + "/apps/oms/Shipment/ShipmentDetail/downloadContent?shipmentId=" + shipmentId + "&shipmentContentId=" + ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.shipmentContentId);
                        connectWithPrinter(url, 'label');
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_91 = _c.sent();
                    console.log('Error', e_91.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_91.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var ResetPackage = createAsyncThunk('auth/ResetPackage', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_92;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + shipmentPackageSeqId + "/reset", {
                            shipmentId: shipmentId,
                            shipmentPackageSeqId: shipmentPackageSeqId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Shipment Rest Package successfully."
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_92 = _b.sent();
                    console.log('Error', e_92.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_92.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var ResetAllPackage = createAsyncThunk('auth/ResetAllPackage', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_93;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/resetAllPackages", {
                            shipmentId: shipmentId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "All packages reset successfully."
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_93 = _b.sent();
                    console.log('Error', e_93.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_93.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var UpdateQuantity = createAsyncThunk('auth/UpdateQuantity', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, productId = _a.productId, quantity = _a.quantity, orderId = _a.orderId, orderItemSeqId = _a.orderItemSeqId, shipmentPackageSeqId = _a.shipmentPackageSeqId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, e_94;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + shipmentPackageSeqId + "/content", {
                            shipmentId: shipmentId,
                            productId: productId,
                            quantity: quantity,
                            orderId: orderId,
                            orderItemSeqId: orderItemSeqId,
                            shipmentPackageSeqId: shipmentPackageSeqId
                        }, {
                            headers: {
                                moquiSessionToken: moquiSessionToken
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Shipment Update Quantity successfully."
                        });
                        getShipmentDetail(shipmentId);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_94 = _b.sent();
                    console.log('Error', e_94.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_94.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var deletePackage = createAsyncThunk('auth/deletePackage', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_95;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.delete("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + shipmentPackageSeqId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Shipment Package " + shipmentPackageSeqId + " Delete successfully."
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_95 = _b.sent();
                    console.log('Error', e_95.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_95.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var deleteAllPackage = createAsyncThunk('auth/deleteAllPackage', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_96;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/deleteAllPackages", {
                            shipmentId: shipmentId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "All packages deleted successfully."
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_96 = _b.sent();
                    console.log('Error', e_96.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_96.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getReturnLabel = createAsyncThunk('auth/getReturnLabel', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, shipmentItemSourceId = _a.shipmentItemSourceId, shipmentMethodEnumId = _a.shipmentMethodEnumId, getReturnLabels = _a.getReturnLabels;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_97;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + shipmentPackageSeqId + "/returnLabel?getReturnLabels=true", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: "Shipment Package Return Label successfully."
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_97 = _b.sent();
                    console.log('Error', e_97.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_97.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// API to Weight UoM
export var getWeightUoM = createAsyncThunk('auth/getWeightUoM', function (_a, thunkAPI) {
    var setWeightUoMList = _a.setWeightUoMList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, mappedArray, e_98;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/fp/uom?uomTypeEnumId=UT_WEIGHT_MEASURE", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _d.sent();
                    if (response.status === 200) {
                        mappedArray = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.uomList) === null || _c === void 0 ? void 0 : _c.map(function (item) {
                            return {
                                key: item === null || item === void 0 ? void 0 : item.uomId,
                                value: item === null || item === void 0 ? void 0 : item.description
                            };
                        });
                        setWeightUoMList(mappedArray);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_98 = _d.sent();
                    console.log('Error', e_98.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_98.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getUpdatePackage = createAsyncThunk('auth/getUpdatePackage', function (_a, thunkAPI) {
    var data = _a.data, shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_99;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/" + shipmentPackageSeqId, __assign(__assign({}, data), { shipmentId: shipmentId, shipmentPackageSeqId: shipmentPackageSeqId, getShipmentDetail: getShipmentDetail }), {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_99 = _b.sent();
                    console.log('Error', e_99.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_99.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get Shipping methods
export var getShippingMethods = createAsyncThunk('auth/getShippingMethods', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setShipmentMethodListing = _a.setShipmentMethodListing;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_100;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/shippingOptions?getRates=true", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('getShippingMethods', response.data);
                    if (response.status === 200) {
                        console.log('response>>>>>>>>>>>>>>>', response === null || response === void 0 ? void 0 : response.data);
                        setShipmentMethodListing((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.shippingOptions);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_100 = _c.sent();
                    console.error('Error', e_100.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_100.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get Shipment Item Asset List
export var getShipmentItemAssetsList = createAsyncThunk('auth/getShipmentItemAssetsList', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setItemAssets = _a.setItemAssets;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_101;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/itemAsset", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    console.log('Shipment Item Asset List', response.data);
                    if (response.status === 200) {
                        setItemAssets((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.shipmentItemAssetList);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_101 = _c.sent();
                    console.log('Error', e_101.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_101.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get active user preference
export var getActiveUserPreference = createAsyncThunk('auth/getActiveUserPreference', function (_a, thunkAPI) {
    var setUserPreferenceList = _a.setUserPreferenceList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, userPreferenceList_1, e_102;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/user/" + localStorage.getItem('userId') + "/preference", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })
                        // console.log('Active User Preference Data', response.data)
                    ];
                case 1:
                    response = _d.sent();
                    // console.log('Active User Preference Data', response.data)
                    if (response.status === 200) {
                        userPreferenceList_1 = {};
                        (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.userPreferenceList) === null || _c === void 0 ? void 0 : _c.forEach(function (u) {
                            var _a;
                            var _b;
                            if ((_b = ['qz.print.enabled', 'qz.printer.label.active', 'qz.printer.main.active']) === null || _b === void 0 ? void 0 : _b.includes(u === null || u === void 0 ? void 0 : u.preferenceKey)) {
                                userPreferenceList_1 = __assign(__assign({}, userPreferenceList_1), (_a = {}, _a[u === null || u === void 0 ? void 0 : u.preferenceKey] = u === null || u === void 0 ? void 0 : u.preferenceValue, _a));
                            }
                        });
                        setUserPreferenceList(userPreferenceList_1);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_102 = _d.sent();
                    console.error('Error', e_102.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_102.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get active user preference
export var setActiveUserPreference = createAsyncThunk('auth/setActiveUserPreference', function (_a, thunkAPI) {
    var data = _a.data, getActiveUserPreference = _a.getActiveUserPreference, setUserPreferenceList = _a.setUserPreferenceList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_103;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/user/" + localStorage.getItem('userId') + "/preference", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })
                        // console.log('Active User Preference Data', response.data)
                    ];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, thunkAPI.dispatch(getActiveUserPreference({ setUserPreferenceList: setUserPreferenceList }))];
                case 2:
                    _b.sent();
                    return [2 /*return*/, response.data];
                case 3: return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_103 = _b.sent();
                    console.error('Error', e_103.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_103.response.data)];
                case 6: return [2 /*return*/];
            }
        });
    });
});
// Showing printer List
export var getPrinterList = createAsyncThunk('auth/getPrinterList', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var token, facilityPartyId, response, mappedArray, e_104;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                token = localStorage.getItem('moquiSessionToken');
                facilityPartyId = localStorage.getItem('facilityId');
                return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityPartyId + "/printer", {
                        headers: {
                            moquiSessionToken: token
                        }
                    })];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    console.log('printer response', response);
                    mappedArray = response.data.printerList
                        .filter(function (item) { return item.statusId === 'PsActive'; })
                        .map(function (item) {
                        return {
                            key: item.networkPrinterId,
                            value: item.printerName,
                            port: item === null || item === void 0 ? void 0 : item.serverPort,
                            host: item === null || item === void 0 ? void 0 : item.ipAddress
                        };
                    });
                    return [2 /*return*/, mappedArray];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                }
                return [3 /*break*/, 3];
            case 2:
                e_104 = _a.sent();
                console.log('Error', e_104.response.data);
                return [2 /*return*/, thunkAPI.rejectWithValue(e_104.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); });
// Set Default Printer Name
export var setdefaultNetworkPrinterName = createAsyncThunk('auth/getDefaultPrinterList', function (_a, thunkAPI) {
    var networkPrinterID = _a.networkPrinterID, hostname = _a.hostname;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, userId, response, mappedArray, e_105;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    userId = localStorage.getItem('userId');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/user/" + userId + "/printer", {
                            networkPrinterId: networkPrinterID,
                            hostname: hostname
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        mappedArray = response.data.getdefaultNetworkPrinterDetail.map(function (item) {
                            return {
                                key: item.networkPrinterId,
                                value: item.printerName
                            };
                        });
                        return [2 /*return*/, mappedArray];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_105 = _b.sent();
                    console.log('Error', e_105.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_105.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//Default Printer List
export var getdefaultNetworkPrinterDetail = createAsyncThunk('auth/getDefaultPrinterList', function (_a, thunkAPI) {
    var setPrinter = _a.setPrinter, setServerHost = _a.setServerHost, setServerPort = _a.setServerPort, setCurrPrinterName = _a.setCurrPrinterName;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, userId, response, host, port, name, printer, e_106;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    userId = localStorage.getItem('userId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/user/" + userId + "/printer", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _k.sent();
                    if (response.status === 200) {
                        host = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.defaultNetworkPrinterDetail) === null || _c === void 0 ? void 0 : _c.ipAddress;
                        port = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.defaultNetworkPrinterDetail) === null || _e === void 0 ? void 0 : _e.serverPort;
                        name = (_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.defaultNetworkPrinterDetail) === null || _g === void 0 ? void 0 : _g.printerName;
                        printer = (_j = (_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.defaultNetworkPrinterDetail) === null || _j === void 0 ? void 0 : _j.networkPrinterId;
                        setPrinter(printer);
                        setServerHost(host);
                        setServerPort(port);
                        setCurrPrinterName(name);
                        return [2 /*return*/, printer];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_106 = _k.sent();
                    console.log('Error', e_106.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_106.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// add product SKU/UPC
export var addProductIdentification = createAsyncThunk('auth/addProductIdentification', function (_a, thunkAPI) {
    var data = _a.data, productId = _a.productId, scanProductData = _a.scanProductData, setScanProductData = _a.setScanProductData, setIsShowModel = _a.setIsShowModel, resetHandler = _a.resetHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, newData, e_107;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/product/" + productId + "/productIdentification", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        newData = scanProductData;
                        if (data.productIdTypeEnumId === 'PidtSku') {
                            newData.associatedProductDetail.productSku = data.idValue;
                        }
                        else if (data.productIdTypeEnumId === 'PidtUpca') {
                            newData.associatedProductDetail.productUpc = data.idValue;
                        }
                        setScanProductData(newData);
                        setIsShowModel(false);
                        resetHandler();
                        notification['success']({
                            message: 'Success',
                            description: (data.productIdTypeEnumId === 'PidtSku' ? 'SKU' : 'UPC') + " Added successfully!"
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_107 = _b.sent();
                    console.error('Error', e_107.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_107.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Add/Update product image REST API
export var uploadProductImage = createAsyncThunk('auth/uploadProductImage', function (_a, thunkAPI) {
    var data = _a.data, productId = _a.productId, onUpdateImageHandler = _a.onUpdateImageHandler, type = _a.type;
    return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, e_108;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/product/" + productId + "/image", data, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                moquiSessionToken: moquiSessionToken,
                                'content-type': 'multipart/form-data'
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('Produt Image data', response);
                    if (response.status === 200) {
                        onUpdateImageHandler(productId);
                        if (notification) {
                            notification['success']({
                                message: 'Success',
                                description: "Product Image " + (type === 'edit' ? 'updated' : 'added') + " successfully!"
                            });
                        }
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_108 = _b.sent();
                    console.log('Error', e_108.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_108.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// update product SKU/UPC
export var updateProductIdentification = createAsyncThunk('auth/addProductIdentification', function (_a, thunkAPI) {
    var data = _a.data, productId = _a.productId, scanProductData = _a.scanProductData, setScanProductData = _a.setScanProductData, setIsShowModel = _a.setIsShowModel, resetHandler = _a.resetHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, newData, e_109;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/product/" + productId + "/productIdentification", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })
                        // console.log('Active User Preference Data', response.data)
                    ];
                case 1:
                    response = _b.sent();
                    // console.log('Active User Preference Data', response.data)
                    if (response.status === 200) {
                        newData = scanProductData;
                        if (data.productIdTypeEnumId === 'PidtSku') {
                            newData.associatedProductDetail.productSku = data.idValue;
                        }
                        else if (data.productIdTypeEnumId === 'PidtUpca') {
                            newData.associatedProductDetail.productUpc = data.idValue;
                        }
                        setScanProductData(newData);
                        setIsShowModel(false);
                        resetHandler();
                        notification['success']({
                            message: 'Success',
                            description: (data.productIdTypeEnumId === 'PidtSku' ? 'SKU' : 'UPC') + " Updated successfully!"
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_109 = _b.sent();
                    console.error('Error', e_109.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_109.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get carton Label
export var getRefundLabel = createAsyncThunk('auth/getRefundLabel', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, carrierPartyId = _a.carrierPartyId, shipmentPackageSeqId = _a.shipmentPackageSeqId, getShipmentDetail = _a.getShipmentDetail, shippingGatewayConfigId = _a.shippingGatewayConfigId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_110;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/refundLabel?shipmentId=" + shipmentId + "&carrierPartyId=" + carrierPartyId + "&shipmentPackageSeqId=" + shipmentPackageSeqId + "&shippingGatewayConfigId=" + shippingGatewayConfigId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('Refund Label', response === null || response === void 0 ? void 0 : response.data);
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: 'Refund Successful'
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_110 = _b.sent();
                    console.log('Error', e_110.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_110.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get carton Label
export var RefundAllLabel = createAsyncThunk('auth/RefundAllLabel', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_111;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/refundAllLabels", {
                            shipmentId: shipmentId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: 'All labels refund successfully.'
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_111 = _b.sent();
                    console.log('Error', e_111.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_111.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//get carton Label
export var ResetAllLabels = createAsyncThunk('auth/ResetAllLabels', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, getShipmentDetail = _a.getShipmentDetail;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_112;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/pack/shipment/" + shipmentId + "/resetAllLables", {
                            shipmentId: shipmentId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        notification['success']({
                            message: 'Success',
                            description: 'All labels reset successfully.'
                        });
                        getShipmentDetail(shipmentId);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_112 = _b.sent();
                    console.log('Error', e_112.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_112.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Update/Add Tracking/Rma No.
export var updateTrackingNumber = createAsyncThunk('auth/updateTrackingNumber', function (_a, thunkAPI) {
    var data = _a.data, returnId = _a.returnId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_113;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/return/" + returnId + "/tracking", data, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        if (notification) {
                            notification['success']({
                                message: 'Success',
                                description: "Updated successfully!"
                            });
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_113 = _b.sent();
                    console.error('Error', e_113.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_113.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get Tracking/Rma No.
export var getTrackingNumber = createAsyncThunk('auth/getTrackingNumber', function (_a, thunkAPI) {
    var setReturnTrackingData = _a.setReturnTrackingData, returnId = _a.returnId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_114;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/return/" + returnId + "/tracking", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _d.sent();
                    if (response.status === 200) {
                        console.log(response.data);
                        setReturnTrackingData({
                            trackingNumber: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.trackingNumber,
                            rmaNumber: (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.rmaNumber
                        });
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_114 = _d.sent();
                    console.error('Error', e_114.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_114.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var CloseBulkPackage = createAsyncThunk('auth/CloseBulkPackage', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, selectBoxType = _a.selectBoxType, packageWeight = _a.packageWeight, weightUomId = _a.weightUomId, getShipmentDetail = _a.getShipmentDetail, updateActivePackageSeqId = _a.updateActivePackageSeqId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_115;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/bulkPackage", {
                            shipmentBoxTypeId: selectBoxType,
                            weight: packageWeight,
                            weightUomId: weightUomId
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        console.log('response?.data****', response === null || response === void 0 ? void 0 : response.data);
                        getShipmentDetail(shipmentId);
                        notification['success']({
                            message: 'Success',
                            description: "Bulk package closed Successfully."
                        });
                        updateActivePackageSeqId();
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_115 = _b.sent();
                    console.log('Error', e_115.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_115.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// API to getReservedLocations
export var getReservedLocations = createAsyncThunk('auth/getReservedLocations', function (_a, thunkAPI) {
    var _b = _a.isDefective, isDefective = _b === void 0 ? false : _b, shipmentId = _a.shipmentId, productId = _a.productId, orderId = _a.orderId, setReservedLocations = _a.setReservedLocations, setLotList = _a.setLotList, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, facilityId, response, mappedArray, e_116;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    facilityId = localStorage.getItem('facilityId');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/shipment/" + shipmentId + "/receive?facilityId=" + facilityId + "&productId=" + productId + "&orderId=" + orderId + "&isDefective=" + isDefective, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    if (response.status === 200) {
                        mappedArray = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.productLocationList) === null || _d === void 0 ? void 0 : _d.reduce(function (acc, item) {
                            var uniqueKeys = new Set(acc.map(function (obj) { return obj.key; }));
                            if (!uniqueKeys.has(item === null || item === void 0 ? void 0 : item.locationSeqId)) {
                                acc.push({
                                    key: item === null || item === void 0 ? void 0 : item.locationSeqId,
                                    value: item === null || item === void 0 ? void 0 : item.description
                                });
                            }
                            return acc;
                        }, []);
                        setReservedLocations(mappedArray);
                        setLotList((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.lotList);
                        setCurrentActiveSubscreen('receive');
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_116 = _f.sent();
                    console.log('Error', e_116.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_116.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getFacilityList = createAsyncThunk('auth/getFacilityList', function (_a, thunkAPI) {
    var setFacilityList = _a.setFacilityList;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, mappedArray_1, e_117;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        mappedArray_1 = [];
                        (_b = response.data.facilityList) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
                            mappedArray_1.push({
                                key: item.facilityId,
                                value: "" + ((item === null || item === void 0 ? void 0 : item.facilityName) || "")
                            });
                        });
                        setFacilityList(mappedArray_1);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_117 = _c.sent();
                    console.log('Error', e_117.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_117.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
/**
 * Endpoint: /rest/s1/handheld/pack/containerShipments?containerId=${containerId}&pageSize=10&pageIndex=${pageIndex}
 * Calls handheld.shipment.ShipmentServices.get#ContainerShipments -- As of Feb 1 2026 (subject to change, always verify)
 */
export var getShipmentList = createAsyncThunk('auth/getShipmentList', function (_a, thunkAPI) {
    var containerId = _a.containerId, setShipmentList = _a.setShipmentList, setCurrentActiveSubscreen = _a.setCurrentActiveSubscreen, subscreenName = _a.subscreenName, setMaxPageIndex = _a.setMaxPageIndex, setRecordCount = _a.setRecordCount, pageIndex = _a.pageIndex;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_118;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/containerShipments?containerId=" + containerId + "&pageSize=10&pageIndex=" + pageIndex, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _f.sent();
                    if (response.status === 200 && ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.shipmentsList.length) > 0) {
                        console.log('response?.data****', response === null || response === void 0 ? void 0 : response.data);
                        setMaxPageIndex(((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.shipmentsListPageMaxIndex) + 1);
                        setShipmentList((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.shipmentsList);
                        setCurrentActiveSubscreen(subscreenName);
                        setRecordCount((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.shipmentsListCount);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        notification['error']({
                            message: 'Error',
                            description: 'No record found'
                        });
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_118 = _f.sent();
                    console.log('Error', e_118.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_118.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getAttachmentList = createAsyncThunk('auth/getAttachmentList', function (_a, thunkAPI) {
    var setAttachmentList = _a.setAttachmentList, orderId = _a.orderId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_119;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/attachments?orderId=" + orderId, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        console.log('response?.data****', response === null || response === void 0 ? void 0 : response.data);
                        setAttachmentList((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.contentList);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_119 = _c.sent();
                    console.log('Error', e_119.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_119.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Set PrefferedLanguage.
export var setPrefferedLanguage = createAsyncThunk('auth/setPrefferedLanguage', function (_a, thunkAPI) {
    var userId = _a.userId, preferenceLanguage = _a.preferenceLanguage;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_120;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.post("/rest/s1/handheld/user/" + userId + "/language", {
                            preferenceValue: preferenceLanguage
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('response', response);
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_120 = _b.sent();
                    console.error('Error', e_120.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_120.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// getFreightPalletPackageInfoList
export var getFreightPalletPackageInfoList = createAsyncThunk('auth/getFreightPalletPackageInfoList', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setFreightPalletInfo = _a.setFreightPalletInfo, setActivePalletData = _a.setActivePalletData;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, activePalletData, e_121;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/freightPallet", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _e.sent();
                    console.log("response", response);
                    if (response.status === 200) {
                        console.log("response?.data", response === null || response === void 0 ? void 0 : response.data);
                        activePalletData = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.FreightPalletPackageData) === null || _c === void 0 ? void 0 : _c.find(function (item) { return !(item === null || item === void 0 ? void 0 : item.containerWeight); });
                        setActivePalletData(activePalletData);
                        setFreightPalletInfo((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.FreightPalletPackageData);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_121 = _e.sent();
                    console.error('Error', e_121.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_121.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// unpackPallet
export var unpackPallet = createAsyncThunk('auth/unpackPallet', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, containerSerialNumber = _a.containerSerialNumber, getFreightPalletInfo = _a.getFreightPalletInfo;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_122;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.put("/rest/s1/handheld/pack/shipment/" + shipmentId + "/package/freightPallet/" + shipmentId, {
                            containerSerialNumber: containerSerialNumber
                        }, {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        getFreightPalletInfo(shipmentId);
                        return [2 /*return*/, response];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_122 = _b.sent();
                    console.error('Error', e_122.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_122.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Packing screen (get shipMethodLock)
export var getShipMethodLock = createAsyncThunk('auth/getShipMethodLock', function (_a, thunkAPI) {
    var shipmentId = _a.shipmentId, setShipMethodLock = _a.setShipMethodLock;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_123;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/shipment/" + shipmentId + "/shipMethodLock", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('ShipMethodLock', response === null || response === void 0 ? void 0 : response.data);
                    if (response.status === 200) {
                        // notification['success']({
                        //   message: 'Success',
                        //   description: 'Refund Successful'
                        // })
                        setShipMethodLock(response === null || response === void 0 ? void 0 : response.data);
                        return [2 /*return*/, response.data];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_123 = _b.sent();
                    console.log('Error', e_123.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_123.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Get PrefferedLanguage.
export var getPrefferedLanguage = createAsyncThunk('auth/getPrefferedLanguage', function (_a, thunkAPI) {
    var userId = _a.userId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, response, e_124;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    token = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/user/" + userId + "/language", {
                            headers: {
                                moquiSessionToken: token
                            }
                        })];
                case 1:
                    response = _b.sent();
                    console.log('response', response);
                    if (response.status === 200) {
                        console.log('response?.data', response === null || response === void 0 ? void 0 : response.data);
                        return [2 /*return*/, response.data.userPreferenceData];
                    }
                    else {
                        return [2 /*return*/, thunkAPI.rejectWithValue(response)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_124 = _b.sent();
                    console.error('Error', e_124.response.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue(e_124.response.data)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Define the initial state using that type
var initialState = {
    allowPieceReceiving: '',
    isFetching: false,
    isSuccess: false,
    isResetPassword: false,
    userId: '',
    preferenceValue: '',
    sidebarOptionsVisibility: {},
    singlePickBtnDisabled: true,
    multiPickBtnDisabled: true,
    moveToSortingBtnDisabled: true,
    sortingBtnDisabled: true,
    productDetailIncorrect: true,
    isSidebarOpen: localStorage.getItem('isNavOpen') === 'true' ? true : false,
    currentOrg: '',
    activeFacility: '',
    activeOrgToggled: false,
    organizationsList: [],
    printerList: [],
    defaultPrinterList: []
};
export var authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        clearState: function (state) {
            state.isSuccess = false;
            state.isFetching = false;
            return state;
        },
        toggleSidebar: function (state) {
            state.isSidebarOpen = !state.isSidebarOpen;
            return state;
        },
        setSidebarOpen: function (state, action) {
            state.isSidebarOpen = action.payload;
            localStorage.setItem('isNavOpen', action.payload);
            return state;
        },
        setSinglePickBtnDisabled: function (state, action) {
            state.singlePickBtnDisabled = action.payload;
            return state;
        },
        setMultiPickBtnDisabled: function (state, action) {
            state.multiPickBtnDisabled = action.payload;
            return state;
        },
        setMoveToSortingBtnDisabled: function (state, action) {
            state.moveToSortingBtnDisabled = action.payload;
            return state;
        },
        setSortingBtnDisabled: function (state, action) {
            state.sortingBtnDisabled = action.payload;
            return state;
        },
        toggleSidebarOptionsVisibility: function (state, action) {
            state.sidebarOptionsVisibility = action.payload;
            return state;
        },
        setProductDetailIncorrect: function (state, action) {
            state.productDetailIncorrect = action.payload;
            return state;
        }
    },
    extraReducers: function (builder) {
        builder.addCase(loginUser.fulfilled, function (state, _a) {
            var payload = _a.payload;
            if (payload.forcePasswordChange) {
                state.isFetching = false;
                state.isResetPassword = true;
                return state;
            }
            else {
                state.isFetching = false;
                state.isSuccess = true;
            }
            state.userId = payload;
        });
        builder.addCase(loginUser.rejected, function (state, _a) {
            var payload = _a.payload;
            state.isFetching = false;
        });
        builder.addCase(loginUser.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getSessionToken.fulfilled, function (state) {
            state.isFetching = false;
        });
        builder.addCase(getSessionToken.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getSessionToken.rejected, function (state) {
            state.isFetching = false;
        });
        builder.addCase(getPrefferedLanguage.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isFetching = false;
            if (payload === null || payload === void 0 ? void 0 : payload.preferenceValue) {
                state.preferenceValue = payload.preferenceValue;
            }
            else {
                state.preferenceValue = payload;
            }
        });
        builder.addCase(getPrefferedLanguage.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getPrefferedLanguage.rejected, function (state) {
            state.isFetching = false;
        });
        builder.addCase(logout.fulfilled, function (state) {
            state.isFetching = false;
            state.isSuccess = true;
            state.userId = '';
            state.preferenceValue = '';
        });
        builder.addCase(logout.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(logout.rejected, function (state) {
            state.isFetching = false;
            state.isSuccess = false;
        });
        builder.addCase(getUserAssociatedOrganization.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.organizationsList = payload;
        });
        builder.addCase(getActiveOrg.fulfilled, function (state, _a) {
            var _b;
            var payload = _a.payload;
            state.isFetching = false;
            state.activeOrgToggled = !state.activeOrgToggled;
            state.currentOrg = (_b = payload === null || payload === void 0 ? void 0 : payload.organization) === null || _b === void 0 ? void 0 : _b.partyId;
            state.allowPieceReceiving = payload === null || payload === void 0 ? void 0 : payload.allowPieceReceiving;
        });
        builder.addCase(getActiveOrg.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getActiveOrg.rejected, function (state) {
            state.isFetching = false;
        });
        builder.addCase(getActiveFacility.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isFetching = false;
            state.activeFacility = payload;
        });
        builder.addCase(getActiveFacility.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getActiveFacility.rejected, function (state) {
            state.isFetching = false;
        });
        builder.addCase(changeActiveOrg.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isFetching = false;
            state.activeOrgToggled = !state.activeOrgToggled;
            state.currentOrg = payload;
        });
        builder.addCase(changeActiveOrg.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(changeActiveOrg.rejected, function (state) {
            state.isFetching = false;
        });
        builder.addCase(getPrinterList.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isFetching = false;
            state.printerList = payload;
        });
        builder.addCase(getPrinterList.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getPrinterList.rejected, function (state) {
            state.isFetching = false;
            state.printerList = [];
        });
        builder.addCase(getdefaultNetworkPrinterDetail.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isFetching = false;
            state.defaultPrinterList = payload;
        });
        builder.addCase(getdefaultNetworkPrinterDetail.pending, function (state) {
            state.isFetching = true;
        });
        builder.addCase(getdefaultNetworkPrinterDetail.rejected, function (state) {
            state.isFetching = false;
            state.defaultPrinterList = [];
        });
    }
});
// Action creators are generated for each case reducer function
export var clearState = (_a = authSlice.actions, _a.clearState), toggleSidebarOptionsVisibility = _a.toggleSidebarOptionsVisibility, setSinglePickBtnDisabled = _a.setSinglePickBtnDisabled, setMultiPickBtnDisabled = _a.setMultiPickBtnDisabled, setMoveToSortingBtnDisabled = _a.setMoveToSortingBtnDisabled, setSortingBtnDisabled = _a.setSortingBtnDisabled, setProductDetailIncorrect = _a.setProductDetailIncorrect, toggleSidebar = _a.toggleSidebar, setSidebarOpen = _a.setSidebarOpen;
export var userSelector = function (state) { return state.auth; };
export default authSlice.reducer;
